import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import clsx from 'clsx';
import '../__generated__/styles/icons.css';
import _extends from '@babel/runtime/helpers/esm/extends';

var styles = {"ppvxIconFont":"ppvxIconFont___6-7-17-beta-0","ppvx_icon":"ppvx_icon___6-7-17-beta-0","ppvx_icon--size_xs":"ppvx_icon--size_xs___6-7-17-beta-0","ppvx_icon--size_sm":"ppvx_icon--size_sm___6-7-17-beta-0","ppvx_icon--size_md":"ppvx_icon--size_md___6-7-17-beta-0","ppvx_icon--size_lg":"ppvx_icon--size_lg___6-7-17-beta-0","ppvx_icon--size_xl":"ppvx_icon--size_xl___6-7-17-beta-0","ppvx_icon--size_xl2":"ppvx_icon--size_xl2___6-7-17-beta-0","ppvx_icon--svg":"ppvx_icon--svg___6-7-17-beta-0","ppvx_icon-pix":"ppvx_icon-pix___6-7-17-beta-0","ppvx_icon-izettle-pos":"ppvx_icon-izettle-pos___6-7-17-beta-0","ppvx_icon-pay-online":"ppvx_icon-pay-online___6-7-17-beta-0","ppvx_icon-shipping-send":"ppvx_icon-shipping-send___6-7-17-beta-0","ppvx_icon-shipping-pack":"ppvx_icon-shipping-pack___6-7-17-beta-0","ppvx_icon-shipping-label":"ppvx_icon-shipping-label___6-7-17-beta-0","ppvx_icon-emoji":"ppvx_icon-emoji___6-7-17-beta-0","ppvx_icon-honey":"ppvx_icon-honey___6-7-17-beta-0","ppvx_icon-chevron-up-alt":"ppvx_icon-chevron-up-alt___6-7-17-beta-0","ppvx_icon-chevron-down-alt":"ppvx_icon-chevron-down-alt___6-7-17-beta-0","ppvx_icon-loyalty-card":"ppvx_icon-loyalty-card___6-7-17-beta-0","ppvx_icon-logout":"ppvx_icon-logout___6-7-17-beta-0","ppvx_icon-barcode-scan":"ppvx_icon-barcode-scan___6-7-17-beta-0","ppvx_icon-block":"ppvx_icon-block___6-7-17-beta-0","ppvx_icon-tip-jar":"ppvx_icon-tip-jar___6-7-17-beta-0","ppvx_icon-theme":"ppvx_icon-theme___6-7-17-beta-0","ppvx_icon-help-center":"ppvx_icon-help-center___6-7-17-beta-0","ppvx_icon-duplicate":"ppvx_icon-duplicate___6-7-17-beta-0","ppvx_icon-close-alt":"ppvx_icon-close-alt___6-7-17-beta-0","ppvx_icon-crypto":"ppvx_icon-crypto___6-7-17-beta-0","ppvx_icon-security-code":"ppvx_icon-security-code___6-7-17-beta-0","ppvx_icon-share-link":"ppvx_icon-share-link___6-7-17-beta-0","ppvx_icon-share-email":"ppvx_icon-share-email___6-7-17-beta-0","ppvx_icon-share-facebook":"ppvx_icon-share-facebook___6-7-17-beta-0","ppvx_icon-share-instagram":"ppvx_icon-share-instagram___6-7-17-beta-0","ppvx_icon-share-line":"ppvx_icon-share-line___6-7-17-beta-0","ppvx_icon-share-linkedin":"ppvx_icon-share-linkedin___6-7-17-beta-0","ppvx_icon-share-messenger":"ppvx_icon-share-messenger___6-7-17-beta-0","ppvx_icon-share-mobile":"ppvx_icon-share-mobile___6-7-17-beta-0","ppvx_icon-share-snapchat":"ppvx_icon-share-snapchat___6-7-17-beta-0","ppvx_icon-share-twitter":"ppvx_icon-share-twitter___6-7-17-beta-0","ppvx_icon-share-wechat":"ppvx_icon-share-wechat___6-7-17-beta-0","ppvx_icon-share-whatsapp":"ppvx_icon-share-whatsapp___6-7-17-beta-0","ppvx_icon-message-center":"ppvx_icon-message-center___6-7-17-beta-0","ppvx_icon-direct-deposit":"ppvx_icon-direct-deposit___6-7-17-beta-0","ppvx_icon-arrow-up":"ppvx_icon-arrow-up___6-7-17-beta-0","ppvx_icon-verified-alt":"ppvx_icon-verified-alt___6-7-17-beta-0","ppvx_icon-working-capital":"ppvx_icon-working-capital___6-7-17-beta-0","ppvx_icon-code":"ppvx_icon-code___6-7-17-beta-0","ppvx_icon-tools":"ppvx_icon-tools___6-7-17-beta-0","ppvx_icon-preferred-selected":"ppvx_icon-preferred-selected___6-7-17-beta-0","ppvx_icon-preferred":"ppvx_icon-preferred___6-7-17-beta-0","ppvx_icon-external":"ppvx_icon-external___6-7-17-beta-0","ppvx_icon-purchase-protection-alt":"ppvx_icon-purchase-protection-alt___6-7-17-beta-0","ppvx_icon-favorite-selected":"ppvx_icon-favorite-selected___6-7-17-beta-0","ppvx_icon-favorite":"ppvx_icon-favorite___6-7-17-beta-0","ppvx_icon-resolution":"ppvx_icon-resolution___6-7-17-beta-0","ppvx_icon-disaster-relief":"ppvx_icon-disaster-relief___6-7-17-beta-0","ppvx_icon-add-payment-method":"ppvx_icon-add-payment-method___6-7-17-beta-0","ppvx_icon-arrow-down":"ppvx_icon-arrow-down___6-7-17-beta-0","ppvx_icon-credit-debit-cards":"ppvx_icon-credit-debit-cards___6-7-17-beta-0","ppvx_icon-activity":"ppvx_icon-activity___6-7-17-beta-0","ppvx_icon-refund":"ppvx_icon-refund___6-7-17-beta-0","ppvx_icon-auto-top-up":"ppvx_icon-auto-top-up___6-7-17-beta-0","ppvx_icon-world":"ppvx_icon-world___6-7-17-beta-0","ppvx_icon-money-delivery":"ppvx_icon-money-delivery___6-7-17-beta-0","ppvx_icon-face-id":"ppvx_icon-face-id___6-7-17-beta-0","ppvx_icon-special-financing":"ppvx_icon-special-financing___6-7-17-beta-0","ppvx_icon-achievement":"ppvx_icon-achievement___6-7-17-beta-0","ppvx_icon-add-image":"ppvx_icon-add-image___6-7-17-beta-0","ppvx_icon-copy-to-clipboard":"ppvx_icon-copy-to-clipboard___6-7-17-beta-0","ppvx_icon-decline":"ppvx_icon-decline___6-7-17-beta-0","ppvx_icon-location":"ppvx_icon-location___6-7-17-beta-0","ppvx_icon-number-pad":"ppvx_icon-number-pad___6-7-17-beta-0","ppvx_icon-share":"ppvx_icon-share___6-7-17-beta-0","ppvx_icon-split-bill":"ppvx_icon-split-bill___6-7-17-beta-0","ppvx_icon-overflow":"ppvx_icon-overflow___6-7-17-beta-0","ppvx_icon-calculator":"ppvx_icon-calculator___6-7-17-beta-0","ppvx_icon-subtract":"ppvx_icon-subtract___6-7-17-beta-0","ppvx_icon-sort-ascending-alt":"ppvx_icon-sort-ascending-alt___6-7-17-beta-0","ppvx_icon-sort-descending-alt":"ppvx_icon-sort-descending-alt___6-7-17-beta-0","ppvx_icon-microphone":"ppvx_icon-microphone___6-7-17-beta-0","ppvx_icon-attach":"ppvx_icon-attach___6-7-17-beta-0","ppvx_icon-light-bulb":"ppvx_icon-light-bulb___6-7-17-beta-0","ppvx_icon-download":"ppvx_icon-download___6-7-17-beta-0","ppvx_icon-upload":"ppvx_icon-upload___6-7-17-beta-0","ppvx_icon-fingerprint":"ppvx_icon-fingerprint___6-7-17-beta-0","ppvx_icon-rocket":"ppvx_icon-rocket___6-7-17-beta-0","ppvx_icon-clear-alt":"ppvx_icon-clear-alt___6-7-17-beta-0","ppvx_icon-cash":"ppvx_icon-cash___6-7-17-beta-0","ppvx_icon-contact-info":"ppvx_icon-contact-info___6-7-17-beta-0","ppvx_icon-home":"ppvx_icon-home___6-7-17-beta-0","ppvx_icon-insights":"ppvx_icon-insights___6-7-17-beta-0","ppvx_icon-invoice":"ppvx_icon-invoice___6-7-17-beta-0","ppvx_icon-shipping":"ppvx_icon-shipping___6-7-17-beta-0","ppvx_icon-transfer":"ppvx_icon-transfer___6-7-17-beta-0","ppvx_icon-withdraw-cash":"ppvx_icon-withdraw-cash___6-7-17-beta-0","ppvx_icon-add-cash":"ppvx_icon-add-cash___6-7-17-beta-0","ppvx_icon-pp-cash-card":"ppvx_icon-pp-cash-card___6-7-17-beta-0","ppvx_icon-gift":"ppvx_icon-gift___6-7-17-beta-0","ppvx_icon-lock":"ppvx_icon-lock___6-7-17-beta-0","ppvx_icon-money-pools":"ppvx_icon-money-pools___6-7-17-beta-0","ppvx_icon-photo":"ppvx_icon-photo___6-7-17-beta-0","ppvx_icon-print":"ppvx_icon-print___6-7-17-beta-0","ppvx_icon-trash":"ppvx_icon-trash___6-7-17-beta-0","ppvx_icon-scan-to-send":"ppvx_icon-scan-to-send___6-7-17-beta-0","ppvx_icon-acorns":"ppvx_icon-acorns___6-7-17-beta-0","ppvx_icon-cash-check":"ppvx_icon-cash-check___6-7-17-beta-0","ppvx_icon-donate":"ppvx_icon-donate___6-7-17-beta-0","ppvx_icon-goals":"ppvx_icon-goals___6-7-17-beta-0","ppvx_icon-offers-rewards":"ppvx_icon-offers-rewards___6-7-17-beta-0","ppvx_icon-order-ahead":"ppvx_icon-order-ahead___6-7-17-beta-0","ppvx_icon-request":"ppvx_icon-request___6-7-17-beta-0","ppvx_icon-send":"ppvx_icon-send___6-7-17-beta-0","ppvx_icon-transfer-money":"ppvx_icon-transfer-money___6-7-17-beta-0","ppvx_icon-add":"ppvx_icon-add___6-7-17-beta-0","ppvx_icon-arrow-left":"ppvx_icon-arrow-left___6-7-17-beta-0","ppvx_icon-arrow-right":"ppvx_icon-arrow-right___6-7-17-beta-0","ppvx_icon-warning":"ppvx_icon-warning___6-7-17-beta-0","ppvx_icon-bank":"ppvx_icon-bank___6-7-17-beta-0","ppvx_icon-browser":"ppvx_icon-browser___6-7-17-beta-0","ppvx_icon-calendar-paused":"ppvx_icon-calendar-paused___6-7-17-beta-0","ppvx_icon-calendar":"ppvx_icon-calendar___6-7-17-beta-0","ppvx_icon-camera-add":"ppvx_icon-camera-add___6-7-17-beta-0","ppvx_icon-camera":"ppvx_icon-camera___6-7-17-beta-0","ppvx_icon-card":"ppvx_icon-card___6-7-17-beta-0","ppvx_icon-cart":"ppvx_icon-cart___6-7-17-beta-0","ppvx_icon-chat":"ppvx_icon-chat___6-7-17-beta-0","ppvx_icon-check-alt":"ppvx_icon-check-alt___6-7-17-beta-0","ppvx_icon-check-circle-alt":"ppvx_icon-check-circle-alt___6-7-17-beta-0","ppvx_icon-check-circle":"ppvx_icon-check-circle___6-7-17-beta-0","ppvx_icon-check":"ppvx_icon-check___6-7-17-beta-0","ppvx_icon-chevron-circle-down":"ppvx_icon-chevron-circle-down___6-7-17-beta-0","ppvx_icon-chevron-circle-up":"ppvx_icon-chevron-circle-up___6-7-17-beta-0","ppvx_icon-chevron-down":"ppvx_icon-chevron-down___6-7-17-beta-0","ppvx_icon-chevron-left":"ppvx_icon-chevron-left___6-7-17-beta-0","ppvx_icon-chevron-right-alt":"ppvx_icon-chevron-right-alt___6-7-17-beta-0","ppvx_icon-chevron-right":"ppvx_icon-chevron-right___6-7-17-beta-0","ppvx_icon-chevron-up":"ppvx_icon-chevron-up___6-7-17-beta-0","ppvx_icon-clear":"ppvx_icon-clear___6-7-17-beta-0","ppvx_icon-close":"ppvx_icon-close___6-7-17-beta-0","ppvx_icon-critical-alt":"ppvx_icon-critical-alt___6-7-17-beta-0","ppvx_icon-desktop":"ppvx_icon-desktop___6-7-17-beta-0","ppvx_icon-edit":"ppvx_icon-edit___6-7-17-beta-0","ppvx_icon-email":"ppvx_icon-email___6-7-17-beta-0","ppvx_icon-error":"ppvx_icon-error___6-7-17-beta-0","ppvx_icon-external-alt":"ppvx_icon-external-alt___6-7-17-beta-0","ppvx_icon-faq":"ppvx_icon-faq___6-7-17-beta-0","ppvx_icon-filter":"ppvx_icon-filter___6-7-17-beta-0","ppvx_icon-heart":"ppvx_icon-heart___6-7-17-beta-0","ppvx_icon-hide-alt":"ppvx_icon-hide-alt___6-7-17-beta-0","ppvx_icon-info-alt":"ppvx_icon-info-alt___6-7-17-beta-0","ppvx_icon-info":"ppvx_icon-info___6-7-17-beta-0","ppvx_icon-laptop":"ppvx_icon-laptop___6-7-17-beta-0","ppvx_icon-link":"ppvx_icon-link___6-7-17-beta-0","ppvx_icon-list-detailed":"ppvx_icon-list-detailed___6-7-17-beta-0","ppvx_icon-list-simple":"ppvx_icon-list-simple___6-7-17-beta-0","ppvx_icon-lock-alt":"ppvx_icon-lock-alt___6-7-17-beta-0","ppvx_icon-logo-paypal":"ppvx_icon-logo-paypal___6-7-17-beta-0","ppvx_icon-menu":"ppvx_icon-menu___6-7-17-beta-0","ppvx_icon-mobile":"ppvx_icon-mobile___6-7-17-beta-0","ppvx_icon-notification":"ppvx_icon-notification___6-7-17-beta-0","ppvx_icon-pending-paused":"ppvx_icon-pending-paused___6-7-17-beta-0","ppvx_icon-pending":"ppvx_icon-pending___6-7-17-beta-0","ppvx_icon-phone":"ppvx_icon-phone___6-7-17-beta-0","ppvx_icon-play-sm":"ppvx_icon-play-sm___6-7-17-beta-0","ppvx_icon-play":"ppvx_icon-play___6-7-17-beta-0","ppvx_icon-question-alt":"ppvx_icon-question-alt___6-7-17-beta-0","ppvx_icon-recurring-paused":"ppvx_icon-recurring-paused___6-7-17-beta-0","ppvx_icon-recurring":"ppvx_icon-recurring___6-7-17-beta-0","ppvx_icon-refresh":"ppvx_icon-refresh___6-7-17-beta-0","ppvx_icon-search":"ppvx_icon-search___6-7-17-beta-0","ppvx_icon-settings":"ppvx_icon-settings___6-7-17-beta-0","ppvx_icon-shield":"ppvx_icon-shield___6-7-17-beta-0","ppvx_icon-show-alt":"ppvx_icon-show-alt___6-7-17-beta-0","ppvx_icon-star-alt":"ppvx_icon-star-alt___6-7-17-beta-0","ppvx_icon-store":"ppvx_icon-store___6-7-17-beta-0","ppvx_icon-support":"ppvx_icon-support___6-7-17-beta-0","ppvx_icon-trash-alt":"ppvx_icon-trash-alt___6-7-17-beta-0","ppvx_icon-unlock-alt":"ppvx_icon-unlock-alt___6-7-17-beta-0","ppvx_icon-user-add":"ppvx_icon-user-add___6-7-17-beta-0","ppvx_icon-user":"ppvx_icon-user___6-7-17-beta-0","ppvx_icon-wallet":"ppvx_icon-wallet___6-7-17-beta-0","ppvx_icon-warning-alt":"ppvx_icon-warning-alt___6-7-17-beta-0"};

var IconContainer = function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["as", "size", "className", "children"]);

  var cls = clsx(styles['ppvx_icon--svg'], styles["ppvx_icon--size_".concat(size)], className);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: cls
  }, rest), children);
};

/* This file is auto-generated using the script ../other/generate-svg-icon-components.js */
var AchievementIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.674 18.035h1.143a.5.5 0 0 1 .423.233l1.24 1.965a.5.5 0 0 1-.424.767H8.001a.5.5 0 0 1-.423-.767l1.24-1.965a.5.5 0 0 1 .422-.233h3.445a.504.504 0 0 1-.006-.075v-1.151c0-.952.34-1.62 1.069-2.362-.053.054 1.257-1.174 1.643-1.62C16.937 11.04 17.796 8.464 17.854 4H6.203c.059 4.464.917 7.04 2.464 8.827.386.446 1.695 1.674 1.642 1.62.73.741 1.069 1.41 1.069 2.362a.5.5 0 1 1-1 0c0-.656-.22-1.09-.78-1.66.084.087-1.26-1.175-1.687-1.667C6.137 11.433 5.2 8.499 5.2 3.5a.5.5 0 0 1 .5-.5h12.658a.5.5 0 0 1 .5.5c0 5-.938 7.933-2.711 9.982-.427.492-1.772 1.754-1.687 1.667-.56.57-.78 1.004-.78 1.66v1.15c0 .026-.003.051-.006.076zm6.55-9.222c.24-.812.32-1.67.302-2.436h-.754a.5.5 0 1 1 0-1H21a.5.5 0 0 1 .497.449c.004.04.01.108.015.203.054.94-.02 2.022-.328 3.067-.403 1.365-1.15 2.415-2.32 2.984a.5.5 0 0 1-.437-.899c.885-.431 1.468-1.25 1.797-2.368zM4.285 6.377H3.48a8.16 8.16 0 0 0 .33 2.431c.343 1.12.934 1.941 1.82 2.373a.5.5 0 1 1-.437.899c-1.168-.569-1.922-1.616-2.339-2.98-.325-1.063-.409-2.163-.363-3.1.004-.078.008-.135.011-.168A.5.5 0 0 1 3 5.377h1.285a.5.5 0 0 1 0 1zM15.15 20l-.609-.965H9.516L8.908 20h6.242zm.358-12.972a.5.5 0 1 1 1 0c0 1.599-.611 3.154-1.624 4.609a12.2 12.2 0 0 1-1.1 1.36 8.246 8.246 0 0 1-.513.51.5.5 0 1 1-.663-.748c.085-.075.241-.226.446-.445.344-.368.688-.787 1.01-1.248.905-1.302 1.444-2.673 1.444-4.038z"
  })), props.children);
};
var AcornsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.351 11.5H4.604c-1.228-.093-1.192-6.133 6.064-6.766.08-.007.74-.876.044-2.234 2.342.3 2.73 2.325 2.827 2.335 7.103.7 7.086 6.572 5.812 6.665zm-.364-1.103c.053-.437-.046-1.015-.308-1.582-.726-1.57-2.438-2.709-5.239-2.985-.659-.065-1.315-1.51-1.347-1.55a2.25 2.25 0 0 0-.108-.123c-.109.85-.55 1.513-1.23 1.573-2.864.25-4.628 1.402-5.398 3.02-.278.585-.392 1.187-.348 1.648.003.037.008.07.013.102H18.97c.006-.031.011-.065.016-.103zm-.054.103s1.13 8.376-5.895 9.94c-.343.334-.835 1.06-1.031 1.06-.197 0-.737-.726-1.032-1.06-7.122-1.453-5.894-9.94-5.894-9.94h13.852zm-12.928 1c-.045 1.204.084 2.525.49 3.763.727 2.217 2.194 3.69 4.68 4.196l.33.067.221.253c.044.05.171.201.27.321a5.07 5.07 0 0 1 .345-.377l.203-.198.277-.062c2.434-.542 3.895-2.01 4.64-4.192.425-1.245.57-2.57.538-3.771H6.005z"
  })), props.children);
};
var ActivityIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6.5-15h8A1.5 1.5 0 0 1 21 5.5v1A1.5 1.5 0 0 1 19.5 8h-8A1.5 1.5 0 0 1 10 6.5v-1A1.5 1.5 0 0 1 11.5 4zm0 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-8zm0 5h8a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5v-1a1.5 1.5 0 0 1 1.5-1.5zm0 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-8zm0 5h8a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5v-1a1.5 1.5 0 0 1 1.5-1.5zm0 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-8z"
  })), props.children);
};
var AddCashIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.371 13.92a.498.498 0 0 1-.198.067c-.636.075-1.17.145-2.27.296-1.226.167-1.717.232-2.373.309-2.386.279-4.231.34-6.07.131A.5.5 0 0 1 2 14.245c-.048-1.182-.054-2.013-.042-3.796.011-1.76.005-2.58-.042-3.74a.5.5 0 0 1 .393-.51c.14-.03.235-.047.434-.08a.5.5 0 0 1 .188.981c.034.973.037 1.804.027 3.356v.003c-.01 1.538-.007 2.358.025 3.312 1.62.146 3.295.077 5.43-.172.647-.076 1.134-.14 2.353-.307.985-.135 1.52-.206 2.08-.273.06-.09.128-.187.204-.287.062-.082.125-.158.186-.226.17-.187.35-.362.536-.523-.563.063-1.196.139-1.962.235-4.623.579-6.012.681-7.656.38a.5.5 0 0 1-.41-.492V4.568a.5.5 0 0 1 .602-.49c1.703.356 2.97.403 5.103.23 1.883-.15 2.942-.238 3.866-.32.443-.04.886-.061 1.346-.067 2.19-.03 4.165.085 5.432.385a.5.5 0 0 1 .386.486v7.225a5.044 5.044 0 1 1-8.43 3.739.5.5 0 1 1 1 0 4.044 4.044 0 1 0 4.16-4.042 33.438 33.438 0 0 0-.58.026c-1 .122-1.922.632-2.652 1.437-.04.046-.085.1-.131.16a4.43 4.43 0 0 0-.264.389.498.498 0 0 1-.212.194zm3.172-3.176a5.022 5.022 0 0 1 2.936.567V5.199c-1.178-.217-2.91-.303-4.804-.278-.435.005-.853.026-1.27.064-.928.082-1.99.169-3.875.32-1.968.16-3.26.138-4.785-.131v6.506c1.363.186 2.864.056 6.942-.455 1.766-.22 2.834-.339 3.98-.425.3-.022.591-.041.876-.056zm1.014 4.42h1.8a.5.5 0 0 1 0 1h-1.791l.016 1.846a.5.5 0 0 1-1 .009l-.016-1.855h-1.8a.5.5 0 0 1 0-1h1.79l-.015-1.845a.5.5 0 0 1 1-.009l.016 1.854zm-5.82-4.917a1.998 1.998 0 1 1 0-3.997 1.998 1.998 0 0 1 0 3.997zm0-1a.998.998 0 1 0 0-1.997.998.998 0 0 0 0 1.997z"
  })), props.children);
};
var AddImageIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5v1a.5.5 0 1 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0v1h1a.5.5 0 1 1 0 1h-1zm.5 3.888l1.411 1.369a.5.5 0 0 1 .152.359v1.814c0 .577-.468 1.045-1.046 1.045H6.654a.502.502 0 0 1-.307 0h-2.27A1.046 1.046 0 0 1 3.03 16.93V7.06c0-.578.47-1.046 1.046-1.046h10.056a4.5 4.5 0 1 1 4.368 7.373zm-1.333.1a4.495 4.495 0 0 1-3.31-1.846l-6.013 5.333h11.173c.026 0 .046-.02.046-.045v-1.603l-1.896-1.84zm-3.813-2.737A4.485 4.485 0 0 1 13 9c0-.713.166-1.386.46-1.985H4.076a.046.046 0 0 0-.046.046v9.869c0 .025.021.045.046.045h2.261l7.017-6.224zm-4.255-.446a1.765 1.765 0 1 1-3.53 0 1.765 1.765 0 0 1 3.53 0zm-1 0a.765.765 0 1 0-1.53-.001.765.765 0 0 0 1.53 0zM21 9a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0z"
  })), props.children);
};
var AddPaymentMethodIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12v2a.5.5 0 1 1-1 0v-2h-2a.5.5 0 1 1 0-1h2V9a.5.5 0 1 1 1 0v2h2a.5.5 0 1 1 0 1h-2zm-9-7h17A1.5 1.5 0 0 1 22 6.5v10a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 16.5v-10A1.5 1.5 0 0 1 3.5 5zm0 1a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-17z"
  })), props.children);
};
var AddIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a.5.5 0 0 1 .5.5v7h7a.5.5 0 0 1 .492.41L20 12a.5.5 0 0 1-.5.5h-7v7a.5.5 0 0 1-.41.492L12 20a.5.5 0 0 1-.5-.5v-7h-7a.5.5 0 0 1-.492-.41L4 12a.5.5 0 0 1 .5-.5h7v-7a.5.5 0 0 1 .41-.492z"
  })), props.children);
};
var ArrowDownIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19.291V3a.5.5 0 1 1 1 0v16.295l6.146-6.149a.5.5 0 0 1 .708.708l-6.998 7a.5.5 0 0 1-.708 0l-7.001-7a.5.5 0 1 1 .706-.707l6.147 6.144z"
  })), props.children);
};
var ArrowLeftIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.353 12.478a.5.5 0 0 1-.351-.52.499.499 0 0 1 .144-.394l7-7.001a.5.5 0 1 1 .707.706L4.625 11.5H20.5a.5.5 0 1 1 0 1H4.79l6.064 6.062a.5.5 0 0 1-.708.708l-6.793-6.792z"
  })), props.children);
};
var ArrowRightIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.791 12.5H3.5a.5.5 0 1 1 0-1h16.295l-6.149-6.146a.5.5 0 1 1 .708-.708l7 6.998a.5.5 0 0 1 0 .708l-7 7.001a.5.5 0 1 1-.707-.706l6.144-6.147z"
  })), props.children);
};
var ArrowUpIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.411 10.216l-.057-.07-6.998-7a.5.5 0 0 0-.638-.057l-.07.057-7.001 7a.5.5 0 0 0 .637.764l.07-.057L11.5 4.71V21a.5.5 0 0 0 .992.09L12.5 21V4.706l6.146 6.148a.5.5 0 0 0 .638.057l.07-.057a.5.5 0 0 0 .057-.638z"
  })), props.children);
};
var AttachIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.146 16.93l7.124-7.125a.95.95 0 0 0-1.343-1.343l-5.213 5.213a.5.5 0 0 1-.708-.707l5.214-5.213a1.95 1.95 0 0 1 2.758 2.757l-6.962 6.962a.504.504 0 0 1-.048.055l-1.984 1.984c-.58.58-1.343.865-2.103.855a2.91 2.91 0 0 1-2.026-.855 2.909 2.909 0 0 1-.85-1.894 2.912 2.912 0 0 1 .85-2.235l.456-.456a.505.505 0 0 1 .038-.043L14.403 4.832a3.853 3.853 0 0 1 2.77-1.132c.976.01 1.95.387 2.695 1.132A3.852 3.852 0 0 1 21 7.519a3.853 3.853 0 0 1-1.132 2.778l-7.221 7.222a.5.5 0 1 1-.707-.707L19.16 9.59a2.865 2.865 0 0 0-4.051-4.051l-7.471 7.47a.506.506 0 0 1-.037.042l-3.04 3.04a1.92 1.92 0 0 0 2.715 2.715L9.1 16.984a.504.504 0 0 1 .047-.054z"
  })), props.children);
};
var AutoTopUpIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.794 19.588a8.083 8.083 0 1 0-2.794.495.417.417 0 0 1 0 .834 8.917 8.917 0 1 1 2.632-.395.417.417 0 0 1-.671-.33v-8.176c0-.23.186-.416.416-.416h1.648l-4.11-4.69-4.11 4.69h1.648c.23 0 .416.186.416.416v5.36a.417.417 0 0 1-.833 0v-4.943h-2.15a.417.417 0 0 1-.313-.691l5.029-5.739c.166-.189.46-.189.627 0l5.028 5.739a.417.417 0 0 1-.313.691h-2.15v7.155z"
  })), props.children);
};
var BankIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 9H3.5c-.51 0-.693-.673-.254-.931l7.993-4.702a1.499 1.499 0 0 1 1.522 0l7.993 4.702c.439.258.255.931-.254.931H18v5.517a.5.5 0 1 1-1 0V8.5a.5.5 0 0 1 .5-.5h1.164l-6.41-3.77a.5.5 0 0 0-.508 0L5.336 8H13.5A1.5 1.5 0 0 1 15 9.5v5.017a.5.5 0 1 1-1 0V9.5a.5.5 0 0 0-.5-.5h-2.497v7.75c0 .138.112.25.25.25H18.5a.5.5 0 0 1 .5.5v.496h1.5a.5.5 0 0 1 .5.5V20.5a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-2.004a.5.5 0 0 1 .5-.5H5V17.5a.5.5 0 0 1 .5-.5h1.944a.5.5 0 1 1 0 1H6v.496a.5.5 0 0 1-.5.5H4V20h16v-1.004h-1.5a.5.5 0 0 1-.5-.5V18h-6.747c-.69 0-1.25-.56-1.25-1.25V9H7v5.53a.5.5 0 1 1-1 0V9z"
  })), props.children);
};
var BarcodeScanIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 18v3h3v1H2.4c-.2 0-.4-.2-.4-.5V18h1zm19 0v3.5c0 .2-.2.4-.4.5H18v-1h3v-3h1zM9 13v5H7v-5h2zm5 0v5h-2v-5h2zm5 0v5h-2v-5h2zM6 13v5H5v-5h1zm5 0v5h-1v-5h1zm5 0v5h-1v-5h1zm5-2v1H3v-1h18zM6 6v4H5V6h1zm3 0v4H7V6h2zm5 0v4h-2V6h2zm5 0v4h-2V6h2zm-8 0v4h-1V6h1zm5 0v4h-1V6h1zm5.5-4c.3.1.5.3.5.5V6h-1V3h-3V2h3.5zM6 2v1H3v3H2V2.5c0-.2.2-.4.4-.5H6z"
  })), props.children);
};
var BlockIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9zm6 3.7L6.7 18c1.4 1.2 3.3 2 5.3 2 4.4 0 8-3.6 8-8 0-2-.8-3.9-2-5.3zM12 4c-4.4 0-8 3.6-8 8 0 2 .8 3.9 2 5.3L17.3 6C15.9 4.8 14 4 12 4z"
  })), props.children);
};
var BrowserIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.005 9h15.993l-.002-2.993H4.005V9zm0 1v8.003l16 .01L19.999 10H4.005zm16.037 9.012l-16.045-.009a.992.992 0 0 1-.992-.992V6c0-.548.444-.992.992-.992h16.008c.548 0 .991.444.991.991l.009 12.092c0 .555-.419.922-.963.922zM18 7.592a.592.592 0 1 1 1.185 0 .592.592 0 0 1-1.185 0zm-13 0a.592.592 0 1 1 1.185 0 .592.592 0 0 1-1.185 0zm2 0a.592.592 0 1 1 1.185 0 .592.592 0 0 1-1.185 0zm2 0a.592.592 0 1 1 1.185 0 .592.592 0 0 1-1.185 0z"
  })), props.children);
};
var CalculatorIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.523 20h6.466c.556 0 1.011-.45 1.011-.996v-6.565h-7.477V20zm-1 0v-7.56H4v6.564c0 .546.455.996 1.012.996h6.51zM4 11.44h7.523V4H5.012C4.455 4 4 4.45 4 4.996v6.443zM12.523 4v7.44H20V4.995C20 4.45 19.545 4 18.99 4h-6.466zM3 11.951a.51.51 0 0 1 0-.024V4.996C3 3.896 3.905 3 5.012 3h13.977C20.095 3 21 3.896 21 4.996v14.008c0 1.1-.905 1.996-2.011 1.996H5.012A2.008 2.008 0 0 1 3 19.004v-7.053zm15.062-4.72a.5.5 0 1 1 0 1h-3.21a.5.5 0 1 1 0-1h3.21zm0 7.623a.5.5 0 0 1 0 1h-3.21a.5.5 0 1 1 0-1h3.21zm0 1.837a.5.5 0 1 1 0 1h-3.21a.5.5 0 0 1 0-1h3.21zm-9.9-8.46v1.1a.5.5 0 1 1-1 0v-1.1H6.058a.5.5 0 0 1 0-1h1.106v-1.1a.5.5 0 1 1 1 0v1.1h1.105a.5.5 0 0 1 0 1H8.163zm-.56 8.858l-.782.78a.5.5 0 0 1-.706-.71l.78-.776-.78-.776a.5.5 0 0 1 .706-.709l.782.78.783-.78a.5.5 0 0 1 .705.708l-.78.777.78.777a.5.5 0 0 1-.705.708l-.783-.779z"
  })), props.children);
};
var CalendarPausedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.998 13.259V6.5c0-.826.674-1.5 1.5-1.5H6v-.5a.5.5 0 0 1 1 0V5h10v-.5a.5.5 0 1 1 1 0V5h1.5c.826 0 1.5.674 1.5 1.5a.5.5 0 1 1-1 0c0-.274-.227-.5-.5-.5h-1.5v.5a.5.5 0 1 1-1 0V6h-10v.5a.5.5 0 0 1-1 0V6h-1.5c-.274 0-.5.226-.5.5V9h16.5a.5.5 0 0 1 .5.5v9c0 .826-.674 1.5-1.5 1.5h-8.1A5.5 5.5 0 1 1 3 13.259zm1-.658a5.5 5.5 0 0 1 7.794 6.4H19.5c.274 0 .5-.226.5-.5V10h-16v2.6zM11 17.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0zm-3 2a.5.5 0 1 1-1 0v-4a.5.5 0 1 1 1 0v4zm-2 0a.5.5 0 1 1-1 0v-4a.5.5 0 1 1 1 0v4zm5.5-6.5a.47.47 0 0 1-.35-.15.454.454 0 0 1-.15-.35c0-.13.05-.26.15-.351a.503.503 0 0 1 .7 0c.1.091.15.221.15.351 0 .14-.05.26-.15.35a.47.47 0 0 1-.35.15zm3 4c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.353.353 0 0 1-.11-.161.402.402 0 0 1-.04-.189c0-.13.05-.26.15-.351a.503.503 0 0 1 .7 0c.1.091.15.221.15.351 0 .069-.01.13-.04.189a.353.353 0 0 1-.11.161.372.372 0 0 1-.16.11c-.06.03-.12.04-.19.04zm0-2a.47.47 0 0 1-.35-.15.353.353 0 0 1-.11-.161.402.402 0 0 1-.04-.189c0-.13.05-.26.15-.351a.503.503 0 0 1 .7 0c.1.091.15.221.15.351 0 .069-.01.13-.04.189a.353.353 0 0 1-.11.161.47.47 0 0 1-.35.15zm0-2c-.07 0-.13-.01-.19-.04a.477.477 0 0 1-.17-.11.431.431 0 0 1-.1-.161.504.504 0 0 1 .1-.54c.19-.189.53-.189.71 0 .1.091.15.221.15.351 0 .069-.01.13-.04.189a.353.353 0 0 1-.11.161.47.47 0 0 1-.35.15zm3 2a.47.47 0 0 1-.35-.15.353.353 0 0 1-.11-.161.402.402 0 0 1-.04-.189c0-.13.05-.26.15-.351a.503.503 0 0 1 .7 0c.1.091.15.221.15.351 0 .069-.01.13-.04.189a.353.353 0 0 1-.11.161.372.372 0 0 1-.16.11c-.06.03-.13.04-.19.04zm0-2a.47.47 0 0 1-.35-.15.454.454 0 0 1-.15-.35c0-.13.05-.26.15-.351a.503.503 0 0 1 .7 0c.1.091.15.221.15.351 0 .069-.01.13-.04.189a.353.353 0 0 1-.11.161.372.372 0 0 1-.16.11c-.06.03-.13.04-.19.04z"
  })), props.children);
};
var CalendarIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 6H7.001v.5a.5.5 0 0 1-1 0V6h-1.5c-.274 0-.5.226-.5.5V9h16.5a.5.5 0 0 1 .5.5v9c0 .826-.674 1.5-1.5 1.5h-15c-.826 0-1.5-.674-1.5-1.5v-12C3 5.674 3.675 5 4.5 5H6v-.5a.5.5 0 1 1 1 0V5H17v-.5a.5.5 0 1 1 1 0V5h1.5c.827 0 1.5.674 1.5 1.5a.5.5 0 1 1-1 0c0-.274-.225-.5-.5-.5H18v.5a.5.5 0 1 1-1 0V6zM4 10v8.5c0 .274.227.5.5.5h15c.275 0 .5-.226.5-.5V10H4zm4.5 7c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.47.47 0 0 1-.15-.35c0-.13.05-.26.15-.351.04-.05.1-.09.16-.11.18-.08.41-.03.54.11.1.09.15.22.15.35 0 .13-.05.26-.15.35a.47.47 0 0 1-.35.15zm0-2c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.353.353 0 0 1-.11-.161.402.402 0 0 1-.04-.19c0-.13.05-.26.15-.35a.493.493 0 0 1 .54-.11c.06.02.12.06.16.11.1.09.15.22.15.35 0 .07-.01.13-.04.19a.353.353 0 0 1-.11.16.372.372 0 0 1-.16.11c-.06.03-.12.04-.19.04zm3 2c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.47.47 0 0 1-.15-.35c0-.13.05-.26.15-.351.04-.05.1-.09.16-.11.18-.08.41-.03.54.11.1.09.15.22.15.35 0 .13-.05.26-.15.35a.47.47 0 0 1-.35.15zm0-2a.47.47 0 0 1-.35-.15.353.353 0 0 1-.11-.161.402.402 0 0 1-.04-.19c0-.13.05-.26.15-.35.04-.05.1-.09.16-.11.19-.08.4-.03.54.11.1.09.15.22.15.35 0 .07-.01.13-.04.19a.353.353 0 0 1-.11.16.372.372 0 0 1-.16.11c-.06.03-.12.04-.19.04zm0-2c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.47.47 0 0 1-.15-.35c0-.061.01-.13.04-.19.02-.06.06-.121.11-.161a.493.493 0 0 1 .54-.11c.06.02.12.06.16.11.05.04.09.1.11.16.03.06.04.13.04.19 0 .13-.05.26-.15.35a.47.47 0 0 1-.35.15zm3 4c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.353.353 0 0 1-.11-.161.402.402 0 0 1-.04-.19c0-.13.05-.26.15-.35.04-.05.1-.09.16-.11a.5.5 0 0 1 .38 0c.06.02.12.06.16.11.1.09.15.22.15.35 0 .13-.05.26-.15.35a.372.372 0 0 1-.16.11c-.06.03-.12.04-.19.04zm0-2c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.353.353 0 0 1-.11-.161.402.402 0 0 1-.04-.19c0-.13.05-.26.15-.35a.503.503 0 0 1 .7 0c.1.09.15.22.15.35 0 .07-.01.13-.04.19a.353.353 0 0 1-.11.16.47.47 0 0 1-.35.15zm0-2c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.47.47 0 0 1-.15-.35c0-.13.05-.26.15-.351a.489.489 0 0 1 .54-.11c.06.02.12.06.16.11.05.04.09.1.11.16.03.06.04.13.04.19 0 .13-.05.26-.15.35a.47.47 0 0 1-.35.15zm3 2c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.353.353 0 0 1-.11-.161.402.402 0 0 1-.04-.19c0-.13.05-.26.15-.35.04-.05.1-.09.16-.11.19-.08.4-.03.54.11.1.09.15.22.15.35 0 .07-.01.13-.04.19a.353.353 0 0 1-.11.16.372.372 0 0 1-.16.11c-.06.03-.12.04-.19.04zm0-2c-.07 0-.13-.01-.19-.04a.372.372 0 0 1-.16-.11.47.47 0 0 1-.15-.35c0-.13.05-.26.15-.351a.503.503 0 0 1 .7 0c.1.09.15.22.15.35 0 .13-.05.26-.15.35a.372.372 0 0 1-.16.11c-.06.03-.12.04-.19.04z"
  })), props.children);
};
var CameraAddIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.004 12.242l-.002 5.66c0 .607-.493 1.103-1.094 1.103H5.106a1.097 1.097 0 0 1-1.094-1.102l-.002-7.8a1.1 1.1 0 0 1 1.091-1.1h2.465c.192 0 .522-.138.623-.235l.95-1.194c.33-.33.908-.572 1.377-.572h2.981c.186 0 .39.04.591.107a4.5 4.5 0 1 1 5.916 5.133zm-1 .23a4.5 4.5 0 0 1-5.001-4.31c-.159-.09-.366-.16-.506-.16h-2.98c-.204 0-.528.136-.632.235l-.95 1.195c-.327.326-.91.57-1.37.57H5.102c-.046 0-.091.046-.091.102l.002 7.799c0 .058.043.102.094.102h13.802c.047 0 .094-.047.094-.102l.002-5.43zM19 8.5v1a.5.5 0 1 1-1 0v-1h-1a.5.5 0 1 1 0-1h1v-1a.5.5 0 1 1 1 0v1h1a.5.5 0 1 1 0 1h-1zm3-.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0zm-10 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM5.238 8a.5.5 0 0 1 0-1h1.7a.5.5 0 0 1 0 1h-1.7z"
  })), props.children);
};
var CameraIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.513 8.003h2.435c.391 0 .695.18.88.466.105.16.153.316.175.511l.001 2.3-.002 5.623c0 .606-.493 1.102-1.094 1.102H5.106a1.097 1.097 0 0 1-1.094-1.102l-.002-7.8a1.1 1.1 0 0 1 1.091-1.1h2.465c.192 0 .522-.138.623-.235l.95-1.194c.33-.33.908-.572 1.377-.572h2.981c.463 0 1.05.244 1.405.601l.949 1.122c.14.14.472.278.662.278zm2.477 1.011c-.009-.013-.006-.011-.042-.011h-2.435c-.456 0-1.043-.245-1.397-.601l-.95-1.122a1.188 1.188 0 0 0-.669-.278h-2.98c-.204 0-.528.136-.632.235l-.95 1.195c-.327.326-.91.57-1.37.57H5.102c-.046 0-.091.046-.091.102l.002 7.799c0 .058.043.102.094.102h13.802c.047 0 .094-.047.094-.102l.002-5.624c0-1.914 0-1.915.004-2.23 0 .004-.007-.018-.018-.035zM12 16a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM5.238 7a.5.5 0 0 1 0-1h1.7a.5.5 0 0 1 0 1h-1.7z"
  })), props.children);
};
var CardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.62 10.01a.5.5 0 1 1 0-1h13.21c.646 0 1.17.524 1.17 1.17v7.65A1.17 1.17 0 0 1 19.83 19H4.17A1.17 1.17 0 0 1 3 17.83V6.17C3 5.525 3.524 5 4.17 5l15.66.004c.646 0 1.17.525 1.17 1.171v1.214a.5.5 0 0 1-1 0V6.175a.17.17 0 0 0-.17-.17L4.17 6a.17.17 0 0 0-.17.17v11.66c0 .094.076.17.17.17h15.66a.17.17 0 0 0 .17-.17v-7.65a.17.17 0 0 0-.17-.17H6.62z"
  })), props.children);
};
var CartIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 6a.5.5 0 0 1 0-1h2.158a1.5 1.5 0 0 1 1.449 1.11l2.08 7.514c.058.22.258.376.483.376h9.14a.505.505 0 0 0 .487-.389l1.458-4.966c.08-.308-.14-.645-.484-.645H9a.5.5 0 0 1 0-1h10.771c1.039 0 1.688.99 1.448 1.912l-1.458 4.965A1.5 1.5 0 0 1 18.31 15H9.17c-.68 0-1.276-.462-1.449-1.115l-2.08-7.512A.502.502 0 0 0 5.159 6H3zm7.5 12a1 1 0 1 0-2.001.001A1 1 0 0 0 10.5 18zm1 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 11.5 18zm8 0a1 1 0 1 0-2.001.001A1 1 0 0 0 19.5 18zm1 0a2 2 0 1 1-4.001-.001A2 2 0 0 1 20.5 18z"
  })), props.children);
};
var CashCheckIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.5 13.012a.5.5 0 0 1-1 0v-4.44c0-.06-.01-.072.033-.072H5.467c.043 0 .033.012.033.071v6.858c0 .059.01.071-.033.071h13.066c-.043 0-.033-.012-.033-.071a.5.5 0 0 1 1 0c0 .572-.408 1.071-.967 1.071H5.467c-.559 0-.967-.5-.967-1.071V8.57C4.5 8 4.908 7.5 5.467 7.5h13.066c.559 0 .967.5.967 1.071v4.441zm-3-3.512a.5.5 0 1 1 0 1h-9a.5.5 0 1 1 0-1h9zm-2.54 3.499c-.21-.215-.8-.094-1.292.412a1.9 1.9 0 0 0-.423.65.5.5 0 0 1-.937-.35c.134-.358.355-.702.644-.998.838-.86 2.046-1.108 2.724-.412.096.098.173.207.232.326.551-.319 1.185-.334 1.594.086.333.342.382.853.198 1.348a.5.5 0 0 1-.937-.35c.061-.164.051-.272.023-.3-.061-.063-.352-.004-.623.275a1.093 1.093 0 0 0-.244.372c-.235.627-1.17.278-.938-.346l.001-.004c.122-.327.097-.587-.022-.71zM3 5.5v3H2V5a.5.5 0 0 1 .5-.5H6v1H3zm3 13v1H2.5A.5.5 0 0 1 2 19v-3.5h1v3h3zm15-3h1V19a.5.5 0 0 1-.5.5H18v-1h3v-3zm-3-10v-1h3.5a.5.5 0 0 1 .5.5v3.5h-1v-3h-3z"
  })), props.children);
};
var CashIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 6.21a.5.5 0 0 1 .595-.49c1.488.288 2.706.324 5.09.165l4.807-.297c2.108-.168 4.61-.095 6.106.203a.5.5 0 0 1 .402.49v7.412a.5.5 0 0 1-.573.494 26.394 26.394 0 0 0-.3-.042l-.236-.031a131.438 131.438 0 0 0-1.008-.128c-2.532-.31-4.57-.264-8.34.154-3.656.405-4.76.453-6.124.227A.5.5 0 0 1 5 13.874V6.211zm1 7.23c1.094.131 2.272.056 5.434-.294 3.84-.426 5.95-.473 8.584-.15l.523.065.459.059V6.702c-1.425-.219-3.589-.264-5.437-.116l-4.814.297c-2.147.143-3.41.132-4.749-.077v6.635zm13 2.598a.5.5 0 1 1 1 0v.982a.5.5 0 0 1-.624.484c-1.805-.462-4.43-.348-7.863.355-3.562.73-6.6.838-9.115.316a.5.5 0 0 1-.398-.49v-7.35a.5.5 0 0 1 .306-.462l.796-.334a.5.5 0 1 1 .387.922L3 10.666v6.606c2.293.402 5.065.273 8.312-.392 3.207-.657 5.766-.82 7.688-.479v-.363zM13.5 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  })), props.children);
};
var ChatIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.974 4A7.94 7.94 0 0 0 4 11.975a7.94 7.94 0 0 0 7.975 7.975c1.483 0 2.861-.36 4.046-1.052a.5.5 0 0 1 .407-.044l3.522 1.143c.03.01.057-.018.048-.048l-1.145-3.52a.5.5 0 0 1 .044-.407c.694-1.186 1.053-2.564 1.053-4.047A7.94 7.94 0 0 0 11.974 4zm0 16.95A8.94 8.94 0 0 1 3 11.975 8.94 8.94 0 0 1 11.974 3a8.94 8.94 0 0 1 8.975 8.975c0 1.576-.366 3.058-1.078 4.354l1.077 3.312a1.038 1.038 0 0 1-1.308 1.307l-3.312-1.075c-1.295.71-2.777 1.077-4.354 1.077zM8.501 14a.5.5 0 1 1 0-1h5a.5.5 0 1 1 0 1h-5zm0-3a.5.5 0 1 1 0-1h7a.5.5 0 1 1 0 1h-7z"
  })), props.children);
};
var CheckAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.566 14.417l-3.272-3.266a.996.996 0 0 1-.001-1.414 1.002 1.002 0 0 1 1.414-.002l2.566 2.561 8.02-8.004a.998.998 0 0 1 1.416.001 1.001 1.001 0 0 1-.002 1.415L6.98 14.417a1 1 0 0 1-1.414 0z"
  })), props.children);
};
var CheckCircleAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.448 10.818l4.82-5.19a1 1 0 0 1 1.465 1.36l-5.57 6a1 1 0 0 1-1.482-.018l-2.43-2.749a1 1 0 1 1 1.498-1.325l1.7 1.922zM9 1a8 8 0 0 0-8 8 8 8 0 0 0 8 8A8 8 0 1 0 9 1z"
  })), props.children);
};
var CheckCircleIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-1a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm4.348-11.354a.5.5 0 1 1 .707.708l-7 7a.5.5 0 0 1-.715-.01l-2.702-2.836a.5.5 0 1 1 .724-.69l2.349 2.466 6.637-6.638z"
  })), props.children);
};
var CheckIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.13 15.76l9.005-9.602a.5.5 0 1 1 .73.684l-9.38 10a.5.5 0 0 1-.737-.009l-3.62-4.053a.5.5 0 1 1 .745-.666L9.13 15.76z"
  })), props.children);
};
var ChevronCircleDownIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.985 14.753l4.144-4.588a.5.5 0 0 1 .742.67l-4.517 5a.5.5 0 0 1-.743-.001l-4.483-5a.5.5 0 1 1 .744-.668l4.113 4.587zM12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-1a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
  })), props.children);
};
var ChevronCircleUpIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.015 9.247l-4.144 4.588a.5.5 0 1 1-.742-.67l4.517-5a.5.5 0 0 1 .743.001l4.483 5a.5.5 0 1 1-.744.668l-4.113-4.587zM12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 1a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
  })), props.children);
};
var ChevronDownAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.343 6.754A1 1 0 0 1 2.557 5.17l.1.076 6.238 5.437 6.46-5.447a1 1 0 0 1 1.323.028l.086.091a1 1 0 0 1-.028 1.323l-.091.086-7.115 6a1 1 0 0 1-1.205.064l-.097-.074-6.885-6z"
  })), props.children);
};
var ChevronDownIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.354 8.146L12 13.793l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 1 1 .708-.708z"
  })), props.children);
};
var ChevronLeftIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.854 6.354a.5.5 0 1 0-.708-.708l-6 6a.5.5 0 0 0 0 .708l6 6a.5.5 0 0 0 .708-.708L10.207 12l5.647-5.646z"
  })), props.children);
};
var ChevronRightAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.421 3.69L6 5.111l3.904 3.905-3.863 3.862L7.462 14.3l5.279-5.279-5.32-5.331zM9 1a8 8 0 1 1 0 16A8 8 0 0 1 9 1z"
  })), props.children);
};
var ChevronRightIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.146 6.354a.5.5 0 1 1 .708-.708l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L14.793 12 9.146 6.354z"
  })), props.children);
};
var ChevronUpAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.657 11.246a1 1 0 0 1-1.214 1.584l-.1-.076-6.238-5.437-6.46 5.447a1 1 0 0 1-1.323-.028l-.086-.091a1 1 0 0 1 .028-1.323l.091-.086 7.115-6a1 1 0 0 1 1.205-.064l.097.074 6.885 6z"
  })), props.children);
};
var ChevronUpIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.354 14.854a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L12 9.207l-5.646 5.647z"
  })), props.children);
};
var ClearAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1a8 8 0 0 0-8 8c0 4.42 3.58 8 8 8A8 8 0 1 0 9 1zm-.042 6.544l2.168-2.168A1 1 0 0 1 12.54 6.79l-2.167 2.168 2.334 2.335a1 1 0 0 1-1.414 1.414l-2.335-2.334-2.334 2.334a1 1 0 0 1-1.415-1.414l2.335-2.335L5.376 6.79A1 1 0 0 1 6.79 5.376l2.168 2.168z"
  })), props.children);
};
var ClearIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.708 12l3.535 3.535a.5.5 0 0 1-.707.707L12 12.707l-3.535 3.535a.5.5 0 0 1-.707-.707L11.293 12 7.758 8.464a.5.5 0 1 1 .707-.707L12 11.292l3.536-3.535a.5.5 0 0 1 .707.707L12.708 12z"
  })), props.children);
};
var CloseAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.707 1.293a1 1 0 0 1 0 1.414l-6.3 6.3 6.3 6.3a1 1 0 0 1 .083 1.32l-.083.095a1 1 0 0 1-1.32.083l-.094-.083-6.3-6.3-6.286 6.285a1 1 0 1 1-1.414-1.414l6.285-6.286-6.285-6.285a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.084l.094.084 6.285 6.284 6.3-6.3a1 1 0 0 1 1.415 0z"
  })), props.children);
};
var CloseIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.071 11.364l6.718-6.718a.5.5 0 0 1 .707.708l-6.718 6.717 6.718 6.718a.5.5 0 0 1-.707.707l-6.718-6.718-6.717 6.718a.5.5 0 0 1-.708-.707l6.718-6.718-6.718-6.717a.5.5 0 1 1 .708-.708l6.717 6.718z"
  })), props.children);
};
var CodeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.654 3.078a.5.5 0 0 1 .34.543l-.021.088-5.586 16.938a.5.5 0 0 1-.97-.225l.02-.088 5.586-16.938a.5.5 0 0 1 .631-.318zM7.93 7.69a.5.5 0 0 1-.017.64l-.066.062-4.51 3.561 4.515 3.658a.5.5 0 0 1 .124.629l-.05.075a.5.5 0 0 1-.628.124l-.075-.05-5-4.051a.5.5 0 0 1-.064-.716l.068-.065 5-3.95a.5.5 0 0 1 .703.083zm8.207 0a.5.5 0 0 1 .702-.082l5 3.95.068.064a.5.5 0 0 1-.063.716l-5 4.05-.075.05a.5.5 0 0 1-.629-.123l-.05-.075a.5.5 0 0 1 .124-.629l4.515-3.658-4.51-3.56-.065-.063a.5.5 0 0 1-.017-.64z"
  })), props.children);
};
var ContactInfoIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.502 11.658v.396l1.268.802c.537.307.73.776.73 1.48v.351c0 .437-.335.813-.78.813H6.28c-.445 0-.78-.376-.78-.813v-.35c0-.714.181-1.174.702-1.47l1.306-.815v-.38C7.165 11.153 7 10.442 7 9.715 7 8.482 7.649 7.5 9 7.5c1.352 0 2 .982 2 2.214 0 .72-.162 1.424-.498 1.944zm-1 .774A1.82 1.82 0 0 1 9 12.5c-.176 0-.34-.023-.492-.065v.172l-.236.147-1.558.97c-.164.095-.214.22-.214.613v.163h5v-.163c0-.382-.054-.515-.245-.624l-1.753-1.108v-.173zM4 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4zm0-1h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm10.5 10a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1h-3zm0-3a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1h-4zM8 9.714c0 .938.394 1.786 1 1.786s1-.848 1-1.786C10 8.968 9.69 8.5 9 8.5s-1 .469-1 1.214z"
  })), props.children);
};
var CopyToClipboardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.09a.5.5 0 0 1 1 0v.41A1.5 1.5 0 0 1 16 21H4.5A1.5 1.5 0 0 1 3 19.5v-12A1.5 1.5 0 0 1 4.5 6h.513a.5.5 0 1 1 0 1H4.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5H16a.5.5 0 0 0 .5-.5v-.41zM8 3h11.5A1.5 1.5 0 0 1 21 4.5v12a1.5 1.5 0 0 1-1.5 1.5H8a1.5 1.5 0 0 1-1.5-1.5v-12A1.5 1.5 0 0 1 8 3zm0 1a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h11.5a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5H8z"
  })), props.children);
};
var CreditDebitCardsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.063 15H21v-4.5a.5.5 0 1 1 1 0v5a.5.5 0 0 1-.5.5h-2.437v1.818c0 .646-.504 1.182-1.142 1.182H3.142C2.505 19 2 18.464 2 17.818V8.26c0-.647.505-1.183 1.142-1.183h14.779c.638 0 1.142.536 1.142 1.183v.238H21V5H5.293v.782a.5.5 0 1 1-1 0V5a1 1 0 0 1 1-1H21a1 1 0 0 1 1 1v3.999a.5.5 0 0 1-.5.5h-2.937a.5.5 0 0 1-.5-.5V8.26c0-.108-.07-.183-.142-.183H3.142c-.071 0-.142.075-.142.183v9.557c0 .107.071.182.142.182h14.779c.072 0 .142-.075.142-.182v-6.633H4.828a.5.5 0 0 1 0-1h13.735a.5.5 0 0 1 .5.5V15zm-3.968 1.486h-1.189c-.511 0-.893-.448-.893-.964v-1.045c0-.516.382-.963.893-.963h1.189c.51 0 .891.447.891.963v1.045c0 .516-.38.964-.891.964zm-.082-2h-1.027v1.027h1.027v-1.027zM4.5 16a.5.5 0 1 1 0-1h7a.5.5 0 1 1 0 1h-7z"
  })), props.children);
};
var CriticalAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.307 1.804l7.29 12.96c.2.356.24.758.142 1.123A1.496 1.496 0 0 1 16.29 17H1.71a1.5 1.5 0 0 1-1.308-2.235l7.29-12.96c.2-.355.522-.598.884-.704a1.496 1.496 0 0 1 1.731.703zM9 5a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  })), props.children);
};
var CryptoIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.1 0 11 4.9 11 11s-4.9 11-11 11S1 18.1 1 12 5.9 1 12 1zm0 1C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1.5 3c.2 0 .4.2.5.4v2.1h2c.8 0 1.4.6 1.5 1.4v1.6c0 .3-.2.5-.5.5-.2 0-.4-.2-.5-.4V9c0-.2-.2-.4-.4-.5H8c-.2 0-.4.2-.5.4V15c0 .2.2.4.4.5H16c.2 0 .4-.2.5-.4v-1.6c0-.3.2-.5.5-.5.2 0 .4.2.5.4V15c0 .8-.6 1.4-1.4 1.5H14v2c0 .3-.2.5-.5.5-.2 0-.4-.2-.5-.4v-2.1h-2v2c0 .3-.2.5-.5.5-.2 0-.4-.2-.5-.4v-2.1H8c-.8 0-1.4-.6-1.5-1.4V9c0-.8.6-1.4 1.4-1.5H10v-2c0-.3.2-.5.5-.5.2 0 .4.2.5.4v2.1h2v-2c0-.3.2-.5.5-.5z",
    fill: "#2c2e2f"
  })), props.children);
};
var DeclineIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.708 12l3.535 3.535a.5.5 0 0 1-.707.707L12 12.707l-3.535 3.535a.5.5 0 0 1-.707-.707L11.293 12 7.758 8.464a.5.5 0 1 1 .707-.707L12 11.292l3.536-3.535a.5.5 0 0 1 .707.707L12.708 12zM12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-1a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
  })), props.children);
};
var DesktopIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.518 19l.003-1.843c0-.64.512-1.153 1.147-1.153l7.205-.002c.08 0 .147-.067.147-.143V5.139a.146.146 0 0 0-.144-.143H4.158a.147.147 0 0 0-.144.143V13H18.5a.5.5 0 1 1 0 1H4.014v1.859c0 .077.066.143.144.143h5.867a.5.5 0 1 1 0 1H4.158c-.63 0-1.144-.515-1.144-1.143V5.139c0-.63.517-1.143 1.144-1.143h15.718c.631 0 1.144.515 1.144 1.143v10.72c0 .631-.518 1.143-1.147 1.143l-7.204.002c-.084 0-.148.065-.148.154L12.518 19h4.787a.5.5 0 1 1 0 1H6.978a.5.5 0 1 1 0-1h4.54z"
  })), props.children);
};
var DirectDepositIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.98 4.5c.566 0 1.006.46 1.062 1.026l.006.123v5.044a.5.5 0 0 1-.991.09l-.009-.09V5.65c0-.077-.03-.126-.052-.143L19.98 5.5H4.068c-.017 0-.05.034-.063.097L4 5.649v7.79c0 .076.03.126.053.142l.015.007H19.98c.018 0 .051-.034.063-.097l.005-.053a.5.5 0 1 1 1 0c0 .58-.402 1.079-.949 1.143l-.119.007-7.459-.001.004.039v4.278l1.658-1.56a.5.5 0 0 1 .639-.038l.067.06a.5.5 0 0 1 .04.639l-.06.067-2.507 2.36a.5.5 0 0 1-.61.059l-.076-.06-2.494-2.36a.5.5 0 0 1 .616-.782l.071.056 1.656 1.568v-4.287l.004-.039h-7.46c-.566 0-1.007-.46-1.063-1.026L3 13.438V5.65c0-.58.403-1.078.95-1.142l.118-.007H19.98zM15.14 10c.103.106.187.224.253.351l.054.12.075-.047c.588-.349 1.256-.394 1.717-.02l.103.093c.37.38.425.956.216 1.518a.5.5 0 1 1-.937-.35c.086-.232.07-.403.005-.47-.123-.126-.537-.04-.9.332-.11.112-.198.235-.262.361l-.055.126c-.224.597-1.086.305-.962-.265l.024-.085.047-.14c.092-.32.07-.59-.041-.76l-.053-.066c-.301-.308-1.077-.15-1.707.497a2.394 2.394 0 0 0-.532.82.5.5 0 0 1-.936-.35c.155-.418.414-.821.752-1.168.976-1 2.37-1.286 3.139-.497zm2.312-3.566a.5.5 0 0 1 .09.991l-.09.009H6.598a.5.5 0 0 1-.09-.992l.09-.008H17.45z"
  })), props.children);
};
var DisasterReliefIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.073 15.962c.142-.509.48-.936.927-1.194V7.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V16h.512a.5.5 0 1 1 0 1H2.5a.5.5 0 0 1-.5-.5v-9A1.5 1.5 0 0 1 3.5 6h11A1.5 1.5 0 0 1 16 7.5v1.541h3.09a1.5 1.5 0 0 1 1.338.822l1.056 2.087c.295.466.44 1.112.44 1.758v2.754a.5.5 0 0 1-.5.5h-3.478a2 2 0 0 1-3.892 0H8.946a2.001 2.001 0 1 1-.02-1h5.147zM16 14.5a2 2 0 0 1 1.927 1.462h2.997v-2.254c0-.244-.028-.486-.083-.708h-2.193a.5.5 0 0 1 0-1h1.743l-.855-1.685a.5.5 0 0 0-.446-.274H16V14.5zm-4.5-5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1v1a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5v-1h-1A.5.5 0 0 1 7 12v-2a.5.5 0 0 1 .5-.5h1v-1A.5.5 0 0 1 9 8h2a.5.5 0 0 1 .5.5v1zm-1 1V9h-1v1.5H8v1h1.5V13h1v-1.5H12v-1h-1.5zm-2.5 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm9 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
  })), props.children);
};
var DonateIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.505 18.425a.499.499 0 0 1-.312.1.5.5 0 0 1-.228-.953c.243-.206.806-.667 1.034-.862.697-.596 1.338-1.2 1.944-1.855 1.57-1.697 2.613-3.43 2.922-5.155.463-2.684-1.667-4.862-3.78-4.862-1.219 0-2.47.668-2.882 1.531a.5.5 0 0 1-.45.284h-.086a.5.5 0 0 1-.437-.256c-.497-.892-1.768-1.56-2.981-1.56-2.192 0-4.144 1.661-3.947 4.071.093.893.5 1.826 1.088 2.694a.5.5 0 0 1-.828.561c-.672-.993-1.142-2.07-1.255-3.162-.25-3.066 2.214-5.163 4.942-5.163 1.3 0 2.639.59 3.443 1.496.755-.905 2.085-1.496 3.393-1.496 2.7 0 5.34 2.7 4.765 6.036-.35 1.949-1.484 3.836-3.173 5.66-.2.217-.403.427-.61.633l.551-.25c1.46-.604 2.556-.646 3.319-.318.196.084.334.178.363.213.635.46.688 1.068.23 1.448a.819.819 0 0 1-.2.128l-5.968 3.249a2.955 2.955 0 0 1-.76.294c-.55.133-1.121.133-1.658.055a3.25 3.25 0 0 1-.327-.062l-5.16-1.554c-.397-.144-.712-.217-.953-.235a.77.77 0 0 0-.282.016l-.511.332a.5.5 0 0 1-.542-.84l.429-.265a.782.782 0 0 1 .27-.162c.413-.155 1.038-.11 1.904.205l5.106 1.538c.034.008.106.022.21.037.42.061.87.061 1.279-.037.185-.045.354-.11.51-.197L20.69 16.6a7.573 7.573 0 0 0-.03-.024s-.037-.024-.118-.06c-.498-.213-1.318-.182-2.526.318l-3.511 1.59zm-2.502-2.34c-.507-.28-1.29-.594-2.332-.934-1.162-.35-2.214-.473-2.89-.392a3.758 3.758 0 0 0-1.273.435l-2.272 1.22a.5.5 0 0 1-.472-.881L5.02 14.32a4.75 4.75 0 0 1 1.621-.552c.844-.101 2.032.036 3.329.428 2.43.793 3.583 1.43 3.578 2.339-.024.159-.102.353-.271.54-.256.282-.644.443-1.15.443H9.985a.5.5 0 1 1 0-1h2.145c.205 0 .32-.038.385-.093a3.147 3.147 0 0 0-.51-.34zm.914-5.95c.959-.072 1.196-1.219-.16-3.048-1.256 1.966-.847 3.124.16 3.048zm.075.997c-2.267.17-2.59-2.216-1.078-4.583l.781-1.223.865 1.165c1.635 2.205 1.593 4.479-.568 4.641z"
  })), props.children);
};
var DownloadIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.1l3.158-2.965a.5.5 0 0 1 .684.73l-4 3.755a.5.5 0 0 1-.684 0l-4-3.755a.5.5 0 1 1 .684-.73L11.5 12.1V3.5a.5.5 0 0 1 1 0v8.6zM6.469 12a.5.5 0 1 1 0 1H4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-2.013a.5.5 0 0 1 0-1H19.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-6A1.5 1.5 0 0 1 4.5 12h1.969z"
  })), props.children);
};
var DuplicateIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.013 6a.5.5 0 0 1 .09.992L5.013 7H4.5a.5.5 0 0 0-.492.41L4 7.5v12a.5.5 0 0 0 .41.492L4.5 20H16a.5.5 0 0 0 .492-.41l.008-.09v-.41a.5.5 0 0 1 .992-.09l.008.09v.41a1.5 1.5 0 0 1-1.356 1.493L16 21H4.5a1.5 1.5 0 0 1-1.493-1.356L3 19.5v-12a1.5 1.5 0 0 1 1.356-1.493L4.5 6h.513zm10.573-3a1.5 1.5 0 0 1 .95.34l.11.1 4.208 4.206a.5.5 0 0 1 .14.275L21 8v8.5a1.5 1.5 0 0 1-1.356 1.493L19.5 18H8a1.5 1.5 0 0 1-1.493-1.356L6.5 16.5v-12a1.5 1.5 0 0 1 1.356-1.493L8 3h7.586zM15 4H8a.5.5 0 0 0-.492.41L7.5 4.5v12a.5.5 0 0 0 .41.492L8 17h11.5a.5.5 0 0 0 .492-.41L20 16.5V8.56h-5V4zm-1.5 4.5a.5.5 0 0 1 .492.41L14 9v2h2a.5.5 0 0 1 .09.992L16 12h-2v2a.5.5 0 0 1-.992.09L13 14v-2h-2a.5.5 0 0 1-.09-.992L11 11h2V9a.5.5 0 0 1 .5-.5zm5.852-.941L16 4.207v3.352h3.352z"
  })), props.children);
};
var EditIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.358 6.116a.504.504 0 0 1 .053-.064 1.382 1.382 0 0 0-2.029-1.81.5.5 0 1 1-.617-.786 2.381 2.381 0 0 1 3.42 3.239.503.503 0 0 1-.062.072L15.9 9.955a.5.5 0 0 1-.697.123l-2.69-1.884-5.71 8.133-.505 3.236 2.791-1.599 4.756-6.64a.5.5 0 1 1 .813.582l-4.82 6.729-.157.143-3.789 2.17a.5.5 0 0 1-.742-.511l.684-4.38a.5.5 0 0 1 .085-.21l7.6-10.828a.5.5 0 0 1 .696-.123L16.9 6.774l.459-.658zm-3.307-.114l-.964 1.374 2.279 1.596.96-1.378-2.275-1.592z"
  })), props.children);
};
var EmailIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 13.169l8-5.178V6.455c0-.236-.227-.446-.52-.446H4.52c-.293 0-.52.21-.52.446v1.536l8 5.178zM3 6.455c0-.805.69-1.446 1.52-1.446h14.96c.83 0 1.52.64 1.52 1.446v2.08l-9 5.825-8-5.178v8.372c0 .235.227.446.52.446h14.96c.293 0 .52-.21.52-.446V12a.5.5 0 1 1 1 0v5.554c0 .805-.69 1.446-1.52 1.446H4.52C3.69 19 3 18.359 3 17.554V8.27 6.455z"
  })), props.children);
};
var EmojiIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9zm0 1c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 8c.3 0 .5.2.5.5 0 2.5-2 4.5-4.5 4.5s-4.5-2-4.5-4.5c0-.3.2-.5.5-.5s.5.2.5.5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5c0-.3.2-.5.5-.5zm-1-4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM9 8c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"
  })), props.children);
};
var ErrorIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.244 4.113a.5.5 0 0 0-.68.193l-7.796 13.95a.5.5 0 0 0 .436.744h15.592a.5.5 0 0 0 .436-.744l-7.796-13.95a.5.5 0 0 0-.192-.193zm1.065-.295l7.796 13.95A1.5 1.5 0 0 1 19.795 20H4.206a1.5 1.5 0 0 1-1.31-2.232l7.796-13.95a1.5 1.5 0 0 1 2.618 0zM11.5 16.532c0-.293.24-.532.532-.532.292 0 .531.24.531.532 0 .292-.24.531-.531.531a.533.533 0 0 1-.532-.531zm0-7.029a.5.5 0 0 1 1-.006l.032 5a.5.5 0 0 1-1 .006l-.032-5z"
  })), props.children);
};
var ExternalAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.19 2.75h-3.44a.75.75 0 1 1 0-1.5H16a.75.75 0 0 1 .75.75v4.82a.75.75 0 1 1-1.5 0V3.81L9.744 9.317a.75.75 0 0 1-1.06-1.06l5.505-5.506zM13.25 12a.75.75 0 1 1 1.5 0v2.667c0 1.15-.933 2.083-2.083 2.083H3.333a2.083 2.083 0 0 1-2.083-2.083V5.333c0-1.15.933-2.083 2.083-2.083H5.96a.75.75 0 0 1 0 1.5H3.333a.583.583 0 0 0-.583.583v9.334c0 .322.261.583.583.583h9.334a.583.583 0 0 0 .583-.583V12z"
  })), props.children);
};
var ExternalIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 5a.5.5 0 0 1 0 1H4v14h13v-5a.5.5 0 1 1 1 0v5c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1zm4.5-2h6.497c.525 0 .944.413.997.93L21 4.04V10.5a.5.5 0 0 1-.992.09L20 10.5V4.564l-7.646 7.656a.5.5 0 0 1-.638.059l-.07-.058a.5.5 0 0 1-.058-.638l.058-.07L19.15 4H13.5a.5.5 0 0 1-.492-.41L13 3.5a.5.5 0 0 1 .41-.492L13.5 3h6.497z"
  })), props.children);
};
var FaceIdIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1zm6 0a.5.5 0 1 1 1 0v1a.5.5 0 1 1-1 0v-1zm-3.002 0a.5.5 0 1 1 1 0v1.9c.034 1.637-.426 2.6-1.498 2.6a.5.5 0 0 1 0-1c.317 0 .522-.43.498-1.59V8.5zm-2.847 7.358a.5.5 0 1 1 .698-.716c.584.569 1.406.858 2.497.858 1.107 0 2.053-.3 2.854-.9a.5.5 0 1 1 .6.8c-.979.733-2.136 1.1-3.454 1.1-1.337 0-2.411-.378-3.195-1.142zM4 8.5a.5.5 0 0 1-1 0v-3A2.5 2.5 0 0 1 5.5 3h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 0 4 5.5v3zM15.5 4a.5.5 0 1 1 0-1h3A2.5 2.5 0 0 1 21 5.5v3a.5.5 0 1 1-1 0v-3A1.5 1.5 0 0 0 18.5 4h-3zM4 15.5v3A1.5 1.5 0 0 0 5.5 20h3a.5.5 0 1 1 0 1h-3A2.5 2.5 0 0 1 3 18.5v-3a.5.5 0 1 1 1 0zM15.5 20h3a1.5 1.5 0 0 0 1.5-1.5v-3a.5.5 0 1 1 1 0v3a2.5 2.5 0 0 1-2.5 2.5h-3a.5.5 0 1 1 0-1z"
  })), props.children);
};
var FaqIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.815 10.048a6.464 6.464 0 0 1-6.297 4.94c-1.114 0-2.166-.254-3.089-.748l-2.276.724a.88.88 0 0 1-1.11-1.109l.74-2.276A6.479 6.479 0 0 1 2 8.489c0-3.593 2.912-6.481 6.518-6.481C12.118 2.008 15 4.89 15 8.49c0 .18-.007.36-.021.537a6.458 6.458 0 0 1 6.986 6.464c0 1.113-.255 2.164-.75 3.087l.742 2.278a.882.882 0 0 1-1.11 1.109l-2.277-.74c-.923.494-1.973.747-3.089.747-2.986 0-5.543-2-6.275-4.843a.5.5 0 0 1 .969-.25 5.454 5.454 0 0 0 5.306 4.093c1.022 0 1.97-.246 2.783-.722a.5.5 0 0 1 .407-.044l2.262.735-.736-2.262a.5.5 0 0 1 .044-.407c.476-.814.723-1.761.723-2.781a5.458 5.458 0 0 0-5.483-5.483 5.59 5.59 0 0 0-.666.04zM3.067 13.942l2.265-.72a.5.5 0 0 1 .404.044c.814.476 1.761.723 2.782.723A5.47 5.47 0 0 0 14 8.489a5.458 5.458 0 0 0-5.482-5.481C5.463 3.008 3 5.45 3 8.49c0 .987.265 1.938.759 2.782a.5.5 0 0 1 .044.407l-.736 2.263zM13.5 18a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1h-4zm0-3a.5.5 0 1 1 0-1h5a.5.5 0 1 1 0 1h-5zM7.542 6.471a.5.5 0 1 1-.8-.6c.383-.51.952-.82 1.697-.867 2.342-.145 3.311 3.033.933 4.036-.373.158-.362.144-.37.474a.5.5 0 1 1-1-.022c.017-.758.269-1.072.98-1.373 1.291-.545.788-2.196-.48-2.117-.452.028-.752.192-.96.47zm.958 5.522a.47.47 0 0 1-.35-.15.454.454 0 0 1-.15-.35c0-.13.05-.26.15-.351a.503.503 0 0 1 .7 0c.1.09.15.22.15.35 0 .14-.05.26-.15.35a.47.47 0 0 1-.35.15z"
  })), props.children);
};
var FavoriteSelectedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.062 7.97a7.178 7.178 0 0 0-1.223-1.49C9.742 5.467 8.427 4.99 6.91 5.254c-3.3.575-4.26 3.741-3.644 6.63.58 2.711 3.025 5.832 8.382 8.85.095.087.22.133.348.13a.503.503 0 0 0 .349-.13c5.295-2.986 7.975-6.336 8.561-8.84.605-2.59-.544-6.068-3.824-6.64-1.852-.323-3.323.443-4.46 1.902-.22.282-.391.531-.559.813z"
  })), props.children);
};
var FavoriteIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.062 7.97a7.178 7.178 0 0 0-1.223-1.49C9.742 5.467 8.427 4.99 6.91 5.254c-3.3.575-4.26 3.741-3.644 6.63.58 2.711 3.025 5.832 8.382 8.85.095.087.22.133.348.13a.503.503 0 0 0 .349-.13c5.295-2.986 7.975-6.336 8.561-8.84.605-2.59-.544-6.068-3.824-6.64-1.852-.323-3.323.443-4.46 1.902-.22.282-.391.531-.559.813zm7.87 3.697c-.175.744-.733 1.857-1.712 3.077-1.392 1.735-3.434 3.446-6.226 5.038-5.015-2.856-7.239-5.71-7.751-8.106-.513-2.41.268-4.989 2.838-5.437 2.085-.364 3.495.938 4.544 2.99a.5.5 0 0 0 .89 0c.33-.643.541-1.006.894-1.458.93-1.194 2.062-1.783 3.5-1.532 2.565.447 3.515 3.322 3.023 5.428zm-8.23 8.288l.276.402.016.004.017-.006.225-.435.014.008-.026-.015a.5.5 0 0 0-.523.042z"
  })), props.children);
};
var FilterIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.05 18H5.5c-.667 0-.667-1 0-1h1.55a2.5 2.5 0 0 1 4.9 0h6.55c.667 0 .667 1 0 1h-6.55a2.5 2.5 0 0 1-4.9 0zm6-6H4.5c-.333 0-.5-.25-.5-.5s.167-.5.5-.5h8.55a2.5 2.5 0 0 1 4.9 0h1.55c.333 0 .5.25.5.5s-.167.5-.5.5h-1.55a2.5 2.5 0 0 1-4.9 0zm-6-6H5.5c-.667 0-.667-1 0-1h1.55a2.5 2.5 0 0 1 4.9 0h6.55c.667 0 .667 1 0 1h-6.55a2.5 2.5 0 0 1-4.9 0zM9.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-6 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  })), props.children);
};
var FingerprintIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.463 9.482a.5.5 0 1 1 .992-.131c.193 1.458.29 2.56.29 3.311 0 .11-.007.22-.02.332-.046.375-.14.693-.341 1.253-.288.797-.349 1.059-.279 1.29.118.389.61.845 1.503 1.321a.5.5 0 1 1-.47.883c-1.105-.59-1.777-1.212-1.99-1.914-.161-.531-.08-.881.295-1.92.177-.491.255-.756.288-1.032.01-.074.014-.145.014-.213 0-.698-.094-1.761-.282-3.18zM14.3 20.058a.5.5 0 0 1-.628.778c-.494-.399-1.135-.601-1.945-.601-.303 0-.602.087-1.094.295-.79.334-.903.374-1.249.374-.56 0-.966-.348-1.198-1.002-.49-1.385.86-2.445 2.772-2.707 1.893-.26 3.73.323 4.494 1.703a.5.5 0 0 1-.875.484c-.528-.953-1.956-1.406-3.483-1.197-1.378.189-2.167.81-1.965 1.383.1.285.16.336.255.336.144 0 .253-.04.86-.295.607-.257 1.01-.374 1.483-.374 1.027 0 1.891.272 2.573.823zm-7.702-7.18a.5.5 0 1 1-.284-.959c.816-.242 1.335-.717 1.599-1.454l.093-.264c.096-.275.453-1.326.538-1.569.289-.827.515-1.39.764-1.854.74-1.384 2.642-1.862 3.734-.488.569.716.594 1.277.377 2.794-.14.977-.16 1.495-.021 2.114.584 2.627-.629 4.084-3.323 5.25-.32.139-1.364.558-1.517.623a7.02 7.02 0 0 0-.792.38.5.5 0 0 1-.503-.863c.245-.143.531-.28.905-.438.166-.07 1.205-.487 1.51-.62 2.307-.998 3.199-2.07 2.744-4.115-.172-.77-.149-1.383.007-2.472.177-1.24.16-1.615-.17-2.031-.587-.738-1.635-.474-2.07.338-.217.407-.428.93-.701 1.712-.083.237-.44 1.288-.538 1.57-.047.134-.064.183-.096.27-.373 1.043-1.14 1.745-2.256 2.076zm.29 2.474a.5.5 0 1 1-.394-.919c1.742-.746 2.85-1.408 3.299-1.945.306-.366.38-.702.411-1.597.025-.673.054-.984.167-1.392a.5.5 0 0 1 .964.265c-.085.31-.11.566-.131 1.163-.04 1.107-.15 1.612-.644 2.203-.58.691-1.795 1.418-3.672 2.222zm.002-6.07a.5.5 0 1 1-.98-.194c.788-4.003 2.71-6.09 5.727-6.09 4.115 0 6.294 4.417 6.294 10.73a.5.5 0 0 1-1 0c0-5.83-1.924-9.73-5.294-9.73-2.472 0-4.041 1.704-4.747 5.283z"
  })), props.children);
};
var GiftIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.03 6h3.479v-.03a3.33 3.33 0 0 0-.404-.963c-.395-.633-.95-.996-1.734-.996-.787 0-1.212.252-1.428.674-.122.238-.16.494-.153.68V5.435a.808.808 0 0 0 .176.489c.02.026.042.052.065.077zM6.886 6c-.074-.21-.1-.414-.094-.595-.014-.343.05-.76.262-1.176.39-.76 1.16-1.218 2.318-1.218 1.16 0 2.017.56 2.582 1.466l.05.081c.027-.046.056-.091.086-.137C12.666 3.542 13.526 3 14.681 3s1.921.442 2.302 1.182c.206.4.265.802.247 1.14v.005a1.67 1.67 0 0 1-.125.673h3.409c.827 0 1.496.67 1.496 1.496v1.955c0 .83-.67 1.554-1.496 1.554l-8.014.004v8.006h7.488v-6.5a.5.5 0 1 1 1 0v7a.5.5 0 0 1-.5.5H3.525a.5.5 0 0 1-.5-.498l-.031-8.61c-.547-.215-.989-.756-.989-1.335V7.558c0-.844.65-1.558 1.487-1.558h3.393zm5.627-.119l.001.007h-.004c-.006.014-.009.016-.009.003V6h3.405c.058-.05.108-.104.15-.16a.804.804 0 0 0 .175-.49l.002-.076c.009-.18-.026-.417-.138-.635C15.89 4.241 15.471 4 14.681 4s-1.352.354-1.756.97a3.226 3.226 0 0 0-.346.71c-.032.091-.054.167-.067.201zM7.675 7l-.001.001L7.672 7h-4.18c-.263 0-.487.247-.487.558v2.014c0 .179.274.433.487.433a.5.5 0 0 1 .5.498l.032 8.512H11.5l.006-8.006-5.466.002a.5.5 0 0 1 0-1l5.466-.002L11.508 7H7.675zm4.825 3.009l8.014-.004c.255 0 .496-.26.496-.554V7.496A.496.496 0 0 0 20.514 7h-4.378a.5.5 0 0 1-.138 0H12.5v3.009z"
  })), props.children);
};
var GoalsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.998 7.295V5.5a.5.5 0 0 1 .146-.354l2.003-2A.5.5 0 0 1 19 3.5v2a.5.5 0 1 1-1 0v-.794l-1.002 1.001v1.305h1.464l1.714-1.608a.5.5 0 1 1 .684.73L19 7.877a.5.5 0 0 1-.342.135h-1.964l-4.341 4.342a.5.5 0 0 1-.708-.708l4.352-4.35zM11.5 9.513a.5.5 0 0 1 .197.98 1.564 1.564 0 1 0 1.842 1.844.5.5 0 1 1 .98.198A2.564 2.564 0 1 1 11.5 9.513zm2.394-2.966a.5.5 0 1 1-.328.944 4.787 4.787 0 1 0 2.964 2.957.5.5 0 1 1 .944-.33 5.788 5.788 0 1 1-3.58-3.572zm1.27-2.955a.5.5 0 0 1-.353.936 8.004 8.004 0 0 0-10.82 7.494 8.004 8.004 0 1 0 15.517-2.76.5.5 0 1 1 .938-.347 9.004 9.004 0 0 1-8.452 12.112 9.004 9.004 0 0 1-9.003-9.005 9.004 9.004 0 0 1 12.172-8.43z"
  })), props.children);
};
var HeartIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.137 7.104c-1.698 2.261-1.313 3.692-.043 3.598a.504.504 0 0 1 .086 0c1.27.095 1.655-1.337-.043-3.598zm-.005 4.597c-2.329.147-2.932-2.426-.626-5.41a.498.498 0 0 1-.029-.11A4.576 4.576 0 0 0 7.568 4C5.044 4 3 6.027 3 8.527c0 1.235.586 2.486 1.588 3.564l7.55 7.442 7.533-7.426c1.017-1.093 1.603-2.344 1.603-3.581C21.274 6.027 19.229 4 16.706 4c-1.621 0-3.09.843-3.91 2.182a.498.498 0 0 1-.028.109c2.31 2.988 1.701 5.565-.636 5.41zm.005-6.335A5.577 5.577 0 0 1 16.706 3c3.074 0 5.568 2.473 5.568 5.526 0 1.516-.695 2.997-1.886 4.278l-7.879 7.767a.499.499 0 0 1-.38.143.499.499 0 0 1-.364-.144L3.87 12.787C2.695 11.523 2 10.041 2 8.527 2 5.473 4.494 3 7.568 3c1.852 0 3.542.905 4.57 2.366z"
  })), props.children);
};
var HelpCenterIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 1a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm.056 12c.305 0 .555.25.555.556 0 .305-.25.555-.555.555a.557.557 0 0 1-.556-.555c0-.306.25-.556.556-.556zm-.27-10C13.708 6 15.3 7.371 15.3 9.413c0 1.591-.927 2.732-2.681 3.381l-.12.042.001 1.246a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.492-.41l-.008-.09V12.1l.358-.106c1.67-.497 2.442-1.34 2.442-2.581C14.3 7.959 13.185 7 11.787 7c-1.127 0-2.182.676-2.28 1.335l-.007.098a.5.5 0 0 1-1 0C8.5 7.091 10.116 6 11.787 6z"
  })), props.children);
};
var HideAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.197 11.362l2.204 2.074c-.937.537-2.071.883-3.42.883-4.377 0-7.032-3.766-7.281-5.38l-.616.05s.631-2.118 2.678-3.683l1.936 1.822a3.527 3.527 0 0 0-.665 2.058 3.554 3.554 0 0 0 3.554 3.554 3.52 3.52 0 0 0 2.222-.802l-.612-.576zm1.58-.658c.225-.46.364-.97.364-1.518a3.554 3.554 0 0 0-3.554-3.554 3.46 3.46 0 0 0-1.71.461L8.5 7.62c.03-.002.056-.014.087-.014.872 0 1.58.707 1.58 1.58l-.001.002 1.61 1.516zm1.893 1.782l2.373 2.234a.395.395 0 1 1-.541.575L2.712 3.257a.395.395 0 0 1 .541-.575L5.15 4.467c1.025-.485 2.282-.81 3.832-.81 4.738 0 7.897 5.331 7.897 5.331l-1.075-.148c-.22 1.06-.916 2.505-2.134 3.646zM7.165 8.51l2.182 2.053a1.562 1.562 0 0 1-.76.203 1.58 1.58 0 0 1-1.58-1.58c0-.243.06-.47.158-.676z"
  })), props.children);
};
var HomeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 11.569c0-.09.023-.173.064-.246a.5.5 0 0 1 .468-.323h2.165L12 3.173 3.303 11h2.17a.5.5 0 0 1 .464.315l.027.068.036.186V21h4v-4a.5.5 0 0 1 .5-.5h3.002a.5.5 0 0 1 .5.5v4H18v-9.431zM19 12v9.5a.5.5 0 0 1-.5.5h-4.998a.5.5 0 0 1-.5-.5v-4H11v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V12H2a.5.5 0 0 1-.334-.872l10-9a.5.5 0 0 1 .668 0l10 9A.5.5 0 0 1 22 12h-3z"
  })), props.children);
};
var HoneyIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8 7c0-.7.2-1.7.7-2.2.7-.8 2-.7 2.2.5.1.6 0 1.2-.3 1.7-.5 1-1.5 1.9-2.6 2.2V7m9.1 10.1c-.6.7-1.3 1.2-2 1.1-.8 0-.7-1-.7-1.5v-2.3-1.3c-.1-1.3-.9-2.3-2.3-2.4-2.4-.1-3.4 2.3-4.1 4.2v-4.2c2.1-.3 5.1-1.5 5.2-4.3.1-4.6-7.6-4.8-7.6 1v1.8C6.3 9 5.5 7.5 5.1 6.6c0-.1-.2-.2-.3-.2-1.5.4-1.7 1.9-.7 3 .8.9 2.1 1.2 3.3 1.3v8.8c0 .5.7.6 1.1.6.4 0 1.2-.1 1.3-.7.1-1.7 1.5-6.5 3.4-6.5.4 0 .7.3.7.7v4c0 1.7.9 2.8 2.6 2.8 1.5 0 2.8-1.2 3.5-2.7.1-.5-.8-.9-1.1-.6",
    fill: "#2c2e2f"
  })), props.children);
};
var InfoAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17c-4.411 0-8-3.59-8-8 0-4.412 3.589-8 8-8s8 3.588 8 8c0 4.41-3.589 8-8 8zm0-3a1 1 0 0 0 1-1V9a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1zM9 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  })), props.children);
};
var InfoIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 1a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-.5 3.468c0-.292.24-.531.532-.531.292 0 .531.24.531.531 0 .293-.24.532-.531.532a.533.533 0 0 1-.532-.532zm0 9.532V9.918a.5.5 0 1 1 1 0V17a.5.5 0 1 1-1 0z"
  })), props.children);
};
var InsightsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.315 5H17.5a.5.5 0 1 1 0-1h3.973a.5.5 0 0 1 .49.397c.025.084.029.174.01.26v3.92a.5.5 0 1 1-1 0v-2.82l-7.149 7.068a.5.5 0 0 1-.705-.001l-1.618-1.618-7.647 7.648A.5.5 0 0 1 3 18.5V4.547a.5.5 0 1 1 1 0v12.746l7.148-7.148a.5.5 0 0 1 .707 0l1.62 1.62L20.315 5zM6.5 20a.5.5 0 1 1 0-1h14a.5.5 0 1 1 0 1h-14z"
  })), props.children);
};
var InvoiceIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-11zm0-1h11A1.5 1.5 0 0 1 19 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3zM9 7v2h2V7H9zm-.5-1h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5zM8 13a.5.5 0 1 1 0-1h8a.5.5 0 1 1 0 1H8zm0 2.5a.5.5 0 1 1 0-1h8a.5.5 0 1 1 0 1H8zm2.5 2.5a.5.5 0 1 1 0-1H16a.5.5 0 1 1 0 1h-5.5z"
  })), props.children);
};
var IzettlePosIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.323 0c.854 0 1.607.676 1.684 1.555l.006.148v16.595c0 .858-.668 1.618-1.543 1.695l-.147.007h-1.306v2.489c0 .783-.457 1.419-1.175 1.491l-.137.007H9.42c-.747 0-1.34-.6-1.408-1.355l-.006-.143V20H6.702a1.713 1.713 0 0 1-1.685-1.554l-.006-.148V1.703C5.01.845 5.68.084 6.554.007L6.702 0h10.62zM11 18H9.006v4.489c0 .224.118.4.274.468l.069.022.072.008L11 22.986V18zm4.017 0H12v4.986h2.705c.158 0 .278-.13.306-.382l.006-.115V18zm2.306-17H6.702c-.346 0-.639.281-.685.612l-.006.091v16.595c0 .354.278.649.602.696l.089.006h1.305v-1.278c0-.346.265-.664.608-.715L8.71 17h6.604c.356 0 .65.29.697.629l.006.093V19h1.306c.346 0 .638-.281.684-.611l.006-.091V1.703a.717.717 0 0 0-.601-.697L17.322 1zm-5.32 13.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm-3.496 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm6.993 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm-3.496-2.857a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm-3.497 0a.75.75 0 1 1 0 1.501.75.75 0 0 1 0-1.5zm6.993 0a.75.75 0 1 1 0 1.501.75.75 0 0 1 0-1.5zM8.512 9.037a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm7 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm-3.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zM15.845 2c.595 0 1.096.432 1.16 1.001l.007.124v3.75c0 .587-.461 1.058-1.04 1.118L15.844 8H8.18c-.595 0-1.096-.432-1.16-1.001l-.007-.124v-3.75c0-.587.461-1.058 1.04-1.118L8.18 2h7.666zm0 1H8.18c-.08 0-.139.04-.16.088l-.007.037v3.75c0 .05.044.1.112.118L8.179 7h7.666l.056-.007a.153.153 0 0 0 .103-.081l.008-.037v-3.75c0-.05-.043-.1-.111-.118L15.845 3z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), props.children);
};
var LaptopIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.477 17H17.01c.444 0 .895-.35 1.022-.786l2.467-9.063c.011-.103-.027-.151-.07-.151H9.658c-.19 0-.392.158-.424.342l-1.25 4.888a.5.5 0 0 1-.97-.248l1.242-4.847C8.364 6.495 8.995 6 9.657 6h10.77c.667 0 1.137.59 1.051 1.336l-2.485 9.148c-.25.867-1.09 1.516-1.984 1.516H5.477a2.88 2.88 0 0 1-2.035-.841.5.5 0 0 1-.119-.19l-.796-2.303A.5.5 0 0 1 3 14.003h13.032a.5.5 0 0 1 0 1H3.702l.526 1.523a1.88 1.88 0 0 0 1.25.474z"
  })), props.children);
};
var LightBulbIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17v-2.793l-1.354-1.353a.5.5 0 0 1 .708-.708L12 13.293l1.146-1.147a.5.5 0 0 1 .708.708L12.5 14.207V17h2.218c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77V19.5a2.5 2.5 0 0 1-2.5 2.5h-3A2.5 2.5 0 0 1 8 19.5v-1.218c0-.08.002-.151.004-.215A.504.504 0 0 1 8 17.995l.031-2.977A7.17 7.17 0 0 1 5 9.138C5 5.197 8.132 2 12 2s7 3.198 7 7.137a7.17 7.17 0 0 1-3.034 5.883v.53a.5.5 0 1 1-1 0v-.797a.5.5 0 0 1 .229-.42A6.165 6.165 0 0 0 18 9.137C18 5.745 15.311 3 12 3S6 5.745 6 9.137a6.165 6.165 0 0 0 2.805 5.196.5.5 0 0 1 .23.426l-.024 2.249c.077-.005.166-.008.27-.008H11.5zM9 18.282V19.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-1.218c0-.181-.002-.245-.007-.275a2.248 2.248 0 0 0-.275-.007H9.282c-.181 0-.245.002-.275.007-.005.03-.007.094-.007.275z"
  })), props.children);
};
var LinkIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.81 12.235a.5.5 0 0 1-.901.435 3.501 3.501 0 0 1 .677-3.999l3.535-3.535a3.489 3.489 0 0 1 2.475-1.025c.896 0 1.792.341 2.475 1.025a3.489 3.489 0 0 1 1.025 2.454 3.49 3.49 0 0 1-1.025 2.496L16.956 12.2a.5.5 0 1 1-.707-.707l2.115-2.115a2.5 2.5 0 0 0-3.536-3.536l-3.535 3.536a2.501 2.501 0 0 0-.484 2.856zm2.405-1.419a.5.5 0 1 1 .91-.415 3.5 3.5 0 0 1-.71 3.927l-3.536 3.536a3.491 3.491 0 0 1-2.647 1.02 3.487 3.487 0 0 1-2.303-1.02 3.489 3.489 0 0 1-1.025-2.43 3.49 3.49 0 0 1 1.025-2.52l1.458-1.458a.5.5 0 0 1 .707.707l-1.458 1.458a2.5 2.5 0 1 0 3.536 3.536l3.535-3.536a2.5 2.5 0 0 0 .508-2.805z"
  })), props.children);
};
var ListDetailedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 8a.5.5 0 1 1 0-1h9a.5.5 0 1 1 0 1h-9zm-6 0a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm6 3a.5.5 0 1 1 0-1h9a.5.5 0 1 1 0 1h-9zm-6 0a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1h-3zm6 3a.5.5 0 1 1 0-1h9a.5.5 0 1 1 0 1h-9zm-6 0a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1h-3zm6 3a.5.5 0 1 1 0-1h9a.5.5 0 1 1 0 1h-9zm-6 0a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1h-3z"
  })), props.children);
};
var ListSimpleIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 8a.5.5 0 0 1 0-1h15a.5.5 0 1 1 0 1h-15zm0 3a.5.5 0 1 1 0-1h15a.5.5 0 1 1 0 1h-15zm0 3a.5.5 0 1 1 0-1h15a.5.5 0 1 1 0 1h-15zm0 3a.5.5 0 1 1 0-1h15a.5.5 0 1 1 0 1h-15z"
  })), props.children);
};
var LocationIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M12.572 21.628a1.5 1.5 0 0 1-1.986-.746L5.96 10.676c-.29-.902-.46-1.632-.46-2.23a6.446 6.446 0 1 1 12.379 2.523l-4.564 9.92a1.5 1.5 0 0 1-.743.739zm4.392-11.063A5.446 5.446 0 1 0 6.5 8.445c0 .462.153 1.12.391 1.872l4.606 10.151a.5.5 0 0 0 .91.003l4.557-9.906zM9.046 8.357a2.9 2.9 0 1 1 5.8 0 2.9 2.9 0 0 1-5.8 0zm1 0a1.9 1.9 0 1 0 3.8 0 1.9 1.9 0 0 0-3.8 0z"
  })), props.children);
};
var LockAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.584v1.417h5V5.584c0-1.425-1.122-2.583-2.5-2.583S6.5 4.159 6.5 5.584zm7.409 1.417A1.1 1.1 0 0 1 15 8.111v7.778c0 .614-.488 1.112-1.091 1.112H4.091A1.101 1.101 0 0 1 3 15.889V8.111a1.1 1.1 0 0 1 1.091-1.11H4.5V5.584c0-2.531 2.015-4.583 4.5-4.583s4.5 2.052 4.5 4.583v1.417h.409z"
  })), props.children);
};
var LockIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 8V7a5 5 0 1 1 10 0v1h1.5A1.5 1.5 0 0 1 20 9.5v5.995a.5.5 0 0 1-1 0V9.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-.99a.5.5 0 1 1 1 0v.99a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19.5v-10A1.5 1.5 0 0 1 5.5 8H7zm1 0h8V7a4 4 0 1 0-8 0v1zm3.5 4.5a.5.5 0 1 1 1 0v4a.5.5 0 1 1-1 0v-4z"
  })), props.children);
};
var LogoPaypalIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.521 17.596l1.227-.068a.5.5 0 0 1 .055.999l-1.358.074c-.331 0-.522-.043-.722-.282a.9.9 0 0 1-.212-.737L6.658 3.88c.098-.64.555-.858 1.225-.858h5.155c.177 0 .328-.003.62-.011 1.05-.028 1.447-.007 1.947.17 1.699.605 2.83 2.026 2.62 4.208l-.027.204c1.076.97 1.337 2.026 1.036 3.602-.56 2.942-2.405 4.396-5.522 4.396h-.4c-.105 0-.304.23-.342.468l-.567 3.781c-.076.505-.403 1.053-.93 1.053H8.79c-.299 0-.401-.129-.499-.346a1.365 1.365 0 0 1-.06-.163c.029.09-.02-.056.032.002-.149-.179-.182-.587-.15-.8l1.027-6.621.028-.085c.157-.398.528-.7.96-.7h1.512c3.087 0 4.84-1.195 5.42-3.787l.008-.041.046-.265c-.374-.139-.936-.209-1.678-.209h-4.284c-.211 0-.228.01-.226-.006l-.524 2.641a.5.5 0 1 1-.98-.194L9.94 7.7c.08-.525.556-.822 1.21-.822h4.285c.728 0 1.327.058 1.81.199.077-1.544-.728-2.509-1.976-2.953-.338-.12-.669-.138-1.585-.113-.3.008-.458.01-.647.01H7.883c-.237 0-.235 0-.237.012L5.521 17.596zm6.119-4.415h-1.512c.016 0-.012.023-.02.04V13.2l-1.007 6.533c.003-.018.005.042.008.09-.001-.023 0 .016-.075-.073a.497.497 0 0 1 .089.144h2.215a.713.713 0 0 0 .076-.202l.568-3.784c.108-.68.659-1.316 1.33-1.316h.4c2.647 0 4.07-1.123 4.54-3.583.184-.965.126-1.603-.27-2.17-.752 2.934-2.908 4.343-6.342 4.343zm-2.85 6.712h.326c-.038-.048-.097 0-.326 0z"
  })), props.children);
};
var LogoutIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3 5.5c3.1 1.3 5.2 4.4 5.2 7.8 0 4.7-3.8 8.5-8.5 8.5S3.5 18 3.5 13.3c0-3.3 1.9-6.2 4.8-7.6.2-.1.5 0 .7.3.1.2 0 .5-.2.7-2.6 1.2-4.2 3.8-4.2 6.7 0 4.1 3.4 7.5 7.5 7.5s7.5-3.4 7.5-7.5c0-3-1.8-5.7-4.6-6.9-.3-.1-.4-.4-.3-.7.1-.2.4-.4.6-.3zM12 2c.2 0 .4.2.5.4v10c0 .3-.2.5-.5.5-.2 0-.4-.2-.5-.4v-10c0-.3.2-.5.5-.5z"
  })), props.children);
};
var LoyaltyCardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2 5h15.7c.6 0 1.1.5 1.1 1.2v11.7c0 .6-.5 1.2-1.2 1.2H4.2C3.5 19 3 18.5 3 17.8V6.2C3 5.5 3.5 5 4.2 5zm0 1c-.1 0-.2.1-.2.2v11.7s.1.1.2.1h15.7c.1 0 .2-.1.2-.2V6.1c-.1 0-.2-.1-.3-.1H4.2zm4.4 2.3c.2-.4.7-.4.9 0l.9 1.8 2 .3c.4.1.5.5.3.8l-.1.1-1.5 1.4.3 2c.1.4-.3.7-.7.6h-.1l-1.8-1-1.8 1c-.3.2-.7-.1-.7-.4v-.1l.3-2-1.5-1.4c-.1-.4.1-.8.4-1h.1l2-.3 1-1.8zM9 9.6l-.6 1.2c-.1.2-.2.3-.4.3l-1.3.2.9.9c.1.1.1.2.2.3v.1l-.2 1.3 1.2-.6c.1-.1.3-.1.4 0h.1l1.2.6-.2-1.3c0-.1 0-.3.1-.4l.1-.1.9-.9-1.4-.1c-.1 0-.2-.1-.3-.2l-.1-.1L9 9.6zm9 2.8c.3 0 .5.2.5.5 0 .2-.2.4-.4.5h-3.6c-.3 0-.5-.2-.5-.5 0-.2.2-.4.4-.5H18zm0-2.4c.3 0 .5.2.5.5 0 .2-.2.4-.4.5h-3.6c-.3 0-.5-.2-.5-.5 0-.2.2-.4.4-.5H18z"
  })), props.children);
};
var MenuIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 7a.5.5 0 0 1 0-1h15a.5.5 0 1 1 0 1h-15zm0 5a.5.5 0 1 1 0-1h15a.5.5 0 1 1 0 1h-15zm0 5a.5.5 0 1 1 0-1h15a.5.5 0 1 1 0 1h-15z"
  })), props.children);
};
var MessageCenterIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.823 10.005a6.221 6.221 0 0 1 6.238 6.229l-.007.305a6.246 6.246 0 0 1-.704 2.59l-.034.063.703 2.174.026.1a.864.864 0 0 1-1.114.988l-2.161-.692-.058.033a6.219 6.219 0 0 1-2.889.684c-3.443 0-6.203-2.783-6.203-6.245a6.193 6.193 0 0 1 6.203-6.23zm0 1c-2.891 0-5.203 2.322-5.203 5.229 0 2.911 2.314 5.245 5.203 5.245.969 0 1.868-.235 2.64-.688l.076-.037a.5.5 0 0 1 .33-.009l2.117.676-.69-2.127a.5.5 0 0 1 .044-.405c.47-.806.72-1.713.72-2.655 0-2.9-2.337-5.23-5.237-5.23zM17 17a.5.5 0 0 1 .09.992L17 18h-3.5a.5.5 0 0 1-.09-.992L13.5 17H17zm1.5-2a.5.5 0 0 1 .09.992L18.5 16h-5a.5.5 0 0 1-.09-.992L13.5 15h5zm-1-13.004c.773 0 1.42.56 1.493 1.292l.007.139v1.3a.5.5 0 0 1 0 .028l-.007 3.443a.5.5 0 0 1-.992.089l-.008-.09.004-2.544-7.232 4.521a.5.5 0 0 1-.446.042l-.084-.042-7.23-4.52L3 12.566c0 .204.17.385.407.423l.092.007h3.976a.5.5 0 0 1 .09.992l-.09.008H3.5c-.772 0-1.419-.56-1.492-1.291L2 12.565l.005-7.744a.5.5 0 0 1-.002-.13l.004-1.265c0-.751.601-1.355 1.356-1.423l.143-.007h13.995zm0 1H3.507c-.252 0-.45.159-.491.355l-.008.076-.002 1.048 7.494 4.686 7.499-4.688L18 3.426c0-.204-.17-.385-.407-.423l-.092-.007z"
  })), props.children);
};
var MicrophoneIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.514 16.978v4.476a.5.5 0 0 1-1 0v-4.46c-3.16-.128-4.88-1.886-5.014-5.158l.005-.691a.5.5 0 0 1 1 .008l-.005.666c.116 2.84 1.526 4.183 4.393 4.183 1.906 0 3.154-.695 3.908-1.88.496-.777.727-1.715.727-2.282v-.691a.5.5 0 0 1 1 0v.69c0 .746-.276 1.869-.883 2.821-.849 1.33-2.21 2.171-4.131 2.318zM12.005 2a3.5 3.5 0 0 1 3.5 3.5v6a3.5 3.5 0 0 1-7 0v-6a3.5 3.5 0 0 1 3.5-3.5zm0 1a2.5 2.5 0 0 0-2.5 2.5v6a2.5 2.5 0 1 0 5 0v-6a2.5 2.5 0 0 0-2.5-2.5z"
  })), props.children);
};
var MobileIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.13 20.006a.5.5 0 0 1-.001 1l-5.616-.001a1.51 1.51 0 0 1-1.51-1.51V4.501c0-.833.676-1.503 1.51-1.503L15.49 3c.834 0 1.51.67 1.51 1.503v16.004a.5.5 0 1 1-1 0V4.502A.504.504 0 0 0 15.49 4H8.513a.504.504 0 0 0-.51.502v14.994c0 .281.229.51.51.51h5.616zM11.25 18a.75.75 0 1 1 1.5-.002.75.75 0 0 1-1.5.002zM10.5 6a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1h-3z"
  })), props.children);
};
var MoneyDeliveryIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.91 16.844A4.001 4.001 0 0 1 2 16a4 4 0 0 1 2.156-3.55C2.289 11.447 1.263 9.082 2.77 7.414c1.221-1.35 4.527-.178 6.591 2.195 2.685-1.06 4.584-1.578 5.76-1.476l-.812-2.39a1.5 1.5 0 0 0-.864-.912l-2.17-.867a.5.5 0 0 1 .37-.928l2.17.866a2.5 2.5 0 0 1 1.441 1.519l.01.029a3.59 3.59 0 0 1 1.085-1.227 4.55 4.55 0 0 1 1.395-.704.5.5 0 0 1 .562.219c.885 1.438.867 2.799.295 3.947-.15.302-.304.52-.418.648a.5.5 0 0 1-.493.152 4.246 4.246 0 0 1-1.67-.806l.457 1.345c.023.06.043.118.06.178l.96 2.829a4 4 0 1 1-.972.248l-.325-.958c-1.398 1.002-2.334 2.015-2.947 3.055a7.35 7.35 0 0 0-.554 1.167c-.035.092-.249.706-.31.842-.162.368-.388.592-.776.569-.396-.024-1.013-.064-1.705-.11zM8.9 16.776a247.67 247.67 0 0 1-2.974-.214.5.5 0 0 1 .083-.997c.574.048 1.788.134 2.984.215a3 3 0 1 0-.093.996zm1.098-.928l1.496.096c.06-.155.23-.64.273-.754.173-.458.368-.879.629-1.32.208-.355.45-.706.726-1.052-.33.076-.672.126-1.023.148l-.028.001c-1.415.083-2.093-.172-2.517-.89a70.604 70.604 0 0 0 2.485-.11.5.5 0 1 1 .032 1 63.973 63.973 0 0 1-3.324.124 3.988 3.988 0 0 1 1.251 2.757zm5.548-6.466a.792.792 0 0 0-.03-.067c-.241-.475-2.165-.182-5.56 1.136.083.168.157.367.283.723.257.724.473.871 1.748.797l.052-.004c2.17-.133 3.808-1.54 3.532-2.511l-.025-.074zm1.305 3.846a3 3 0 1 0 .98-.223l1.143 3.368a.5.5 0 0 1-.947.321l-1.176-3.466zm.859-5.989c.38-.764.432-1.641-.053-2.62a3.87 3.87 0 0 0-.713.411c-.434.319-.75.704-.91 1.162.092.168.258.393.516.622.286.254.637.461 1.062.606.031-.053.064-.113.098-.18zM5.248 11.82c.782.222 2.224.31 4.305.258a3.264 3.264 0 0 1-.258-.57c-.183-.517-.23-.63-.375-.849a1.967 1.967 0 0 0-.108-.148c-1.71-2.146-4.58-3.221-5.299-2.426-1.12 1.24 0 3.244 1.735 3.735z"
  })), props.children);
};
var MoneyPoolsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.716 16c.159-.359.412-.634.79-.853l1.155-.73a.403.403 0 0 0-.065-.053l-1.681-1.302-.194-.15v-.532c-.225.077-.47.12-.732.12-.255 0-.492-.04-.71-.114v.526l-.194.15-1.68 1.302c-.232.149-.405.663-.405 1.257V16h3.716zm-.21 1H2.838C2.346 17 2 16.563 2 16.073v-.452c0-.9.276-1.72.827-2.073l1.452-1.126v-.73c-.51-.6-.779-1.455-.779-2.29C3.5 8.086 4.389 7 5.989 7 7.589 7 8.5 8.111 8.5 9.429c0 .816-.272 1.657-.779 2.252v.74l1.452 1.127c.125.08.24.192.343.33l.324-.206V12.11c-.61-.777-.913-1.897-.913-3.047 0-1.803.997-3.197 3.057-3.197S15.04 7.26 15.04 9.063c0 1.128-.29 2.227-.878 3.002v1.61l.379.242c.128-.152.276-.283.44-.387l1.397-1.12v-.642c-.566-.593-.878-1.467-.878-2.309C15.5 8.14 16.451 7 18.054 7c1.6 0 2.446 1.138 2.446 2.506 0 .9-.298 1.79-.878 2.362v.542l1.397 1.12c.612.389.981 1.137.981 1.943v.599c0 .49-.35.927-.843.927H17.48c.007.108.01.22.01.337v.592c0 .554-.416 1.027-.964 1.027H7.46c-.548 0-.965-.473-.965-1.027v-.592c0-.117.003-.229.01-.336zm10.751-1L21 15.999v-.526c0-.479-.21-.904-.56-1.13l-1.818-1.452v-.458a2.356 2.356 0 0 1-1.244-.033v.49l-1.817 1.453c-.061.04-.115.08-.162.124l1.046.67c.386.223.647.504.812.863zM7.5 9.429C7.5 8.624 6.988 8 5.989 8 4.99 8 4.5 8.598 4.5 9.403c0 1.035.595 2.097 1.489 2.097.902 0 1.511-1.056 1.511-2.071zm9 .03c0 .992.638 2.041 1.554 2.041.9 0 1.446-.96 1.446-1.994C19.5 8.637 19.027 8 18.054 8c-1.007 0-1.554.655-1.554 1.46zM13.162 12.9a2.687 2.687 0 0 1-1.178.258c-.426 0-.807-.086-1.144-.241v1.307l-.233.147-2.584 1.632c-.399.23-.527.56-.527 1.333v.592c0 .026 0 .027-.029.027h9.05c-.026 0-.027-.001-.027-.027v-.592c0-.756-.138-1.097-.565-1.345l-2.763-1.77v-1.32zM9.927 9.063c0 1.617.745 3.095 2.057 3.095 1.312 0 2.056-1.478 2.056-3.095 0-1.31-.635-2.197-2.056-2.197-1.422 0-2.057.888-2.057 2.197z"
  })), props.children);
};
var NotificationIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.885 11.513c0-3.479 2.452-6.411 5.602-6.694V3.007a.5.5 0 0 1 1 0v2.29a.5.5 0 0 1-.5.5c-2.806 0-5.102 2.583-5.102 5.716v2.765c0 .93-.583 2.048-1.343 2.58l-.102.054a.787.787 0 0 0-.193.125c-.108.092-.161.188-.161.297 0 .003.008.047.029.083.03.052.079.08.233.08h13.478c.153 0 .201-.028.231-.08a.266.266 0 0 0 .029-.083c0-.08-.054-.173-.167-.27a1.01 1.01 0 0 0-.218-.147l-.097-.057c-.741-.563-1.317-1.672-1.317-2.582v-2.765c0-2.298-1.316-4.345-3.265-5.194a.5.5 0 1 1 .4-.916c2.316 1.009 3.865 3.417 3.865 6.11v2.765c0 .576.404 1.368.885 1.756.116.06.258.15.402.274.312.27.512.61.512 1.026 0 .162-.04.367-.161.58-.208.363-.587.583-1.1.583H5.349c-.513 0-.892-.22-1.1-.583a1.17 1.17 0 0 1-.162-.58c0-.434.198-.788.509-1.055.146-.126.291-.213.411-.269.477-.358.879-1.144.879-1.732v-2.765zm7.861 8.565a.5.5 0 1 1 .887.462 2.832 2.832 0 0 1-.51.693c-.51.51-1.341.813-2.136.813-.769 0-1.522-.298-2.043-.812-.195-.194-.297-.354-.473-.696a.5.5 0 1 1 .889-.458c.13.254.188.345.287.443.33.325.83.523 1.34.523.544 0 1.119-.21 1.43-.52.132-.133.243-.283.33-.448z"
  })), props.children);
};
var NumberPadIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm5-12a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm5-17a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-1 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm1 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
  })), props.children);
};
var OffersRewardsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 6v3.5a.5.5 0 1 1-1 0V3.667C15 2.715 15.92 2 17 2c1.081 0 2 .715 2 1.667v1.346c.566.086 1 .575 1 1.165v6.71c0 .403-.16.79-.445 1.073l-7.694 7.694c-.46.46-1.205.46-1.666 0l-6.85-6.85a1.178 1.178 0 0 1 0-1.667l7.694-7.694C11.324 5.16 11.71 5 12.112 5h1.166a.5.5 0 1 1 0 1h-1.166a.518.518 0 0 0-.366.151l-7.694 7.695a.178.178 0 0 0 0 .252l6.85 6.85c.07.07.183.07.252 0l7.695-7.695a.516.516 0 0 0 .151-.365v-6.71A.179.179 0 0 0 18.822 6H16zm0-1h2V3.667C18 3.33 17.576 3 17 3c-.575 0-1 .33-1 .667V5z"
  })), props.children);
};
var OrderAheadIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.292 3.393a.372.372 0 0 0-.354.017.434.434 0 0 0-.212.338L9.391 8.51c-.01.142-.137.25-.289.247-.151-.003-.274-.116-.279-.257l-.15-4.9c0-.111-.07-.4-.44-.4-.406 0-.442.289-.442.4l-.15 4.9c-.004.141-.126.254-.277.257-.153.003-.28-.106-.29-.248l-.335-4.76a.433.433 0 0 0-.212-.34.372.372 0 0 0-.354-.016.325.325 0 0 0-.189.279l-.282 7.026c-.024.656.19 1.3.605 1.83L8 13.978V21H9.02v-7.022l1.138-1.45c.416-.53.629-1.174.605-1.83l-.282-7.026a.325.325 0 0 0-.19-.28zM10.02 21a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-6.562l-1.345-1.15-.136-.143a3.801 3.801 0 0 1-.817-2.487l.282-7.02c.016-.496.312-.933.754-1.146a1.37 1.37 0 0 1 1.413.134c.24-.258.599-.426 1.081-.426.464 0 .825.174 1.07.433a1.372 1.372 0 0 1 1.424-.142c.44.214.737.651.753 1.14l.282 7.03a3.794 3.794 0 0 1-.817 2.484l-.925 1.178V21zM17.51 3.06C15.5 6.062 15 12.983 15 12.983l2 1.501v6.533L18 21V3.219c0-.13-.084-.164-.197-.2-.113-.037-.189-.112-.292.042zM19 3.22V21a1 1 0 0 1-.984 1l-1 .016a1 1 0 0 1-1.016-1v-6.033l-1.6-1.201a1 1 0 0 1-.397-.872 42.523 42.523 0 0 1 .191-1.817c.172-1.355.405-2.71.708-3.983.458-1.93 1.037-3.5 1.779-4.606.192-.287.472-.494.853-.531.168-.016.314.005.454.048.055.017.108.038.14.051.507.168.872.48.872 1.147z"
  })), props.children);
};
var OverflowIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 5.005a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 5.005a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
  })), props.children);
};
var PayOnlineIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.366 2c.856 0 1.557.658 1.628 1.494l.006.141v15.73c0 .855-.656 1.557-1.493 1.629l-.14.006H1.633a1.634 1.634 0 0 1-1.628-1.494L0 19.365V3.635c0-.855.656-1.557 1.493-1.629L1.633 2h20.733zM23 7H1v12.365c0 .319.234.583.54.628l.094.007h20.732a.634.634 0 0 0 .627-.541l.007-.094V7zM12.517 8.387c.6 0 1.083.06 1.487.201.96.335 1.65 1.175 1.607 2.37l-.01.146.115.122c.445.509.579 1.134.469 1.884l-.033.19c-.319 1.636-1.36 2.509-3.05 2.576l-.214.004h-.193l-.307 1.916a.74.74 0 0 1-.626.616l-.108.008h-1.479a.596.596 0 0 1-.6-.584l.005-.11.034-.22-.088.009-1.194.002a.747.747 0 0 1-.746-.753l.01-.108 1.182-7.502a.906.906 0 0 1 .787-.76l.11-.007h2.842zm2.702 4.296l-.063.132c-.573 1.11-1.653 1.699-3.156 1.757l-.254.005h-.658l-.448 2.842h.795l.278-1.727a.963.963 0 0 1 .837-.805l.118-.007h.22c1.347 0 2.044-.547 2.283-1.77.022-.117.038-.226.045-.327l.003-.1zm-2.684-3.296l-.018.003-2.762-.001-1.123 7.125h.891c.075 0 .141.013.199.035l.04.019.373-2.363.047-.143.042-.086a.793.793 0 0 1 .582-.392l.106-.007h.834c1.512 0 2.39-.557 2.723-1.734l.048-.193.013-.071-.12-.041a1.961 1.961 0 0 0-.42-.079l-.151-.005-2.278-.001-.208 1.424a.5.5 0 0 1-.994-.054l.005-.09.224-1.534a.884.884 0 0 1 .77-.738l.119-.007h2.362c.211 0 .42.022.62.065l.125.031-.015-.076c-.105-.426-.391-.728-.775-.895l-.119-.046c-.24-.084-.554-.131-.952-.143l-.188-.003zM22.366 3H1.634a.634.634 0 0 0-.627.541L1 3.635V6h22V3.635a.635.635 0 0 0-.54-.628L22.366 3zM2.501 4a.5.5 0 1 1-.003 1.001A.5.5 0 0 1 2.501 4zm1.998 0a.501.501 0 1 1 0 1.002.501.501 0 0 1 0-1.002zM6.5 4a.5.5 0 1 1-.001 1.001A.5.5 0 0 1 6.5 4zm15 0a.5.5 0 1 1-.002 1.002A.5.5 0 0 1 21.5 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })), props.children);
};
var PendingPausedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.411 19.979a8 8 0 1 0-7.39-7.39 5.5 5.5 0 0 1 7.39 7.39zm-.596.932a5.5 5.5 0 1 1-7.723-7.728.501.501 0 0 1-.03-.12 9 9 0 1 1 7.861 7.874.502.502 0 0 1-.108-.026zM11 17.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0zm-3 2a.5.5 0 1 1-1 0v-4a.5.5 0 1 1 1 0v4zm-2 0a.5.5 0 1 1-1 0v-4a.5.5 0 1 1 1 0v4zm6.5-7.707l2.354 2.353a.5.5 0 0 1-.708.707l-2.5-2.5A.5.5 0 0 1 11.5 12V6.5a.5.5 0 1 1 1 0v5.293z"
  })), props.children);
};
var PendingIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.854 14.146a.5.5 0 0 1-.708.707l-2.5-2.5A.5.5 0 0 1 11.5 12V6.5a.5.5 0 1 1 1 0v5.293l2.354 2.353zM20 12a8 8 0 1 0-16.001.001A8 8 0 0 0 20 12zm1 0a9 9 0 1 1-18.001-.001A9 9 0 0 1 21 12z"
  })), props.children);
};
var PhoneIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.925 15.067a1.564 1.564 0 0 1 1.901 1.1l.619 2.244a1.57 1.57 0 0 1-1.1 1.929l-2.41.584a2.106 2.106 0 0 1-.934.06.5.5 0 1 1 .168-.987c.153.026.319.014.511-.04l2.41-.584a.566.566 0 0 0 .391-.695l-.62-2.246a.565.565 0 0 0-.686-.397l-2.384.614a.5.5 0 0 1-.285-.011c-.473-.16-1.129-.61-1.764-1.48a7.27 7.27 0 0 1-.977-1.917c-.516-1.49-.455-2.948-.042-4.26.122-.388.247-.675.335-.84a.5.5 0 0 1 .277-.236l2.297-.795a.568.568 0 0 0 .361-.684l-.548-2.023A.565.565 0 0 0 11.762 4l-2.207.616c-.23.06-.434.186-.592.364-1.325 1.496-1.922 4.675-.69 8.701.714 2.327 1.764 4.039 2.99 5.168a.5.5 0 1 1-.679.735c-1.358-1.252-2.502-3.117-3.266-5.61-1.333-4.35-.667-7.892.896-9.657.29-.326.666-.558 1.08-.666l2.207-.617a1.567 1.567 0 0 1 1.909 1.106l.548 2.024c.215.794-.22 1.62-.998 1.89l-2.1.727a5.217 5.217 0 0 0-.183.5c-.353 1.12-.405 2.367.033 3.631.228.66.513 1.208.84 1.656.298.41.613.711.924.923.094.065.174.112.236.145l2.215-.57z"
  })), props.children);
};
var PhotoIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm11.855 8.003a.147.147 0 0 0 .147-.147v-1.942l-5.611-5.541a.148.148 0 0 0-.21.002l-7.744 7.628h13.418zm-14.843 0l8.464-8.338a1.146 1.146 0 0 1 1.62-.001l5.757 5.685a.5.5 0 0 1 .149.356v2.15c0 .635-.514 1.148-1.147 1.148H3.138a1.148 1.148 0 0 1-1.148-1.147V6.154c0-.634.514-1.147 1.148-1.147h17.717c.633 0 1.147.513 1.147 1.147v5.297a.5.5 0 1 1-1 0V6.154a.147.147 0 0 0-.147-.147H3.138a.148.148 0 0 0-.148.147v11.702c0 .081.066.147.148.147h2.874z"
  })), props.children);
};
var PixIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.063 2.854a2.917 2.917 0 0 0-4.125 0L6.28 6.512h.347c.753 0 1.461.294 1.994.826l2.88 2.88c.209.21.548.209.757 0l2.89-2.89a2.804 2.804 0 0 1 1.995-.826h.567l-3.647-3.648zm.226 3.613l-2.41 2.41-2.398-2.4a4.06 4.06 0 0 0-.816-.63l2.133-2.133a1.701 1.701 0 0 1 2.405 0l2.042 2.043c-.35.186-.67.424-.956.71zm2.854 11.032a2.805 2.805 0 0 1-1.995-.826l-2.89-2.891a.55.55 0 0 0-.757 0l-2.88 2.88a2.804 2.804 0 0 1-1.994.826H6.28l3.658 3.658a2.918 2.918 0 0 0 4.125 0L17.71 17.5h-.567zm-3.94 2.787c-.321.32-.748.497-1.203.497-.455 0-.882-.176-1.202-.497l-2.133-2.132c.296-.173.569-.384.816-.632l2.399-2.398 2.409 2.41c.287.286.607.524.956.71l-2.042 2.042z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.557 8.15l2.19 2.188a2.918 2.918 0 0 1 0 4.125l-2.19 2.19h-1.414c-.52 0-1.028-.212-1.395-.579l-2.89-2.89c-.523-.522-1.434-.523-1.956 0l-2.88 2.88a1.987 1.987 0 0 1-1.396.578H5.433l-2.179-2.18a2.916 2.916 0 0 1 0-4.124l2.179-2.18h1.193c.52 0 1.029.212 1.396.58l2.88 2.88a1.38 1.38 0 0 0 1.954-.001l2.892-2.89a1.986 1.986 0 0 1 1.395-.578h1.414zm-.504 7.287l1.833-1.833c.322-.322.498-.748.498-1.204 0-.454-.176-.881-.498-1.202l-1.833-1.834h-.91c-.2 0-.395.081-.535.222L13.794 12.4l2.814 2.815c.14.14.336.222.535.222h.91zm-11.427-.012c.2 0 .395-.08.536-.221L9.966 12.4 7.163 9.598a.763.763 0 0 0-.537-.222h-.69l-1.822 1.823a1.702 1.702 0 0 0 0 2.406l1.823 1.821h.69z",
    clipRule: "evenodd"
  })), props.children);
};
var PlaySmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 8.87v6.26L14.385 12 9 8.87zm-.249-1.302l6.88 4a.5.5 0 0 1 0 .864l-6.88 4A.5.5 0 0 1 8 16V8a.5.5 0 0 1 .751-.432z"
  })), props.children);
};
var PlayIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.67 19.131a.5.5 0 0 1-.103.7A.981.981 0 0 1 7 19.043V5.008a1 1 0 0 1 1.534-.845l10.404 6.574a1.5 1.5 0 0 1 .007 2.532L14.02 16.42l-3.125 2a.5.5 0 1 1-.54-.842l3.125-2 4.926-3.153a.5.5 0 0 0-.002-.843L8 5.008v14a.5.5 0 0 1 .67.123z"
  })), props.children);
};
var PpCashCardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.955 9.502a.51.51 0 0 1 0-.02v-2.73c0-.992.805-1.798 1.798-1.798h16.503a1.8 1.8 0 0 1 1.799 1.799v.856a.5.5 0 0 1-1 0v-.856a.8.8 0 0 0-.8-.799H3.754a.799.799 0 0 0-.798.799v2.24h3.093a.5.5 0 0 1 0 1H2.955v7.144c0 .44.358.798.798.798h16.503a.8.8 0 0 0 .799-.798V9.915h-2.867a.5.5 0 0 1 0-1h3.367a.5.5 0 0 1 .5.5v7.722a1.8 1.8 0 0 1-1.8 1.798H3.754a1.799 1.799 0 0 1-1.798-1.798V9.502zm11.92-1.74c-.298-.104-.695-.156-1.21-.16a.506.506 0 0 1-.051.003H9.607L8.384 15.36H9.39c.116 0 .21.03.286.08l.41-2.602.049-.147a.816.816 0 0 1 .75-.496h.899c1.723 0 2.696-.67 3.02-2.085l.004-.022.018-.108a2.105 2.105 0 0 0-.788-.15h-2.486l-.23 1.567a.5.5 0 1 1-.99-.145l.243-1.652a.917.917 0 0 1 .919-.77h2.544c.296 0 .586.041.854.117-.092-.597-.483-.998-1.017-1.185zm-4.341 8.58l.142-.904c.327.215.28.796-.142.904zm-.046.29l.046-.29a.58.58 0 0 1-.143.017l-1.285.003a.766.766 0 0 1-.756-.884l1.274-8.082a.937.937 0 0 1 .929-.793h3.06c.643 0 1.16.064 1.591.214 1.064.372 1.818 1.328 1.695 2.691.621.606.781 1.38.594 2.342-.354 1.817-1.541 2.748-3.48 2.748h-.239l-.336 2.096a.76.76 0 0 1-.753.64H10.09a.615.615 0 0 1-.462-.212.62.62 0 0 1-.14-.49zm6.023-4.973a2.45 2.45 0 0 0 .052-.644c-.595 1.45-1.897 2.18-3.78 2.18h-.74l-.496 3.14h.936l.304-1.895a1 1 0 0 1 .99-.842h.237c1.47 0 2.237-.602 2.497-1.94zm-7.127 3.7h-.278c.069 0 .134.03.179.082a.237.237 0 0 1 .057.187l.042-.27z"
  })), props.children);
};
var PreferredSelectedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.525 3.022a.5.5 0 0 1 .95 0L14.6 9.464H21.5a.5.5 0 0 1 .355.853l-.068.057-5.572 3.902 2.13 6.387a.5.5 0 0 1-.688.61l-.075-.044-5.583-3.964-5.58 3.964a.5.5 0 0 1-.785-.48l.02-.086 2.13-6.387-5.57-3.902a.5.5 0 0 1 .198-.903l.088-.007h6.898z"
  })), props.children);
};
var PreferredIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.398 9.464H2.5l-.088.007a.5.5 0 0 0-.199.903l5.571 3.902-2.13 6.387-.02.085a.5.5 0 0 0 .784.481L12 17.265l5.583 3.964.075.045a.5.5 0 0 0 .688-.61l-2.13-6.388 5.572-3.902.068-.057a.5.5 0 0 0-.355-.853h-6.899l-2.126-6.442a.5.5 0 0 0-.95 0L9.398 9.464zM12 4.773l1.764 5.348.037.084a.5.5 0 0 0 .438.26l5.675-.001-4.577 3.207-.071.06a.5.5 0 0 0-.117.508l1.763 5.288-4.623-3.282-.077-.046a.5.5 0 0 0-.501.046l-4.624 3.282 1.764-5.288.02-.091a.5.5 0 0 0-.208-.477l-4.578-3.207h5.676a.5.5 0 0 0 .475-.343L12 4.773z"
  })), props.children);
};
var PrintIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 6.734V3.501a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v3.233h1.03c1.096 0 1.962.952 1.962 2.113l-.005 5.241c0 .839-.457 1.594-1.164 1.932a.5.5 0 1 1-.431-.903c.353-.168.595-.569.595-1.03l.005-5.24c0-.629-.44-1.113-.963-1.113H3.957c-.52 0-.963.488-.963 1.112l.005 5.242c0 .478.257.886.626 1.044a.5.5 0 1 1-.393.92C2.488 15.732 2 14.958 2 14.088l-.005-5.243c0-1.156.867-2.112 1.963-2.112H5zm1 0h12V4.001H6v2.733zm12 6.278V21.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-8.488h-.5a.5.5 0 1 1 0-1h13a.5.5 0 1 1 0 1H18zm-1 0H7V21h10v-7.988z"
  })), props.children);
};
var PurchaseProtectionAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.71.107a.442.442 0 0 1 .574-.003c.131.111 3.27 2.686 7.198 2.1a.442.442 0 0 1 .352.1.457.457 0 0 1 .16.333c.018.488.33 11.98-7.826 15.33a.443.443 0 0 1-.337 0C.776 14.659.99 3.15 1.003 2.661a.482.482 0 0 1 .16-.345.432.432 0 0 1 .354-.113C5.514 2.793 8.677.135 8.71.107zm3.075 5.694l-4.167 4.265-1.4-1.442a1 1 0 0 0-1.435 1.393l2.115 2.18a1 1 0 0 0 1.433.002l4.884-5a1 1 0 0 0-1.43-1.398z"
  })), props.children);
};
var QuestionAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1a8 8 0 1 1-.001 16 8 8 0 0 1 0-16zm-.941 13h2v-2h-2v2zm3.416-5.024A3.478 3.478 0 0 0 12.5 6.5c0-.935-.364-1.814-1.025-2.475a3.506 3.506 0 0 0-4.95 0l-.706.707 1.413 1.415.708-.707A1.501 1.501 0 0 1 10.5 6.5c0 .4-.156.778-.44 1.06C9.779 7.846 9.4 8 9 8H8v3h2V9.856a3.482 3.482 0 0 0 1.475-.88z"
  })), props.children);
};
var RecurringPausedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.808 20.92a5.5 5.5 0 1 1-7.728-7.727A9 9 0 0 1 19 6.34v-2.84a.5.5 0 1 1 1 0v3.977a.5.5 0 0 1-.5.5h-4a.5.5 0 1 1 0-1h2.728A8 8 0 0 0 4.022 12.59a5.5 5.5 0 0 1 7.39 7.389 8 8 0 0 0 8.53-8.949.5.5 0 1 1 .993-.12A9 9 0 0 1 10.808 20.92zM11 17.5A4.5 4.5 0 1 0 2 17.5a4.5 4.5 0 0 0 9 0zm-3 2a.5.5 0 1 1-1 0v-4a.5.5 0 1 1 1 0v4zm-2 0a.5.5 0 1 1-1 0v-4a.5.5 0 1 1 1 0v4z"
  })), props.children);
};
var RecurringIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 17.521V20a.5.5 0 1 1-1 0v-4a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1H5.965a7.53 7.53 0 0 0 13.509-5.413.5.5 0 0 1 .992-.12A8.53 8.53 0 0 1 5.5 17.52zM19.007 5.988v-2.48a.5.5 0 1 1 1 0v3.995a.5.5 0 0 1-.5.5h-4.005a.5.5 0 1 1 0-1h3.035a7.53 7.53 0 0 0-13.51 5.411.5.5 0 1 1-.993.12 8.53 8.53 0 0 1 14.973-6.546z"
  })), props.children);
};
var RefreshIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.228 6.977a8 8 0 1 0 1.714 4.052.5.5 0 1 1 .993-.12A9 9 0 0 1 12 20.999a9 9 0 0 1-9-9A9 9 0 0 1 19 6.34V3.5a.5.5 0 1 1 1 0v3.977a.5.5 0 0 1-.5.5h-4a.5.5 0 1 1 0-1h2.728z"
  })), props.children);
};
var RefundIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.983 17.224l-1.13 1.13a.5.5 0 1 1-.707-.708l2-2a.5.5 0 0 1 .707 0l2 2a.5.5 0 0 1-.706.707L7.983 17.19v1.299a1.5 1.5 0 0 0 1.5 1.5h.437c1.07 0 1.937-.867 1.937-1.937v-4.873a.5.5 0 0 1 1 0v4.873a2.937 2.937 0 0 1-2.937 2.937h-.437a2.5 2.5 0 0 1-2.5-2.5v-1.265zM20 3.924a28.24 28.24 0 0 1-1.498.271 28.73 28.73 0 0 1-4.39.353c-.958 0-1.63-.086-3.543-.401-3.02-.498-4.652-.562-6.569 0v8.619l.021-.005c1.394-.34 2.852-.365 4.246-.204.284.032.666.09.623.087a.5.5 0 0 1-.072.997c-.003 0-.416-.062-.666-.09-1.286-.149-2.633-.127-3.893.181-.206.05-.406.108-.6.173A.5.5 0 0 1 3 13.43V3.778a.5.5 0 0 1 .345-.475c2.268-.738 4.04-.694 7.387-.143 1.855.306 2.497.388 3.38.388 1.426 0 2.859-.127 4.237-.34a23.733 23.733 0 0 0 2.03-.397.5.5 0 0 1 .621.486v9.865a.5.5 0 0 1-.313.464 7.254 7.254 0 0 1-1.265.373c-1.137.232-2.335.246-3.449.132a8.496 8.496 0 0 1-.538-.07.5.5 0 0 1 .17-.985c.083.014.244.037.47.06 1.021.104 2.124.092 3.148-.117.272-.055.531-.124.777-.206v-8.89zm-8.111 2.04a2.722 2.722 0 1 1 0 5.444 2.722 2.722 0 0 1 0-5.445zm0 1a1.722 1.722 0 1 0 0 3.444 1.722 1.722 0 0 0 0-3.445z"
  })), props.children);
};
var RequestIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.922 4.036a.505.505 0 0 1 .006.065 49796.793 49796.793 0 0 1 .294 7.3.5.5 0 0 1-.393.51c-.145.03-.296.06-.458.087a.5.5 0 1 1-.166-.986l-.129-3.218-.13-3.243c-1.973-.186-3.704-.036-7.29.479h-.007c-3.93.565-5.698.702-7.971.44a.5.5 0 0 1 .114-.993c2.16.249 3.87.116 7.715-.436l.007-.001c3.923-.563 5.696-.7 7.969-.438a.5.5 0 0 1 .439.434zM11 14.45v5.006l1.688-1.347a.5.5 0 1 1 .624.782l-2.506 2a.5.5 0 0 1-.625 0l-2.494-2a.5.5 0 1 1 .626-.781L10 19.463V14.45a2.5 2.5 0 1 1 1 0zm-3.538.727a.5.5 0 0 1 .014 1c-1.882.027-3.622-.089-4.7-.364a.5.5 0 0 1-.377-.484V7.3a.5.5 0 0 1 .613-.487c.187.043.437.089.739.136.34.052 1.189.165 1.155.16 2.467.305 4.397.226 7.603-.157 3.478-.415 4.507-.471 6.088-.158a.5.5 0 0 1 .403.49v8.274a.5.5 0 0 1-.61.488c-1.567-.352-2.24-.377-4.388-.236a2.4 2.4 0 0 1-.232.001h-.009a1.998 1.998 0 0 0-.141 0 .5.5 0 0 1-.067-.998c.062-.005.117-.004.232-.002h.009c.087.002.123.003.142.001 1.947-.128 2.775-.123 4.064.13v-7.24c-1.243-.198-2.334-.12-5.372.243-3.28.391-5.28.474-7.86.155a72.469 72.469 0 0 1-1.37-.195v7.021c.996.19 2.478.273 4.064.25zM10.5 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM5.235 4.989a.5.5 0 0 1 1-.039c.015.4.026.632.035.704a.5.5 0 1 1-.994.116c-.013-.111-.024-.339-.041-.781z"
  })), props.children);
};
var ResolutionIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.337 4.44a4.82 4.82 0 0 1 4.74-.558L21 6.388v-.635a.5.5 0 0 1 .41-.492l.09-.008a.5.5 0 0 1 .492.41l.008.09v11a.5.5 0 0 1-.992.09l-.008-.09V16h-2c-.351 0-.58-.085-.795-.29l-.09-.095-6.353-7.182a.35.35 0 0 0-.38-.1l-.057.029-.001.001-.801.6a3.443 3.443 0 0 1-3.72.266l-.217-.118a1.08 1.08 0 0 1-.12-1.816zm4.351.363a3.82 3.82 0 0 0-3.757.443L7.058 8.1a.08.08 0 0 0 .007.134l.217.117c.84.461 1.873.388 2.641-.188l-.037.025.032-.028.729-.54.077-.057a.51.51 0 0 1 .007-.005l.005-.004a1.333 1.333 0 0 1 1.684.124l.09.092 6.354 7.183c.032.036.034.046.055.048l2.08-.001V7.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.253a.5.5 0 0 1 .492.41l.008.09L2.999 6H5a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L5 7H2.999L3 15.03h1.1c.057.001.112.008.165.021l.08.024c.13.046.229.11.357.213l.07.058.036.028 4.696 3.57c.178.136.38.234.595.289a.63.63 0 0 0 .722-.333l.036-.092.046-.148L8.19 15.98a.5.5 0 0 1-.062-.637l.058-.07a.5.5 0 0 1 .707-.004l3.104 3.066c.15.149.338.254.543.305a.717.717 0 0 0 .862-.503l.028-.099-2.6-2.75a.5.5 0 0 1 .659-.747l.067.06 3.004 3.178c.15.156.355.247.57.254a.67.67 0 0 0 .605-.342l.045-.097.115-.31-2.421-2.666a.5.5 0 0 1 .673-.734l.067.062 2.494 2.745a.693.693 0 0 0 .647.214l.077-.028.191-.153a.5.5 0 0 1 .692.716l-.065.063-.266.203c-.387.21-.828.252-1.231.14l-.035.095c-.25.674-.9 1.113-1.619 1.092-.314-.01-.618-.101-.884-.262a1.714 1.714 0 0 1-1.916.84 2.178 2.178 0 0 1-.594-.246 1.625 1.625 0 0 1-1.854.835 2.644 2.644 0 0 1-.777-.338l-.175-.122-4.693-3.569a3.822 3.822 0 0 1-.13-.104l-.028-.022-.02-.015H3v.722a.5.5 0 0 1-.992.09L2 16.752v-11a.5.5 0 0 1 .5-.5z"
  }))), props.children);
};
var RocketIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.862 15.837l-.73-.734a.5.5 0 0 1-.114-.525c1.334-3.617 3.168-6.338 5.38-8.27 1.666-1.455 3.453-2.386 5.25-2.895 1.127-.32 2.047-.423 2.654-.412h.022a.5.5 0 0 1 .255.08l.195.126a.5.5 0 0 1 .228.41v.01c.006.575-.101 1.48-.427 2.605-.528 1.818-1.485 3.63-2.975 5.316-1.945 2.2-4.662 4.028-8.256 5.36a.5.5 0 0 1-.528-.115l-.728-.732-.226-.224zm.206-1.211l.5.503.226.224.503.505c3.292-1.265 5.774-2.958 7.553-4.972 1.39-1.572 2.277-3.251 2.764-4.933.231-.797.34-1.463.375-1.947-.51.024-1.22.129-2.068.369-1.66.47-3.315 1.333-4.865 2.686-2.023 1.767-3.722 4.252-4.988 7.565zm4.307 3.493c1.144-1.28 1.694-2.684 1.367-4.16a.5.5 0 0 1 .977-.216c.407 1.841-.26 3.544-1.598 5.042-.366.41-.758.775-1.15 1.09-.238.19-.425.325-.538.398a.5.5 0 0 1-.745-.581c.402-1.186.304-2.151-.094-2.915a2.01 2.01 0 0 0-.312-.462.5.5 0 1 1 .703-.712c.136.135.318.372.496.712a4.2 4.2 0 0 1 .453 2.262c.15-.145.298-.298.441-.458zm-4.873-5.795c.34.178.576.361.71.498a.5.5 0 0 1-.714.7 2.001 2.001 0 0 0-.46-.312c-.76-.4-1.722-.498-2.902-.095a.5.5 0 0 1-.583-.743c.073-.113.206-.301.396-.54a9.658 9.658 0 0 1 1.087-1.154c1.493-1.342 3.192-2.012 5.03-1.603a.5.5 0 0 1-.218.976c-1.47-.327-2.868.224-4.144 1.371a8.429 8.429 0 0 0-.46.447c.85-.06 1.608.114 2.258.455zm-.684 5.424L3.864 20.71c-.47.472-1.179-.234-.708-.706l2.954-2.963c.47-.472 1.179.234.708.706zm-.67-2.11l-2.052 2.057c-.471.472-1.18-.234-.708-.706l2.051-2.057c.471-.472 1.18.234.708.706zM8.92 18.42l-2.05 2.057c-.471.472-1.18-.234-.709-.706l2.051-2.057c.471-.472 1.18.234.708.706zm6.96-8.355a2.079 2.079 0 1 1 0-4.157 2.079 2.079 0 0 1 0 4.157zm0-1a1.079 1.079 0 1 0 0-2.157 1.079 1.079 0 0 0 0 2.157z"
  })), props.children);
};
var ScanToSendIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 3v2.954H2V2.5a.5.5 0 0 1 .5-.5h3.454v1H3zm0 18h3v1H2.5a.5.5 0 0 1-.5-.5V18h1v3zM21 3h-3V2h3.5a.5.5 0 0 1 .5.5V6h-1V3zm0 18v-3h1v3.5a.5.5 0 0 1-.5.5H18v-1h3zM6 6v4h4V6H6zm-.5-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zm.5 9v4h4v-4H6zm-.5-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zM14 6v4h4V6h-4zm-.5-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zM15 7h2v2h-2V7zM7 7h2v2H7V7zm0 8h2v2H7v-2zm8.436-.715a.353.353 0 0 0-.193.264l-.59 3.79h-.997a.158.158 0 0 1-.154-.183l.756-4.883a.261.261 0 0 1 .257-.223h1.691c.626 0 1.11.138 1.386.448.187.212.296.488.267.884l-.055-.02a1.648 1.648 0 0 0-.178-.05 3.039 3.039 0 0 0-.616-.061h-1.424a.34.34 0 0 0-.15.034zm2.293.307c.033.012.066.024.097.038a3.127 3.127 0 0 1-.095.367c-.19.594-.57.968-1.134 1.133a2.704 2.704 0 0 1-.758.097h-.533a.447.447 0 0 0-.082.008l.24-1.546a.23.23 0 0 1 .224-.195h1.322a2.799 2.799 0 0 1 .564.055 1.545 1.545 0 0 1 .155.043zm.49.282c.194.225.252.534.209.9-.005.034-.01.067-.017.1-.21 1.094-.926 1.473-1.842 1.473h-.141a.229.229 0 0 0-.225.196l-.199 1.262a.229.229 0 0 1-.224.195h-.82c-.076 0-.148-.069-.135-.153.015-.107.333-2.143.333-2.143a.26.26 0 0 1 .255-.223l.409.001c1.648 0 2.087-1.021 2.235-1.747a.83.83 0 0 1 .161.139z"
  })), props.children);
};
var SearchIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.85 20.145l-.206-.204a944.952 944.952 0 0 1-2.198-2.174l-.03-.03c-1.309-1.3-2.177-2.174-2.322-2.343-.223-.261-.252-.756-.074-1.042a7.64 7.64 0 0 0 1.056-3.906c0-4.148-3.015-7.446-6.93-7.446-3.952 0-7.147 3.339-7.147 7.446 0 4.107 3.195 7.445 7.146 7.445a6.91 6.91 0 0 0 3.236-.801.5.5 0 0 0-.467-.885 5.91 5.91 0 0 1-2.769.686C6.757 16.891 4 14.011 4 10.446 4 6.881 6.757 4 10.145 4c3.343 0 5.931 2.831 5.931 6.446 0 1.22-.317 2.384-.91 3.388-.4.64-.343 1.612.169 2.21.172.202 1.019 1.054 2.376 2.402l.03.03a846.815 846.815 0 0 0 2.2 2.177l.207.204a.5.5 0 0 0 .702-.712z"
  })), props.children);
};
var SecurityCodeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.491 12a2.5 2.5 0 0 1 2.5 2.5v.52l.011.001a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 .99-1V14.5a2.5 2.5 0 0 1 2.5-2.5zm.009-9.018a1.5 1.5 0 0 1 1.493 1.356l.007.144v5.555a.5.5 0 0 1-.992.09l-.008-.09V4.482a.5.5 0 0 0-.41-.491l-.09-.009h-15a.5.5 0 0 0-.492.41L3 4.483V14.5a.5.5 0 0 0 .41.492L3.5 15h10a.5.5 0 0 1 .09.992L13.5 16h-10a1.5 1.5 0 0 1-1.493-1.356L2 14.5V4.482A1.5 1.5 0 0 1 3.356 2.99l.144-.007h15zM18.491 13a1.5 1.5 0 0 0-1.493 1.356l-.007.144v.52h3v-.52a1.5 1.5 0 0 0-1.355-1.493L18.49 13zM6.51 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM11 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm4.491 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
  })), props.children);
};
var SendIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.056 19.45c1.972.185 3.703.035 7.288-.48h.007c3.588-.516 5.375-.675 7.389-.5-.004-.059-.007-.1-.01-.124a.5.5 0 0 1 .994-.116c.013.111.024.339.04.781a.5.5 0 0 1-.618.505c-2.131-.239-3.845-.104-7.653.443l-.007.001c-3.923.563-5.696.7-7.969.438a.5.5 0 0 1-.443-.48 49807.036 49807.036 0 0 1-.293-7.301.5.5 0 0 1 .392-.509c.145-.032.297-.06.459-.088a.5.5 0 0 1 .166.986l.129 3.219.13 3.224zM13 9.55V4.544L11.312 5.89a.5.5 0 1 1-.624-.782l2.454-1.958A.499.499 0 0 1 13.503 3a.5.5 0 0 1 .316.11l2.494 2a.5.5 0 0 1-.626.78L14 4.537V9.55a2.5 2.5 0 1 1-1 0zm7.601-.463c-.995-.19-2.477-.273-4.063-.25a.5.5 0 1 1-.014-1c1.882-.027 3.622.089 4.7.363a.5.5 0 0 1 .377.485v8.028a.5.5 0 0 1-.613.487 10.688 10.688 0 0 0-.739-.136 75.68 75.68 0 0 0-1.155-.16c-2.467-.306-4.397-.226-7.603.157-3.478.415-4.507.47-6.088.158a.5.5 0 0 1-.403-.49V8.454a.5.5 0 0 1 .61-.488c1.567.351 2.24.377 4.388.235a2.4 2.4 0 0 1 .232 0h.009c.08.002.12.002.141 0a.5.5 0 1 1 .067.998 2.427 2.427 0 0 1-.232.001h-.009a2.138 2.138 0 0 0-.142 0C8.117 9.327 7.29 9.322 6 9.07v7.24c1.243.198 2.334.12 5.372-.243 3.28-.392 5.28-.474 7.86-.155a72.468 72.468 0 0 1 1.37.195V9.087zM13.5 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  })), props.children);
};
var SettingsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.623 10.621a.5.5 0 0 1 .326.416 8.84 8.84 0 0 1-.01 1.985.5.5 0 0 1-.333.413l-1.935.67c-.124.394-.281.774-.471 1.137l.874 1.88a.5.5 0 0 1-.065.526c-.421.52-.894.988-1.411 1.396a.5.5 0 0 1-.528.057l-1.84-.895a6.977 6.977 0 0 1-1.138.469l-.713 1.949a.5.5 0 0 1-.416.325 8.908 8.908 0 0 1-1.984-.01.5.5 0 0 1-.415-.333l-.67-1.936A6.954 6.954 0 0 1 8.76 18.2l-1.881.874a.5.5 0 0 1-.525-.064 8.863 8.863 0 0 1-1.397-1.41.5.5 0 0 1-.057-.529l.895-1.84a6.928 6.928 0 0 1-.469-1.139l-1.949-.712a.5.5 0 0 1-.325-.416 8.908 8.908 0 0 1 .01-1.984.5.5 0 0 1 .333-.414l1.936-.67c.124-.394.281-.774.471-1.137l-.874-1.881a.5.5 0 0 1 .065-.525 8.952 8.952 0 0 1 1.41-1.395.5.5 0 0 1 .528-.058l1.84.895a6.96 6.96 0 0 1 1.138-.468l.714-1.95a.5.5 0 0 1 .417-.326 8.966 8.966 0 0 1 1.982.01.5.5 0 0 1 .414.334l.67 1.936c.394.124.774.282 1.137.471l1.881-.874a.5.5 0 0 1 .524.064c.514.414.983.887 1.396 1.409a.5.5 0 0 1 .057.529l-.894 1.841c.188.363.345.744.468 1.139l1.95.712zm-.642.83l-1.887-.69a.5.5 0 0 1-.311-.338 5.959 5.959 0 0 0-.574-1.392.5.5 0 0 1-.015-.466l.867-1.785a7.902 7.902 0 0 0-.805-.812l-1.822.847a.5.5 0 0 1-.459-.02 5.965 5.965 0 0 0-1.39-.576.5.5 0 0 1-.341-.319l-.65-1.876a7.968 7.968 0 0 0-1.142-.006l-.691 1.888a.5.5 0 0 1-.338.31c-.49.134-.958.328-1.391.575a.5.5 0 0 1-.467.015L6.781 5.94c-.289.248-.56.517-.813.805l.846 1.822a.5.5 0 0 1-.02.459c-.248.434-.44.9-.575 1.39a.5.5 0 0 1-.32.341l-1.875.649c-.03.381-.032.763-.006 1.144l1.888.69a.5.5 0 0 1 .31.338c.135.493.327.959.574 1.39a.5.5 0 0 1 .016.468l-.867 1.784c.248.29.518.562.805.813l1.822-.846a.5.5 0 0 1 .46.02c.431.247.898.44 1.39.575a.5.5 0 0 1 .34.32l.649 1.875c.38.03.763.032 1.144.006l.69-1.888a.5.5 0 0 1 .339-.31c.49-.134.956-.327 1.391-.575a.5.5 0 0 1 .466-.015l1.784.867c.288-.247.56-.516.814-.806l-.847-1.82a.5.5 0 0 1 .02-.46c.249-.434.442-.9.575-1.39a.5.5 0 0 1 .319-.341l1.876-.649c.03-.38.032-.762.005-1.144zM12.001 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1A3 3 0 1 1 12 9a3 3 0 0 1 0 6z"
  })), props.children);
};
var ShareEmailIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm5 7.976l-5 3.238-5-3.238v4.441c0 .32.27.583.6.583h8.8c.33 0 .6-.262.6-.583v-4.441zM16.4 8H7.6c-.33 0-.6.262-.6.583v1.299c.065 0 .13.012.192.038l.08.042L12 13.022l4.728-3.06.088-.045A.497.497 0 0 1 17 9.882v-1.3c0-.32-.27-.582-.6-.582z"
  })), props.children);
};
var ShareFacebookIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 12a9 9 0 1 0-10.406 8.89v-6.288H8.309V12h2.285v-1.983c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V12h2.496l-.399 2.602h-2.097v6.289C17.71 20.215 21 16.492 21 12"
  })), props.children);
};
var ShareInstagramIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.656 3.09c.954.043 1.606.195 2.176.416.59.23 1.089.535 1.587 1.034.498.498.805.998 1.034 1.587.221.57.373 1.221.416 2.175.039.841.051 1.179.054 2.906v1.578c-.003 1.728-.015 2.065-.054 2.906-.043.954-.195 1.605-.416 2.175a4.392 4.392 0 0 1-1.034 1.588 4.393 4.393 0 0 1-1.587 1.033c-.57.222-1.222.373-2.176.417-.84.038-1.178.05-2.905.053h-1.578c-1.728-.002-2.065-.015-2.906-.053-.954-.044-1.606-.195-2.176-.417a4.393 4.393 0 0 1-1.587-1.033 4.393 4.393 0 0 1-1.034-1.588c-.221-.57-.373-1.221-.416-2.175a42.371 42.371 0 0 1-.052-2.21V10.77a45.3 45.3 0 0 1 .052-2.468c.043-.954.195-1.605.416-2.175A4.393 4.393 0 0 1 4.504 4.54a4.392 4.392 0 0 1 1.587-1.034c.57-.221 1.222-.373 2.176-.416a42.375 42.375 0 0 1 2.21-.052l2.712-.001a45.3 45.3 0 0 1 2.467.053zm-2.443 1.562h-2.25c-1.502.002-1.829.014-2.623.05-.873.04-1.348.186-1.664.31a2.776 2.776 0 0 0-1.03.67 2.777 2.777 0 0 0-.67 1.03c-.123.316-.27.79-.31 1.664-.033.747-.046 1.08-.05 2.37v2.25c.003 1.502.015 1.829.05 2.622.04.874.187 1.349.31 1.664.162.419.356.717.67 1.03.313.314.612.509 1.03.671.316.123.79.269 1.664.309.794.036 1.12.048 2.624.051h1.996c1.502-.003 1.83-.015 2.623-.051.874-.04 1.348-.186 1.664-.309a2.776 2.776 0 0 0 1.03-.67c.314-.314.508-.612.67-1.03.123-.316.27-.79.31-1.665.035-.793.048-1.12.05-2.623V11c-.002-1.502-.015-1.83-.05-2.623-.04-.874-.187-1.348-.31-1.664a2.777 2.777 0 0 0-.67-1.03 2.777 2.777 0 0 0-1.03-.67c-.316-.124-.79-.27-1.664-.31a43.486 43.486 0 0 0-2.37-.05zm-1.251 2.743a4.602 4.602 0 1 1 0 9.204 4.602 4.602 0 0 1 0-9.204zm0 1.615a2.987 2.987 0 1 0 0 5.974 2.987 2.987 0 0 0 0-5.974zm4.783-2.872a1.075 1.075 0 1 1 0 2.15 1.075 1.075 0 0 1 0-2.15z"
  })), props.children);
};
var ShareLineIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.1 3A3.9 3.9 0 0 1 21 6.9v10.2a3.9 3.9 0 0 1-3.9 3.9H6.9A3.9 3.9 0 0 1 3 17.1V6.9A3.9 3.9 0 0 1 6.9 3h10.2zm-5.13 2.89c-3.613 0-6.553 2.386-6.553 5.318 0 2.63 2.332 4.831 5.481 5.248.214.046.504.14.577.323.067.165.044.425.022.592l-.094.561c-.029.166-.132.648.568.354.7-.295 3.774-2.223 5.15-3.805h-.001c.95-1.042 1.404-2.099 1.404-3.273 0-2.932-2.94-5.318-6.553-5.318zm-1.33 3.901c.07 0 .127.058.127.128v2.855c0 .07-.057.128-.128.128h-.46a.128.128 0 0 1-.127-.128V9.92c0-.07.057-.128.127-.128zm1.172.001h.007l.005.002.008.001.004.001.004.001.004.002.011.004.004.002.007.004.007.005.003.002.01.008.01.01.001.001a.14.14 0 0 1 .01.013l1.309 1.767V9.92c0-.07.057-.128.128-.128h.46c.07 0 .127.058.127.128v2.855c0 .07-.057.128-.128.128h-.46a.121.121 0 0 1-.032-.005.11.11 0 0 1-.01-.003l-.004-.001-.013-.006a.167.167 0 0 1-.013-.008.129.129 0 0 1-.032-.031l-1.31-1.77v1.696c0 .07-.057.128-.128.128h-.46a.128.128 0 0 1-.127-.128V9.92c0-.07.057-.128.127-.128zm-3.658 0c.07 0 .128.056.128.127v2.268h1.25c.07 0 .127.057.127.128v.46c0 .07-.057.127-.128.127H7.695l-.033-.004a.129.129 0 0 1-.056-.032.13.13 0 0 1-.039-.092V9.92c0-.07.057-.128.128-.128zm8.188 0c.07 0 .127.057.127.127v.46c0 .07-.057.127-.127.127h-1.249v.483h1.249c.07 0 .127.057.127.128v.46c0 .07-.057.127-.127.127h-1.249v.483h1.249c.07 0 .127.057.127.128v.46c0 .07-.057.127-.127.127h-1.836l-.034-.004a.129.129 0 0 1-.094-.123V9.918a.127.127 0 0 1 .037-.09l.002-.002a.127.127 0 0 1 .088-.036z"
  })), props.children);
};
var ShareLinkIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm1.498 8.263a.5.5 0 1 0-.91.415 1.5 1.5 0 0 1-.304 1.683l-2.357 2.357-.107.097a1.5 1.5 0 0 1-2.015-2.218l.972-.972.058-.07a.5.5 0 0 0-.765-.638l-.972.973-.112.12a2.5 2.5 0 0 0 3.648 3.415l2.357-2.357.125-.135a2.5 2.5 0 0 0 .382-2.67zm3.264-3.559a2.5 2.5 0 0 0-3.535 0l-2.357 2.357-.121.13a2.5 2.5 0 0 0-.363 2.726.5.5 0 0 0 .9-.435 1.5 1.5 0 0 1 .29-1.714l2.358-2.357.107-.097a1.5 1.5 0 0 1 2.014 2.218l-1.41 1.41-.058.07a.5.5 0 0 0 .765.638l1.41-1.41.113-.12a2.5 2.5 0 0 0-.113-3.416z"
  })), props.children);
};
var ShareLinkedinIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.6 3a1.311 1.311 0 0 1 1.319 1.158l.008.134v15.341a1.312 1.312 0 0 1-1.194 1.289l-.134.005H4.323a1.31 1.31 0 0 1-1.315-1.16L3 19.633V4.293a1.308 1.308 0 0 1 1.19-1.287l.133-.005h15.276V3zM8.316 9.72h-2.66v8.555h2.66V9.72zm6.77-.212a2.794 2.794 0 0 0-2.516 1.381h-.035V9.72h-2.55v8.554h2.656v-4.231c0-1.116.212-2.197 1.595-2.197 1.364 0 1.382 1.277 1.382 2.269v4.16h2.656l.001-4.693c0-2.304-.496-4.074-3.189-4.074zm-8.1-4.04a1.542 1.542 0 1 0 .002 3.083 1.542 1.542 0 0 0-.001-3.083z"
  })), props.children);
};
var ShareMessengerIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.991 3.018c5.065 0 8.99 3.71 8.99 8.721 0 5.012-3.925 8.722-8.99 8.722-.91 0-1.784-.12-2.603-.346a.717.717 0 0 0-.48.037l-1.783.786a.72.72 0 0 1-1.01-.636l-.049-1.6a.724.724 0 0 0-.242-.511C4.074 16.626 3 14.36 3 11.739c0-5.01 3.926-8.72 8.991-8.72zm5.398 6.712c.255-.402-.24-.856-.619-.568l-2.836 2.152a.54.54 0 0 1-.65.002l-2.1-1.576a1.35 1.35 0 0 0-1.95.36l-2.641 4.19c-.255.402.24.856.618.568l2.837-2.152a.54.54 0 0 1 .65-.002l2.1 1.575a1.35 1.35 0 0 0 1.95-.36z"
  })), props.children);
};
var ShareMobileIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm2.326 3H9.674l-.127.007c-.588.061-1.046.542-1.046 1.13v9.722l.007.124a1.162 1.162 0 0 0 1.166 1.016l4.652.001.141-.006c.644-.054 1.034-.478 1.032-1.137v-9.72l-.007-.124c-.064-.571-.562-1.012-1.166-1.012zM12 16a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm2.325-8l.055.006c.07.015.118.058.118.109v6.812c-.003.062-.02.072-.116.073H9.673l-.054-.006c-.07-.016-.119-.06-.119-.111V8.114l.009-.036C9.53 8.033 9.595 8 9.673 8h4.652z"
  })), props.children);
};
var ShareSnapchatIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.687 17.302c-.87.481-1.45.43-1.9.72-.383.246-.156.777-.434.969-.342.236-1.351-.017-2.656.414-1.075.355-1.761 1.378-3.696 1.378-1.935 0-2.605-1.02-3.698-1.381-1.302-.43-2.314-.178-2.656-.414-.277-.192-.052-.723-.434-.969-.45-.29-1.03-.238-1.9-.717-.555-.306-.24-.495-.055-.585 3.155-1.528 3.658-3.886 3.68-4.061.028-.212.058-.379-.175-.594-.226-.208-1.226-.827-1.504-1.021-.459-.32-.66-.641-.512-1.035.104-.272.358-.375.625-.375.084 0 .168.01.25.029.504.109.994.361 1.276.43a.447.447 0 0 0 .105.014c.15 0 .204-.076.193-.25-.032-.55-.11-1.625-.023-2.63.12-1.381.564-2.066 1.093-2.671C8.52 4.262 9.714 3 11.997 3s3.48 1.256 3.734 1.546c.53.606.975 1.29 1.094 2.672.087 1.005.012 2.08-.024 2.63-.012.182.043.25.194.25.035-.001.07-.006.104-.015.283-.068.773-.32 1.277-.43.082-.018.166-.027.25-.028.268 0 .52.104.625.375.149.394-.052.714-.512 1.035-.277.193-1.278.812-1.503 1.02-.234.216-.203.383-.176.595.022.177.525 2.536 3.681 4.06.186.094.5.283-.054.592"
  })), props.children);
};
var ShareTwitterIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.66 19.265c6.794 0 10.508-5.627 10.508-10.507 0-.16-.003-.32-.01-.478A7.513 7.513 0 0 0 21 6.368a7.374 7.374 0 0 1-2.12.582 3.706 3.706 0 0 0 1.623-2.043 7.4 7.4 0 0 1-2.345.896 3.694 3.694 0 0 0-6.293 3.368 10.484 10.484 0 0 1-7.612-3.858 3.69 3.69 0 0 0 1.143 4.93 3.666 3.666 0 0 1-1.673-.462v.047a3.695 3.695 0 0 0 2.962 3.62 3.704 3.704 0 0 1-1.667.064 3.697 3.697 0 0 0 3.45 2.565 7.41 7.41 0 0 1-4.587 1.58c-.298 0-.592-.016-.881-.05a10.455 10.455 0 0 0 5.66 1.658"
  })), props.children);
};
var ShareWechatIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.595 9.622c2.994 0 5.405 2.01 5.405 4.504 0 1.347-.723 2.574-1.869 3.398-.1.06-.16.16-.14.302 0 .04 0 .08.02.12.08.342.24.885.24.905 0 .06.02.1.02.14 0 .101-.08.182-.18.182-.04 0-.06-.02-.1-.04l-1.186-.684a.654.654 0 0 0-.281-.08c-.06 0-.12 0-.161.02a6.367 6.367 0 0 1-1.768.24c-2.994 0-5.405-2.01-5.405-4.503 0-2.493 2.41-4.504 5.405-4.504zm-6.09-4.986c3.155 0 5.795 1.862 6.362 4.348l.043.208h-.363c-3.263 0-5.921 2.208-5.921 4.918 0 .369.052.725.144 1.069l.078.255h-.363c-.725 0-1.45-.12-2.115-.3-.06-.02-.12-.02-.18-.02a.652.652 0 0 0-.264.058l-.08.042-1.43.822c-.04.02-.08.04-.12.04-.12 0-.222-.1-.222-.22 0-.06.02-.1.04-.16.02-.02.202-.683.303-1.085 0-.04.02-.1.02-.14 0-.16-.08-.281-.181-.361C3.866 13.126 3 11.66 3 10.035c0-2.99 2.92-5.399 6.505-5.399zm7.874 7.295a.732.732 0 0 0-.735.735c0 .408.327.734.735.734a.745.745 0 0 0 .735-.734.732.732 0 0 0-.735-.735zm-3.621 0a.732.732 0 0 0-.735.735c0 .408.327.734.735.734a.745.745 0 0 0 .735-.734.732.732 0 0 0-.735-.735zm-2.152-4.46a.833.833 0 0 0-.84.839c0 .468.372.84.84.84.47 0 .84-.391.84-.84a.833.833 0 0 0-.84-.84zm-4.303 0a.833.833 0 0 0-.84.839c0 .468.372.84.84.84.469 0 .84-.391.84-.84a.833.833 0 0 0-.84-.84z"
  })), props.children);
};
var ShareWhatsappIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.057 13.783c-.223-.111-1.318-.65-1.522-.724-.205-.075-.353-.112-.502.111-.148.223-.575.725-.705.874-.13.148-.26.167-.483.055-.223-.111-.94-.346-1.792-1.105-.662-.591-1.11-1.32-1.24-1.544-.129-.223-.013-.343.099-.455.1-.1.222-.26.334-.39.111-.13.148-.223.223-.372.074-.148.037-.278-.019-.39-.056-.111-.501-1.208-.687-1.654-.18-.435-.364-.376-.501-.383a8.936 8.936 0 0 0-.427-.008.819.819 0 0 0-.594.28c-.205.222-.78.761-.78 1.858s.798 2.156.91 2.305c.111.148 1.57 2.399 3.806 3.364.531.23.946.367 1.27.47.534.169 1.02.145 1.403.088.428-.064 1.318-.54 1.504-1.06.186-.52.186-.966.13-1.06-.056-.092-.204-.148-.427-.26m-4.065 5.551h-.003a7.4 7.4 0 0 1-3.772-1.033l-.271-.16-2.805.735.749-2.735-.177-.28a7.394 7.394 0 0 1-1.133-3.944c.002-4.087 3.327-7.411 7.415-7.411 1.98 0 3.84.773 5.24 2.173a7.367 7.367 0 0 1 2.168 5.244c-.002 4.086-3.326 7.411-7.411 7.411m6.307-13.719A8.859 8.859 0 0 0 11.992 3c-4.915 0-8.915 4-8.917 8.916 0 1.572.41 3.106 1.19 4.458L3 20.994l4.727-1.24a8.91 8.91 0 0 0 4.261 1.086h.004c4.914 0 8.915-4 8.917-8.917a8.863 8.863 0 0 0-2.61-6.308"
  })), props.children);
};
var ShareIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.219 4a.5.5 0 0 1 .846-.36l7.031 6.75a.5.5 0 0 1 0 .72l-7.031 6.75a.5.5 0 0 1-.846-.36v-3.244c-4.806.108-8.397 1.788-10.818 5.042-.32.43-1 .124-.89-.4C3.773 12.834 7.766 8.371 14.219 7.32V4zm1 1.173V7.75a.5.5 0 0 1-.432.495c-5.49.753-9.115 4.073-10.737 8.804 2.63-2.532 6.195-3.799 10.669-3.799a.5.5 0 0 1 .5.5v2.577l5.809-5.577-5.81-5.577z"
  })), props.children);
};
var ShieldIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 8v9.5a.5.5 0 1 1-1 0v-10A.5.5 0 0 1 12 7h8.202a.5.5 0 0 1 .496.56c-.02.178-.044.348-.068.513-.806 5.458-3.983 10.62-8.403 12.872a.5.5 0 0 1-.454 0C6.549 18.285 3 11.669 3 5.5a.5.5 0 0 1 .5-.5c2.963 0 6.749-1.238 8.082-2.38a.5.5 0 0 1 .65 0C13.6 3.79 17.328 5 20.5 5a.5.5 0 1 1 0 1c-3.182 0-6.858-1.127-8.594-2.367-1.618 1.15-5.013 2.238-7.898 2.356C4.186 11.57 7.39 17.452 12 19.935c3.969-2.143 6.864-6.897 7.63-11.935H12.5z"
  })), props.children);
};
var ShippingLabelIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16zm0 1H4v16h16V4zM9.002 15.033a1 1 0 0 1 .993.883l.007.117v1a1 1 0 0 1-1.993.117l-.007-.117v-1a1 1 0 0 1 1-1zm4.989 0a1 1 0 0 1 .993.883l.007.117v1a1 1 0 0 1-1.993.117l-.007-.117v-1a1 1 0 0 1 1-1zm2.509.037a.5.5 0 0 1 .492.41l.008.09v1.926a.5.5 0 0 1-.992.09l-.008-.09V15.57a.5.5 0 0 1 .5-.5zm-10 0a.5.5 0 0 1 .492.41l.008.09v1.926a.5.5 0 0 1-.992.09L6 17.496V15.57a.5.5 0 0 1 .5-.5zm5.011 0a.5.5 0 0 1 .492.41l.008.09v1.926a.5.5 0 0 1-.992.09l-.008-.09V15.57a.5.5 0 0 1 .5-.5zM16 9a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm-5.5 2.999a.5.5 0 0 1 .09.992l-.09.008h-4a.5.5 0 0 1-.09-.992l.09-.008h4zM16 10h-2v2h2v-2zm-5.5-1.001a.5.5 0 0 1 .09.992l-.09.008h-4a.5.5 0 0 1-.09-.992l.09-.008h4zM16.5 6a.5.5 0 0 1 .09.992L16.5 7h-10a.5.5 0 0 1-.09-.992L6.5 6h10z"
  })), props.children);
};
var ShippingPackIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.932c.141 0 .274.059.368.162l.051.066 1.577 2.428 1.61-2.432a.499.499 0 0 1 .318-.214l.099-.01h3.883a.5.5 0 0 1 .467.679l-.039.078L19 14.744V20.5a1.5 1.5 0 0 1-1.356 1.493L17.5 22h-11a1.5 1.5 0 0 1-1.493-1.356L5 20.5v-5.854l-1.885-2.944a.5.5 0 0 1 .339-.763l.082-.006H12.5zm1.5 4.067L6 15v5.5a.5.5 0 0 0 .41.492L6.5 21H14v-6.001zm1 0V21h2.5a.5.5 0 0 0 .492-.41L18 20.5V15l-3-.001zm-2.772-3.067H4.449l1.324 2.067h7.798l-1.343-2.067zm7.294 0H16.79l-1.368 2.067h2.859l1.241-2.067zm-6.709-2.901l.01-.007.018-.015-.014.012-.004.003-.007.007a.498.498 0 0 1-.047.033l-.03.017a.342.342 0 0 1-.043.021l-.037.013-.025.008-.026.006-.028.005a.353.353 0 0 1-.056.005h-.019l-.07-.005a.813.813 0 0 0 .049.005l-.005-.001.005.001h.021l-.026-.001-.029-.002a.45.45 0 0 1-.14-.037l-.016-.007-.016-.008a.33.33 0 0 1-.045-.026l-.012-.009-.013-.009a.527.527 0 0 1-.051-.043l-.005-.006-2.851-2.85a.5.5 0 0 1 .638-.765l.069.058 1.997 1.994V2.139a.5.5 0 0 1 .992-.09l.008.09v5.293l1.996-1.997a.5.5 0 0 1 .638-.058l.069.058a.5.5 0 0 1 .058.638l-.058.069-2.849 2.85-.007.005-.039.034z"
  })), props.children);
};
var ShippingSendIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1 4.5h-.2L2.4 6.4h-.1s-.1 0-.1.1c-.1 0-.1.1-.2.2v10.6c0 .2.2.4.4.4l7.5 1.9H10.2l6.5-1.9h.1c.2-.1.3-.3.3-.5v-2.9c0-.2-.2-.4-.5-.4h-.1c-.2 0-.4.2-.4.5v2.4l-5.5 1.6V9.1L16 7.5V9.8c0 .2.2.4.5.4s.5-.2.5-.5V6.9v-.1-.1c0-.1-.1-.1-.1-.2 0 0-.1 0-.1-.1h-.1l-6.6-1.9zm-.6 4.6L3 7.5v9.2l6.5 1.6V9.1zm.5-.9L4.6 6.9 10 5.5l4.7 1.3L10 8.2zm8.3.6c.2-.2.4-.2.6-.1l.1.1 2.8 2.8c.2.2.2.3.2.4 0 .1-.1.3-.2.4L19 15.2c-.2.2-.5.2-.7 0-.2-.2-.2-.4-.1-.6l.1-.1 2-2H15c-.3 0-.5-.2-.5-.5 0-.2.2-.4.4-.5H20.3l-2-2c-.2-.2-.2-.4 0-.7z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), props.children);
};
var ShippingIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.073 15.962c.142-.509.48-.936.927-1.194V7.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V16h.512a.5.5 0 1 1 0 1H2.5a.5.5 0 0 1-.5-.5v-9A1.5 1.5 0 0 1 3.5 6h11A1.5 1.5 0 0 1 16 7.5v1.541h3.09a1.5 1.5 0 0 1 1.338.822l1.056 2.087c.295.466.44 1.112.44 1.758v2.754a.5.5 0 0 1-.5.5h-3.478a2 2 0 0 1-3.892 0H8.946a2.001 2.001 0 1 1-.02-1h5.147zM16 14.5a2 2 0 0 1 1.927 1.462h2.997v-2.254c0-.244-.028-.486-.083-.708h-2.193a.5.5 0 0 1 0-1h1.743l-.855-1.685a.5.5 0 0 0-.446-.274H16V14.5zm-8 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm9 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
  })), props.children);
};
var ShowAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.191 9.203a1.588 1.588 0 1 1-3.177 0 1.588 1.588 0 0 1 3.177 0m1.985 0a3.573 3.573 0 1 1-7.146 0 3.573 3.573 0 0 1 7.146 0m3.682-.347l1.081.149S13.764 3.646 9 3.646c-6.35 0-7.939 5.359-7.939 5.359l.619-.05c.25 1.623 2.919 5.409 7.32 5.409 4.285 0 6.436-3.47 6.858-5.508z"
  })), props.children);
};
var SortAscendingAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.182 4.271v10.16a.75.75 0 0 1-1.5 0V4.352L9.035 6.026a.75.75 0 0 1-1.07-1.052l2.951-3a.75.75 0 0 1 1.06-.009l3.05 3a.75.75 0 0 1-1.052 1.07L12.182 4.27zM8 13.25a.75.75 0 1 1 0 1.5H3a.75.75 0 1 1 0-1.5h5zm0-4a.75.75 0 0 1 0 1.5H5.5a.75.75 0 1 1 0-1.5H8z"
  })), props.children);
};
var SortDescendingAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.182 12.728V2.568a.75.75 0 0 0-1.5 0v10.08l-1.647-1.674a.75.75 0 0 0-1.07 1.052l2.951 3a.75.75 0 0 0 1.06.008l3.05-3a.75.75 0 0 0-1.052-1.069l-1.792 1.763zM8 3.75a.75.75 0 1 0 0-1.5H3a.75.75 0 0 0 0 1.5h5zm0 4a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0 0 1.5H8z"
  })), props.children);
};
var SpecialFinancingIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.909 9.782a2 2 0 1 1-1.817-3.566 2 2 0 0 1 1.817 3.566zm-.019-2.237a1 1 0 1 0-.436 1.346 1 1 0 0 0 .436-1.346zm2.875-2.994a.5.5 0 0 1-.264.964L9.979 4.003c-.049-.014-.12.022-.136.067L8.034 8.868a.96.96 0 0 0 .036.613l4.884 9.487c.014.028.054.04.084.025l7.264-3.676a.055.055 0 0 0 .026-.072L16.3 7.422a.5.5 0 1 1 .889-.458l4.027 7.823c.267.52.058 1.16-.464 1.423l-7.263 3.675c-.52.264-1.16.058-1.425-.46L7.18 9.939c-.204-.398-.24-1.002-.082-1.422l1.81-4.8c.199-.528.79-.828 1.336-.678l5.521 1.513zM3.601 18.969l7.064 1.452.079-.24a.5.5 0 0 1 .95.315l-.22.661a.5.5 0 0 1-.575.333l-7.478-1.537c-.595-.095-.996-.669-.909-1.274L4.161 7.886a1.5 1.5 0 0 1 .445-.856L6.29 5.414a.5.5 0 1 1 .692.722L5.298 7.75a.5.5 0 0 0-.148.286l-1.648 10.79c-.01.07.032.131.099.142z"
  })), props.children);
};
var SplitBillIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.2 2.5a.51.51 0 0 1 .036 0h.264c.064 0 .124.012.18.034a3.262 3.262 0 0 1 2.791 3.227.5.5 0 0 1-.5.5h-1.97v5.693l-.001.02a.501.501 0 0 1-.601.513L5.446 9.802a.5.5 0 0 1-.398-.49V5.294A2.795 2.795 0 0 1 7.841 2.5H18.2zm.8 1.142V5.26h1.416A2.265 2.265 0 0 0 19 3.641zM15.777 21.5a3.076 3.076 0 0 1-.178 0H5.547c-.06 0-.119-.01-.173-.03A3.023 3.023 0 0 1 2.5 18.45a.5.5 0 0 1 .5-.5h2.048v-5.902-.023a.5.5 0 0 1 .601-.515l12.952 2.685a.5.5 0 0 1 .399.49v4.034c0 1.515-1.499 2.781-3.084 2.781h-.139zm-.155-1h.294c1.067 0 2.084-.86 2.084-1.781V15.09L6.048 12.614v5.336h7.148a.5.5 0 0 1 .49.405.5.5 0 0 1 .017.125c0 1.083.85 1.967 1.92 2.02zm-2.145 0a3.012 3.012 0 0 1-.738-1.55H3.562a2.024 2.024 0 0 0 1.961 1.523.5.5 0 0 1 .163.027h7.79zM6.047 8.905L18 11.383V3.5H7.843c-.992 0-1.795.804-1.795 1.794v3.611z"
  })), props.children);
};
var StarAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.928L4.674 15l1.656-4.967L2 7h5.35L9 2l1.65 5H16l-4.33 3.033L13.326 15z"
  })), props.children);
};
var StoreIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 17h8V9.893a2.45 2.45 0 0 1-.736.107 2.048 2.048 0 0 1-1.585-.758 2.047 2.047 0 0 1-1.585.758 2.047 2.047 0 0 1-1.585-.758 2.047 2.047 0 0 1-1.584.758 2.047 2.047 0 0 1-1.585-.758A2.048 2.048 0 0 1 8.755 10a2.047 2.047 0 0 1-1.585-.758A2.047 2.047 0 0 1 5.585 10C4.428 10 3.5 9.026 3.5 7.835c0-.595.093-1.192.246-1.766.093-.344.186-.608.252-.764a.5.5 0 0 1 .04-.075A.498.498 0 0 1 4 5.038V3.5a.5.5 0 0 1 .5-.5h15.052a.5.5 0 0 1 .5.5v1.538c0 .087-.023.17-.062.24.01.02.018.04.025.062a11.173 11.173 0 0 1 .424 1.747c.04.27.061.52.06.78a2.548 2.548 0 0 1-.559 1.395c.038.071.06.152.06.238v7.527c.27.063.51.23.686.47.204.276.314.635.314 1.005l-.002 1.998a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5v-2c0-.727.426-1.37 1.045-1.483v-5.835a.5.5 0 1 1 1 0V17H7v-4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V17zm-1 0v-4H8v4h2zM5 5h14.052V4H5v1zM4 20h15.999L20 18.501a.71.71 0 0 0-.12-.411c-.047-.066-.09-.09-.12-.09H4.24c-.094 0-.24.197-.24.5V20zm9.5-5.036a.5.5 0 0 1-.5-.5V12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1.964a.5.5 0 0 1-.5.5h-3zm2.5-1V13h-2v.964h2zM4.712 6.328A5.872 5.872 0 0 0 4.5 7.835C4.5 8.485 4.991 9 5.585 9S6.67 8.484 6.67 7.835c0-.667 1-.667 1 0C7.67 8.485 8.16 9 8.755 9c.594 0 1.085-.516 1.085-1.165 0-.667 1-.667 1 0 0 .65.49 1.165 1.085 1.165.593 0 1.084-.516 1.084-1.165 0-.667 1-.667 1 0 0 .65.491 1.165 1.085 1.165s1.084-.515 1.084-1.165c0-.667 1-.667 1 0 0 .65.492 1.165 1.086 1.165.52 0 .837-.206 1.04-.575.132-.236.188-.481.196-.59 0-.175-.017-.378-.05-.602a8.609 8.609 0 0 0-.165-.812A11.998 11.998 0 0 0 19.173 6H4.809c-.03.095-.064.205-.097.328z"
  })), props.children);
};
var SubtractIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 11.5h5a.5.5 0 1 1 0 1h-11a.5.5 0 1 1 0-1h6z"
  })), props.children);
};
var SupportIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.293 6.001L15.165 8.13c.258.212.495.449.707.707L18 6.708a8.048 8.048 0 0 0-.707-.707zm-.796-.618A7.964 7.964 0 0 0 12 4c-1.667 0-3.215.51-4.496 1.382l2.183 2.184A4.978 4.978 0 0 1 12 7c.835 0 1.622.205 2.313.566l2.184-2.183zm2.12 2.121l-2.183 2.184c.362.691.566 1.478.566 2.312 0 .834-.204 1.621-.566 2.313l2.184 2.183A7.964 7.964 0 0 0 20 12.001c0-1.668-.51-3.215-1.382-4.497zM6 17.293c.221.25.457.486.708.707l2.128-2.128a5.031 5.031 0 0 1-.707-.708L6 17.293zm-.618-.796l2.184-2.184A4.978 4.978 0 0 1 7 12c0-.834.204-1.62.566-2.312L5.382 7.504A7.963 7.963 0 0 0 4 12c0 1.666.51 3.214 1.382 4.496zm2.121 2.121A7.962 7.962 0 0 0 12 20.001c.81 0 1.602-.12 2.36-.355a.5.5 0 0 1 .295.956 9 9 0 1 1 2.92-1.538.5.5 0 0 1-.662-.04l-2.594-2.593A4.978 4.978 0 0 1 12 17c-.834 0-1.62-.204-2.312-.566l-2.185 2.184zM18 17.292l-2.129-2.128c-.21.257-.445.492-.701.703l2.127 2.127a8.035 8.035 0 0 0 .703-.702zM6.708 6A8.05 8.05 0 0 0 6 6.708l2.127 2.128c.212-.259.449-.496.708-.707L6.708 6zM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
  })), props.children);
};
var ThemeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.023 3a.998.998 0 0 1 1.002 1.003l.001 9.174a2.193 2.193 0 0 1-.204.873c-.288.616-.857.996-1.684.996-1.504 0-2.32.227-3.005.869-.18.169-.143.554.174 1.642l.121.432c.234.872.278 1.408.067 1.933-.313.775-1.13 1.147-2.47 1.147l-.259-.004c-1.207-.041-1.941-.419-2.208-1.16-.206-.57-.113-1.144.214-2.158l.124-.381c.3-.945.333-1.297.169-1.451-.685-.642-1.5-.869-3.005-.869-.84 0-1.44-.387-1.788-1.009a2.347 2.347 0 0 1-.3-.997V4.003A.998.998 0 0 1 5.974 3zm.002 8.102H5.97v1.904c.007.097.04.254.113.418l.061.124c.18.32.455.498.916.498 1.734 0 2.786.292 3.689 1.14.613.574.54 1.14.034 2.688l-.12.372c-.207.677-.258 1.06-.164 1.32.111.31.529.503 1.5.503l.213-.002c.845-.025 1.234-.218 1.355-.518.116-.287.063-.72-.163-1.511l-.121-.423c-.385-1.363-.405-1.894.166-2.43.904-.847 1.955-1.139 3.69-1.139.429 0 .65-.148.777-.42.09-.19.117-.408.11-.58l-.001-1.944zm0-7.102H5.971l-.001 6.102h12.055V4z"
  })), props.children);
};
var TipJarIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 2C14 2 15 3 15 4.2c0 .8-.3 1.4-.8 1.8h2.3v2h1c.3 0 .5.2.5.5 0 .2-.2.4-.4.5h-1.1v.5h.1c1.4.7 2.3 2.2 2.4 3.8v7.2c0 .8-.7 1.5-1.5 1.5h-11c-.8 0-1.5-.7-1.5-1.5v-7c0-1.7 1-3.2 2.4-4h.1V9h-1c-.3 0-.5-.2-.5-.5 0-.2.2-.4.4-.5h1.1V6h3.8c-.5-.4-.8-1-.8-1.8 0-1.2 1-2.2 2.3-2.2zm2.7 7h-7v1.1l-.3.1c-1.3.6-2.2 1.9-2.2 3.3v7c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5v-7c0-1.4-.9-2.7-2.2-3.2l-.3-.1V9zm-1.3 6.5c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2S12 19 12 17.8s1-2.3 2.2-2.3zm0 1c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2 1.2-.6 1.2-1.2-.5-1.2-1.2-1.2zm-5-3.5c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2S7 16.5 7 15.2 8 13 9.2 13zm0 1c-.6 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2 1.2-.6 1.2-1.2S9.9 14 9.2 14zm6.3-7h-7v1h7V7zm-2.7-4c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2S14 4.9 14 4.2 13.4 3 12.8 3z"
  })), props.children);
};
var ToolsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.802 2.147a.5.5 0 0 1 .57-.098l3.444 1.646a.5.5 0 0 1 .138.805l-.499.498 6.559 6.558 1.866-1.865a.5.5 0 0 1 .54-.11c.4.161.819.245 1.245.245a3.349 3.349 0 0 0 3.34-3.603l-.026-.217-2.147 2.147a.5.5 0 0 1-.638.058l-.07-.058-2.134-2.136a.5.5 0 0 1-.058-.638l.058-.07 2.146-2.147-.216-.025-.254-.01a3.351 3.351 0 0 0-3.35 3.35c0 .426.085.845.246 1.246a.5.5 0 0 1-.054.472l-.053.064-.901.921a.5.5 0 0 1-.772-.63l.057-.07.683-.698-.063-.213a4.295 4.295 0 0 1-.133-.815l-.01-.276a4.351 4.351 0 0 1 4.35-4.351c.555 0 1.1.11 1.619.317a.5.5 0 0 1 .223.751l-.056.067-2.402 2.402 1.428 1.427 2.402-2.4a.5.5 0 0 1 .778.089l.04.078a4.33 4.33 0 0 1 .317 1.62 4.349 4.349 0 0 1-4.35 4.348c-.371 0-.737-.048-1.093-.143l-.208-.062-1.643 1.642 1.443 1.445.04-.03c.503-.349 1.16-.371 1.618-.007l.102.09 3.73 3.731c.522.521.451 1.388-.1 1.942l-2.12 2.119c-.552.552-1.42.623-1.942.1l-3.73-3.73c-.457-.456-.46-1.177-.083-1.721l.029-.038-3.62-3.62-1.752 1.834a.5.5 0 0 1-.548.12 3.333 3.333 0 0 0-1.246-.247 3.35 3.35 0 0 0-3.34 3.604l.025.218 2.238-2.238a.5.5 0 0 1 .638-.058l.07.057 2.136 2.135a.5.5 0 0 1 .057.638l-.057.07-2.24 2.237.219.027.254.01a3.35 3.35 0 0 0 3.35-3.35c0-.427-.085-.845-.247-1.246a.5.5 0 0 1 .056-.476l.055-.065.703-.703a.5.5 0 0 1 .765.638l-.058.07-.481.479.063.21c.07.266.116.539.134.815l.01.278a4.35 4.35 0 0 1-4.35 4.35c-.557 0-1.1-.11-1.62-.32a.5.5 0 0 1-.223-.75l.057-.067 2.491-2.491-1.428-1.429-2.491 2.493a.5.5 0 0 1-.778-.088l-.04-.078a4.318 4.318 0 0 1-.319-1.62 4.35 4.35 0 0 1 4.351-4.35c.37 0 .735.049 1.091.143l.202.06 1.547-1.617-4.383-4.382-.499.5a.5.5 0 0 1-.758-.06l-.047-.078L2.05 4.37a.5.5 0 0 1 .098-.57zm.457.956L3.104 4.258l1.188 2.488.353-.351a.5.5 0 0 1 .638-.058l.07.058 9.402 9.403a.5.5 0 0 1 0 .708l-.185.183c-.185.185-.205.424-.1.528l3.73 3.73c.103.104.342.084.527-.101l2.119-2.119c.185-.185.204-.424.101-.527l-3.73-3.73c-.104-.105-.342-.085-.527.099l-.185.186a.5.5 0 0 1-.708 0L6.395 5.353a.5.5 0 0 1 0-.707l.352-.353-2.488-1.189z"
  })), props.children);
};
var TransferMoneyIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 16.014a.5.5 0 1 1 1-.004l.004.887a.5.5 0 0 1-.513.502c-1.549-.04-2.786.115-5.574.61H9.91c-3.6.638-5.23.794-7.326.495a.5.5 0 0 1-.424-.423l-.005-.06-.269-8.237a.5.5 0 0 1 .414-.509l1.125-.195a.5.5 0 0 1 .171.985l-.696.121.237 7.381c1.776.202 3.35.033 6.599-.542l.007-.001c2.549-.452 3.844-.629 5.259-.631L15 16.014zm2.265-3.296a.5.5 0 0 1 1 0V14.5a.5.5 0 0 1-.64.48 6.82 6.82 0 0 0-.572-.132 49.023 49.023 0 0 0-.911-.16c-1.94-.3-3.438-.227-5.923.138-2.731.4-3.551.454-4.84.134A.5.5 0 0 1 5 14.475V6.23a.5.5 0 0 1 .635-.481c1.355.38 1.878.414 3.593.269l3.419-.285c1.707-.173 4.06-.096 5.27.29a.5.5 0 0 1 .348.477v1.615a.5.5 0 1 1-1 0V6.884c-1.142-.255-3.093-.3-4.526-.155l-3.427.286c-1.543.13-2.239.122-3.312-.135v7.193c.933.176 1.788.099 4.074-.237 2.576-.378 4.16-.454 6.239-.132a45.836 45.836 0 0 1 .952.166v-1.152zM11.5 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10-.97a.5.5 0 0 1 0 1h-5a.5.5 0 1 1 0-1h5zm-1.898-1.18a.5.5 0 0 1 .796-.603l1.5 1.977a.5.5 0 0 1 .001.603l-1.5 1.99a.5.5 0 1 1-.798-.602l1.272-1.688-1.271-1.676z"
  })), props.children);
};
var TransferIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.517 5.214V6.5a.5.5 0 0 1-.5.5h-4.95a.5.5 0 0 1 0-1h4.45V4a.5.5 0 0 1 .855-.352l5.983 6.032a.5.5 0 0 1 0 .704l-5.983 6.033a.5.5 0 0 1-.855-.352v-3.566l-6.534.002a.5.5 0 0 1-.5-.5V9.15l-4.779 4.818 4.779 4.818V17a.5.5 0 0 1 .5-.5h4.95a.5.5 0 0 1 0 1h-4.45V20a.5.5 0 0 1-.855.352L2.645 14.32a.5.5 0 0 1 0-.704l5.983-6.033a.5.5 0 0 1 .855.352v3.566l6.534-.002a.5.5 0 0 1 .5.5v2.851l4.779-4.818-4.779-4.818z"
  })), props.children);
};
var TrashAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.142 3.25l.344-1.477A1 1 0 0 1 7.46 1h3.08a1 1 0 0 1 .974.773l.344 1.477H14.5a.75.75 0 1 1 0 1.5h-.529l-.397 10.327A2 2 0 0 1 11.575 17h-5.15a2 2 0 0 1-1.999-1.923L4.029 4.75H3.5a.75.75 0 0 1 0-1.5h2.642zm1.54 0h2.636l-.175-.75H7.857l-.175.75zM6.126 6.534l.5 7.99a.375.375 0 0 0 .748-.047l-.5-7.99a.375.375 0 1 0-.748.047zm5.748 0a.375.375 0 0 0-.748-.047l-.5 7.99a.375.375 0 0 0 .748.046l.5-7.99zM8.625 6.51v7.99a.375.375 0 1 0 .75 0V6.51a.375.375 0 0 0-.75 0z"
  })), props.children);
};
var TrashIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.531 6l.832 13.699c.009.15.266.301.671.301l3.382-.024a.503.503 0 0 1 .087-.007l.455.004.455-.004c.03 0 .06.003.087.007l3.382.024c.406 0 .663-.152.671-.301L17.385 6H6.531zM5.53 6H4.5a.5.5 0 0 1 0-1h4.1l.445-2.003C9.15 2.447 9.673 2 10.202 2h4.052c.541 0 1.031.457 1.117.98L15.852 5H19.5a.5.5 0 1 1 0 1h-1.113l-.835 13.757c-.046.798-.8 1.243-1.673 1.243l-3.92-.027L8.037 21c-.873 0-1.628-.445-1.673-1.243L5.529 6zm4.095-1h5.2l-.433-1.822c-.015-.094-.106-.178-.137-.178h-4.052c-.043 0-.16.1-.174.183l-.005.022L9.623 5zM8.51 8.538a.5.5 0 0 1 .997-.076l.745 9.724a.5.5 0 1 1-.997.076L8.51 8.538zm6.989 0l-.74 9.724a.5.5 0 0 1-.998-.076l.74-9.724a.5.5 0 0 1 .998.076zM12.5 8.5v9.75c0 .667-1 .667-1 0V8.5c0-.667 1-.667 1 0z"
  })), props.children);
};
var UnlockAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7V4.582C6.5 3.158 7.622 2 9 2c1.243 0 2.275.943 2.466 2.174A.999.999 0 0 0 13.45 4c0-.051-.008-.102-.015-.15l.003-.001-.007-.031c0-.012-.004-.025-.007-.038C13.05 1.633 11.215 0 9 0 6.515 0 4.5 2.051 4.5 4.582V7h-.409a1.1 1.1 0 0 0-1.09 1.111v7.778C3 16.502 3.487 17 4.09 17h9.818c.603 0 1.091-.498 1.091-1.111V8.111A1.1 1.1 0 0 0 13.91 7H6.5z"
  })), props.children);
};
var UploadIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.4L8.342 7.365a.5.5 0 0 1-.684-.73l4-3.755a.5.5 0 0 1 .684 0l4 3.755a.5.5 0 0 1-.684.73L12.5 4.4V13a.5.5 0 1 1-1 0V4.4zM6.469 12a.5.5 0 1 1 0 1H4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-2.013a.5.5 0 0 1 0-1H19.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-6A1.5 1.5 0 0 1 4.5 12h1.969z"
  })), props.children);
};
var UserAddIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 17h1.5a.5.5 0 1 1 0 1H18v1.458a.5.5 0 0 1-1 0V18h-1.52a.5.5 0 1 1 0-1H17v-1.482a.5.5 0 0 1 1 0V17zM13.093 6.182C11.968 7.816 10.455 8.92 8.51 9.218a.5.5 0 0 1-.55-.337.871.871 0 0 0-1.698.276l.002.02.002.074c0 .737.34 1.295.93 1.721a3.404 3.404 0 0 0 .973.483.5.5 0 1 1-.255.967 4.102 4.102 0 0 1-1.303-.639c-.832-.6-1.345-1.442-1.345-2.532l-.001-.02c-.002-.028-.002-.028-.002-.074a1.871 1.871 0 0 1 3.455-.995c1.474-.327 2.645-1.229 3.553-2.547.413-.6.743-1.246.995-1.891.151-.386.242-.681.28-.842a.5.5 0 0 1 .912-.145c.686 1.113.86 1.88.853 3.065 0 .084 0 .084-.002.167l-.002.328v.01c-.004.337.024.787.11 1.216.046.225.105.42.175.577.096.212.235.437.467.764l.247.348c.096.137.169.245.232.348.185.3.285.543.285.8 0 .268-.123.486-.33.703-.113.119-.157.156-.466.41-.312.257-.43.396-.43.429 0 1.468-.363 3.241-1.206 3.616-.657.292-1.65.444-2.89.476V19.5a.5.5 0 0 1-.727.445l-5.5-2.804A.5.5 0 0 1 5 16.696v-2.043a.5.5 0 1 1 1 0v1.736l4.5 2.295V15.5a.5.5 0 0 1 .5-.5c1.344 0 2.401-.137 2.983-.396.291-.129.613-1.7.613-2.702 0-.466.23-.736.795-1.201.318-.262.43-.38.43-.34 0-.079-.088-.223-.58-.92-.266-.376-.433-.645-.562-.93a3.728 3.728 0 0 1-.242-.79 6.996 6.996 0 0 1-.13-1.434l.001-.329.002-.163c.004-.595-.04-1.043-.196-1.502a10.253 10.253 0 0 1-1.02 1.89z"
  })), props.children);
};
var UserIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.093 6.682c-1.125 1.634-2.638 2.737-4.584 3.036a.5.5 0 0 1-.55-.337.871.871 0 0 0-1.698.276l.002.02.002.074c0 .737.34 1.295.93 1.721a3.404 3.404 0 0 0 .973.483.5.5 0 1 1-.255.967 4.102 4.102 0 0 1-1.303-.639c-.832-.6-1.345-1.442-1.345-2.532l-.001-.02c-.002-.028-.002-.028-.002-.074a1.871 1.871 0 0 1 3.455-.995c1.474-.327 2.645-1.229 3.553-2.547.413-.6.743-1.246.995-1.891.151-.386.242-.681.28-.842a.5.5 0 0 1 .912-.145c.686 1.113.86 1.88.853 3.065 0 .084 0 .084-.002.167l-.002.328v.01c-.004.337.024.787.11 1.216.046.225.105.42.175.577.096.212.235.437.467.764l.247.348c.096.137.169.245.232.348.185.3.285.543.285.8 0 .268-.123.486-.33.703-.113.119-.157.156-.466.41-.312.257-.43.396-.43.429 0 1.468-.363 3.241-1.206 3.616-.657.292-1.65.444-2.89.476V20a.5.5 0 0 1-.727.445l-5.5-2.804A.5.5 0 0 1 7 17.196v-2.043a.5.5 0 1 1 1 0v1.736l4.5 2.295V16a.5.5 0 0 1 .5-.5c1.344 0 2.401-.137 2.983-.396.291-.129.613-1.7.613-2.702 0-.466.23-.736.795-1.201.318-.262.43-.38.43-.34 0-.079-.088-.223-.58-.92-.266-.376-.433-.645-.562-.93a3.728 3.728 0 0 1-.242-.79 6.996 6.996 0 0 1-.13-1.434l.001-.329.002-.163c.004-.595-.04-1.043-.196-1.502a10.253 10.253 0 0 1-1.02 1.89z"
  })), props.children);
};
var V2AccountbenefitsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.35 7.63l3.5.08c1.03.01 1.88-.83 1.85-1.86l-.08-3.5c0-.31-.38-.47-.61-.24l-4.9 4.9c-.23.23-.07.61.24.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45 10.42H16.1V4a2 2 0 0 0-2-2H9.09c.02.1.04.21.04.32l.08 3.5A3.312 3.312 0 0 1 5.9 9.21l-3.58-.08c-.11-.01-.21-.04-.32-.06V18c0 1.1.9 2 2 2h3.26c.56 1.03 1.64 1.74 2.89 1.74h8.29c1.82 0 3.3-1.48 3.3-3.3v-4.73c.01-1.81-1.47-3.29-3.29-3.29zm-8.3 1.5h8.29c.25 0 .49.05.7.14.22.09.41.22.57.39.08.08.16.17.22.27.19.29.31.63.31 1.01v.54H8.35v-.54c0-1.01.81-1.81 1.8-1.81zm8.3 8.32h-8.3c-.15 0-.3-.03-.44-.06-.02-.01-.04-.01-.06-.02-.14-.04-.26-.09-.39-.16a1.8 1.8 0 0 1-.91-1.56V16.8h11.89v1.64c.01 1-.8 1.8-1.79 1.8z"
  })), props.children);
};
var V2AcornsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.575 11.024H4.426c-1.335-.104-1.291-6.117 6.459-6.676.072-.032.088-.04.132-.184a3.26 3.26 0 0 0 .12-.756 2.094 2.094 0 0 0-.12-.8A1.977 1.977 0 0 0 10.661 2c.24 0 .48.048.704.14.292.116.592.32.86.588.264.268.496.568.684.892a5.492 5.492 0 0 1 .388.792c7.566.655 7.602 6.508 6.278 6.612zm-.36 1.003s1.2 7.633-6.139 9.041c-.331.284-.883.936-1.087.932-.2.004-.756-.648-1.088-.932-7.375-1.264-6.135-9.04-6.135-9.04h14.45z"
  })), props.children);
};
var V2ActivityIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.505 7.003a1.5 1.5 0 1 0-.001-3 1.5 1.5 0 0 0 0 3zm5-3a1.5 1.5 0 0 0 0 3h12a1.5 1.5 0 0 0 0-3h-12zm0 6.497a1.5 1.5 0 0 0 0 3h12a1.5 1.5 0 0 0 0-3h-12zm-1.5 7.997a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 1 1 0 3h-12a1.5 1.5 0 0 1-1.5-1.5zm-2 .003a1.5 1.5 0 1 1-3.001 0 1.5 1.5 0 0 1 3 0zm-1.5-5a1.5 1.5 0 1 0-.001-3 1.5 1.5 0 0 0 0 3z"
  })), props.children);
};
var V2AddCashIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.015 6C2.455 6 2 6.448 2 7v7c0 .552.454 1 1.015 1h8.81a5.768 5.768 0 0 1 7.398-3.414V7c0-.552-.455-1-1.015-1H3.015zm16.208 6.668a4.766 4.766 0 1 0-3.979 8.666 4.766 4.766 0 0 0 3.979-8.666zM11.555 16H4.777v1c0 .552.455 1 1.015 1h5.763a5.801 5.801 0 0 1 0-2zM22 13.754V10c0-.552-.454-1-1.015-1h-.508v3.232A5.799 5.799 0 0 1 22 13.754zm-8.4-3.346a2.947 2.947 0 1 1-5.893 0 2.947 2.947 0 0 1 5.893 0zm3.606 3.946h.059a.5.5 0 0 1 .5.5v1.617h1.617a.5.5 0 0 1 .5.5v.06a.5.5 0 0 1-.5.5l-1.618-.001v1.618a.5.5 0 0 1-.5.5h-.058a.5.5 0 0 1-.5-.5V17.53h-1.618a.5.5 0 0 1-.5-.5v-.059a.5.5 0 0 1 .5-.5h1.617l.001-1.617a.5.5 0 0 1 .5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2AddImageIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 6.641c0 .043 0 .086-.002.13-.057 2.018-1.447 3.714-3.347 4.287a4.895 4.895 0 0 1-1.417.208 4.871 4.871 0 0 1-1.942-.4c-1.664-.721-2.823-2.342-2.823-4.225a4.495 4.495 0 0 1 .344-1.729c.705-1.698 2.42-2.896 4.421-2.896C19.866 2.016 22 4.086 22 6.64zM11.75 4.912H4c-1.1 0-2 .874-2 1.941v9.706c0 1.067.9 1.941 2 1.941h16c1.1 0 2-.873 2-1.941V9.792a5.774 5.774 0 0 1-3.318 2.267l1.594 3.095c.333.646-.15 1.405-.894 1.405H5.762c-.935 0-1.359-1.135-.64-1.716l3.376-2.73a1.025 1.025 0 0 1 1.087-.123l2.692 1.306a1.02 1.02 0 0 0 1.228-.261l1.145-1.39c-1.886-.92-3.181-2.815-3.181-5.004 0-.603.098-1.184.28-1.729zM7 8.31c0 .804-.672 1.456-1.5 1.456S4 9.113 4 8.309s.672-1.456 1.5-1.456S7 7.505 7 8.31zm10.206-4.174h.059a.5.5 0 0 1 .5.5v1.617h1.617a.5.5 0 0 1 .5.5v.06a.5.5 0 0 1-.5.5h-1.618V8.93a.5.5 0 0 1-.5.5h-.058a.5.5 0 0 1-.5-.5V7.311h-1.618a.5.5 0 0 1-.5-.5v-.058a.5.5 0 0 1 .5-.5h1.617l.001-1.618a.5.5 0 0 1 .5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2AddUserIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.823 11.516a5.922 5.922 0 0 0 1.173-3.546c0-3.297-2.688-5.97-6.003-5.97S5.991 4.673 5.991 7.97c0 3.297 2.687 5.97 6.002 5.97.194 0 .385-.009.573-.027a5.745 5.745 0 0 1 4.257-2.397zM17.226 22a4.75 4.75 0 1 1 .048 0h-.048zm-5.647-5.707A5.744 5.744 0 0 0 14.01 22H5.536c-.469 0-.913-.203-1.213-.561-1.717-2.042-.264-5.146 2.413-5.146h4.843zm5.643-1.68h.058c.275 0 .499.223.499.498v1.612h1.612c.275 0 .498.223.498.499v.058a.498.498 0 0 1-.498.499h-1.613v1.612a.498.498 0 0 1-.498.498h-.058a.498.498 0 0 1-.499-.498v-1.613H15.11a.498.498 0 0 1-.498-.498v-.058c0-.276.223-.499.498-.499h1.612V15.11c0-.275.223-.498.499-.498z",
    clipRule: "evenodd"
  })), props.children);
};
var V2AddIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.143 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 12.143a1 1 0 0 1-1 1H7a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ArrowDownSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 14.647a.844.844 0 0 0 .844-.844V4.197a.844.844 0 0 0-1.688 0v9.606c0 .466.378.844.844.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.6 8.403a.844.844 0 0 0 0 1.194L8.403 14.4c.33.33.864.33 1.194 0L14.4 9.597a.844.844 0 1 0-1.193-1.194L9 12.61 4.793 8.403a.844.844 0 0 0-1.193 0z"
  })), props.children);
};
var V2ArrowLeftIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.746 4.823a1 1 0 0 1 0 1.414L5.454 11.53l5.292 5.283a1 1 0 0 1-1.413 1.415l-6-5.99a1 1 0 0 1-.001-1.415l6-6a1 1 0 0 1 1.414 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.04 11.53a1 1 0 0 1 1-1h15.959a1 1 0 1 1 0 2H4.039a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ArrowRightIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.292 18.228a1 1 0 0 1 0-1.415l5.292-5.292-5.291-5.283a1 1 0 0 1 1.413-1.415l6 5.99a1 1 0 0 1 0 1.415l-6 6a1 1 0 0 1-1.414 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.999 11.52a1 1 0 0 1-1 1H4.039a1 1 0 1 1 0-2H20a1 1 0 0 1 1 1z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ArrowUpSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3.353c.466 0 .844.378.844.844v9.606a.844.844 0 1 1-1.688 0V4.197c0-.466.378-.844.844-.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.6 9.597a.844.844 0 0 1 0-1.194L8.403 3.6a.844.844 0 0 1 1.194 0L14.4 8.403a.844.844 0 1 1-1.193 1.194L9 5.39 4.793 9.597a.844.844 0 0 1-1.193 0z"
  })), props.children);
};
var V2AttachIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.753 3a4.135 4.135 0 0 0-4.131 4.122v7.497a2.631 2.631 0 0 0 2.628 2.628 2.631 2.631 0 0 0 2.628-2.628V7.194a.451.451 0 0 0-.45-.45h-.603a.451.451 0 0 0-.45.45v7.434a1.125 1.125 0 0 1-2.25 0V7.122a2.631 2.631 0 0 1 2.628-2.628 2.631 2.631 0 0 1 2.628 2.628v8.253a4.127 4.127 0 0 1-4.122 4.122 4.133 4.133 0 0 1-4.122-4.122V7.194a.451.451 0 0 0-.45-.45h-.612a.457.457 0 0 0-.45.45v8.181A5.627 5.627 0 0 0 12.25 21a5.627 5.627 0 0 0 5.625-5.625V7.122A4.133 4.133 0 0 0 13.753 3z"
  })), props.children);
};
var V2AutoIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13.102v2.373a.474.474 0 0 1-.474.475H19.6a2.85 2.85 0 0 1-5.7 0h-3.8a2.85 2.85 0 0 1-5.7 0H2.973a.474.474 0 0 1-.474-.474V12.15a1.896 1.896 0 0 1 1.425-1.832L5.35 6.697A1.9 1.9 0 0 1 7.113 5.5h6.352a2.15 2.15 0 0 1 1.484.713l3.225 4.039h.474a2.85 2.85 0 0 1 2.852 2.85zm-12.825 2.85a1.425 1.425 0 1 0-2.85 0 1.425 1.425 0 0 0 2.85 0zm.712-8.55H7.113l-1.14 2.85h3.414v-2.85zm6.354 2.85l-2.28-2.85h-2.647v2.85h4.927zm2.443 5.7a1.425 1.425 0 1 0-1.425 1.425 1.425 1.425 0 0 0 1.415-1.425h.01z"
  })), props.children);
};
var V2BankIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.22 18.498H4.78c-.43 0-.78.35-.78.78v.931c0 .44.35.791.78.791h14.43c.43 0 .78-.35.78-.78v-.931a.769.769 0 0 0-.77-.79zM12.093 3.011a.4.4 0 0 0-.186 0l-7.6 1.825a.4.4 0 0 0-.307.39V7.05c0 .221.18.4.4.4h15.2a.4.4 0 0 0 .4-.4V5.225a.4.4 0 0 0-.307-.389l-7.6-1.825zM6.32 15.496c-.44 0-.8.36-.8.801v.5c0 .11.09.2.2.2h12.6a.2.2 0 0 0 .2-.2v-.5c0-.44-.36-.8-.8-.8h-.42v-5.044h.43c.44 0 .8-.36.8-.8v-.5a.2.2 0 0 0-.2-.2h-5.56a.2.2 0 0 0-.2.2v.5c0 .44.36.8.8.8h.43v5.043h-3.55v-5.043h.43c.44 0 .8-.36.8-.8v-.5a.2.2 0 0 0-.2-.2H5.73a.2.2 0 0 0-.2.2v.5c0 .44.36.8.8.8h.43v5.043h-.44z"
  })), props.children);
};
var V2BigPurchaseIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.25a.5.5 0 0 1 .492.41l.008.09h5.5l-2 2 2 2H15v3.55a1.995 1.995 0 0 1 1.139.79l1.077 1.54-.976 1.3-.028.032-.032.028a.3.3 0 0 1-.42-.06l-.54-.72-.054-.066a.898.898 0 0 0-1.386.066l-.525.7-.03.035-.037.03a.3.3 0 0 1-.418-.072l-.941-1.337 1.032-1.475A1.993 1.993 0 0 1 14 11.3V3.75a.5.5 0 0 1 .5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.72 15.29l.858-1.143L21.5 19.75a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1l3.963-5.661.817 1.16.07.087a.9.9 0 0 0 1.385-.066l.525-.7.048-.05a.3.3 0 0 1 .432.05l.54.72.074.086a.9.9 0 0 0 1.366-.086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.273 12.987a.998.998 0 0 0-1.648-.07L2.5 19.75l.007.117a1 1 0 0 0 .993.883h4a1 1 0 0 1-.993-.883L6.5 19.75l3.698-5.283-.925-1.48z"
  })), props.children);
};
var V2BillPaymentIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8zm-2.5 12h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2-2h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2-2h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-4-5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"
  })), props.children);
};
var V2CalculatorIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 7a5 5 0 0 1 5-5h4.25v9.25H2V7zm10.75-5v9.25H22V7a5 5 0 0 0-5-5h-4.25zM22 12.75h-9.25V22H17a5 5 0 0 0 5-5v-4.25zM11.25 22v-9.25H2V17a5 5 0 0 0 5 5h4.25zM7 9.5a.75.75 0 0 1-.75-.75v-1h-1a.75.75 0 0 1 0-1.5h1v-1a.75.75 0 0 1 1.5 0v1h1a.75.75 0 0 1 0 1.5h-1v1A.75.75 0 0 1 7 9.5zm11.75 6.75a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0 0 1.5h3.5zm0 3a.75.75 0 0 0 0-1.5h-3.5a.75.75 0 0 0 0 1.5h3.5zm-10.78-.22a.75.75 0 0 0 1.06-1.06L8.06 17l.97-.97a.75.75 0 1 0-1.06-1.06l-.97.97-.97-.97a.75.75 0 0 0-1.06 1.06l.969.97-.97.97a.75.75 0 1 0 1.061 1.06l.97-.97.97.97zM19.5 7a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 .75.75z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CalendarPausedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.53 3.5v.86C18.49 4.62 20 6.28 20 8.31v8c0 2.21-1.79 4-4 4h-4.345A5.766 5.766 0 0 0 4 12.16V8.31c0-2.03 1.51-3.69 3.47-3.95V3.5c0-.27.22-.5.5-.5h.5c.27 0 .5.22.5.5v.8h6.07v-.8c0-.27.22-.5.5-.5h.49c.27 0 .5.22.5.5zM6.797 21.969c1.445 0 2.74-.643 3.614-1.659a4.766 4.766 0 1 0-3.614 1.659zM5.5 9.12c.01.1.09.19.2.19h12.58a.2.2 0 0 0 .2-.2v-.8c0-1.2-.85-2.2-1.97-2.44v.63c0 .27-.22.5-.5.5h-.49c-.27 0-.5-.22-.5-.5v-.69H8.96v.69c0 .27-.22.5-.5.5h-.49c-.27 0-.5-.22-.5-.5v-.63A2.5 2.5 0 0 0 5.5 8.31v.81zm.326 5.436h-.058a.5.5 0 0 0-.5.5v4.294a.5.5 0 0 0 .5.5h.058a.5.5 0 0 0 .5-.5v-4.294a.5.5 0 0 0-.5-.5zm2 0h-.058a.5.5 0 0 0-.5.5v4.294a.5.5 0 0 0 .5.5h.058a.5.5 0 0 0 .5-.5v-4.294a.5.5 0 0 0-.5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CalendarIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.53 4.36V3.5c0-.28-.23-.5-.5-.5h-.49c-.28 0-.5.23-.5.5v.8H8.97v-.8c0-.28-.23-.5-.5-.5h-.5c-.28 0-.5.23-.5.5v.86A3.984 3.984 0 0 0 4 8.31v8c0 .55.11 1.08.31 1.56s.5.91.86 1.27c.18.18.38.34.59.49.43.29.91.5 1.43.6.26.05.53.08.81.08h8c2.21 0 4-1.79 4-4v-8c0-2.03-1.51-3.69-3.47-3.95zM5.7 9.31c-.11 0-.19-.09-.2-.19v-.81c0-1.2.85-2.2 1.97-2.44v.63c0 .28.23.5.5.5h.49c.28 0 .5-.23.5-.5v-.69h6.06v.69c0 .28.23.5.5.5h.49c.28 0 .5-.23.5-.5v-.63a2.5 2.5 0 0 1 1.97 2.44v.8a.2.2 0 0 1-.2.2H5.7z"
  })), props.children);
};
var V2CameraAddIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 6.797a4.758 4.758 0 0 1-4.766 4.766 4.766 4.766 0 0 1-4.7-5.55V6A4.767 4.767 0 0 1 22 6.797zm-10.254-1.77A2.005 2.005 0 0 0 10 4H6c-1.08 0-1.95.86-1.99 1.93H4v.34c0 .11-.062.212-.157.268C2.748 7.191 2 8.374 2 9.74v6.52C2 18.32 3.68 20 5.74 20h12.52A3.74 3.74 0 0 0 22 16.26v-6.217a5.766 5.766 0 0 1-10.254-5.016zM6 13c0 2.07 1.68 3.75 3.75 3.75 2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75C7.68 9.25 6 10.93 6 13zm6 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0zm5.206-8.85h.059a.5.5 0 0 1 .5.5v1.618h1.617a.5.5 0 0 1 .5.5v.06a.5.5 0 0 1-.5.5l-1.618-.001v1.618a.5.5 0 0 1-.5.5h-.058a.5.5 0 0 1-.5-.5V7.327h-1.618a.5.5 0 0 1-.5-.5v-.059a.5.5 0 0 1 .5-.5h1.617l.001-1.617a.5.5 0 0 1 .5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CameraIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.26 6H12.3c-.166 0-.298-.135-.323-.299A2.007 2.007 0 0 0 10 4H6c-1.08 0-1.95.86-1.99 1.93H4v.34c0 .11-.062.212-.157.268C2.748 7.191 2 8.374 2 9.74v6.52C2 18.32 3.68 20 5.74 20h12.52A3.74 3.74 0 0 0 22 16.26V9.74C22 7.68 20.32 6 18.26 6zM9.75 16.75C7.68 16.75 6 15.07 6 13c0-2.07 1.68-3.75 3.75-3.75 2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75zM20 9.61c0 .33-.27.6-.6.6h-1.8c-.33 0-.6-.27-.6-.6v-.3c0-.33.27-.6.6-.6h1.8c.33 0 .6.27.6.6v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5z"
  })), props.children);
};
var V2CashIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7.5c0-.553.454-1 1.015-1h15.193c.56 0 1.015.447 1.015 1v7c0 .552-.455 1-1.015 1H3.015c-.56 0-1.015-.448-1.015-1v-7zm2.777 10v-1h14.685c.56 0 1.015-.448 1.015-1v-6h.508c.56 0 1.015.447 1.015 1v7c0 .552-.454 1-1.015 1H5.792c-.56 0-1.015-.448-1.015-1zm5.876-3.646a2.947 2.947 0 1 0 0-5.893 2.947 2.947 0 0 0 0 5.893z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CausesIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.617 2c-1.853 0-2.52 1.092-2.692 1.458-.015.033-.066.033-.081 0C11.67 3.092 11.004 2 9.152 2c-2.362 0-3.637 2.39-2.5 4.852 1.03 2.232 3.977 4.84 5.233 4.84 1.255 0 4.208-2.602 5.232-4.84C18.254 4.39 16.98 2 14.617 2zM3.17 18.101a.557.557 0 0 1 0-.8l1.412-1.382a.997.997 0 0 0 .206-.309c.44-.983 1.615-1.686 2.995-1.686v-.001h6.356c.879 0 1.59.696 1.59 1.556 0 .859-.711 1.431-1.59 1.431h-3.253c-.056.199-.142.513-.252.691l4.371.731a1.961 1.961 0 0 0 1.465-.34l2.639-1.888a1.469 1.469 0 0 1 2.044 0 1.392 1.392 0 0 1 0 2l-3.23 2.473a2.943 2.943 0 0 1-2.112.589l-6.26-.692a.808.808 0 0 0-.671.242l-1.077 1.118a.588.588 0 0 1-.818 0L3.17 18.101z"
  })), props.children);
};
var V2ChatIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.402a8.75 8.75 0 1 0-7.605-4.42c.08.175.101.371.044.563l-.992 3.478a.844.844 0 0 0 1.124 1.014l3.358-1.342a.827.827 0 0 1 .708.048v-.01a8.754 8.754 0 0 0 3.363.669z"
  })), props.children);
};
var V2CheckCaptureIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 19.5v-4h1.5V19H7v1.5H3a1 1 0 0 1-1-1zM3.5 5H7V3.5H3a1 1 0 0 0-1 1v4h1.5V5zm17 0v3.5H22v-4a1 1 0 0 0-1-1h-4V5h3.5zm0 14H17v1.5h4a1 1 0 0 0 1-1v-4h-1.5V19zM5 8.5A1.5 1.5 0 0 1 6.5 7h11A1.5 1.5 0 0 1 19 8.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 15.5v-7zm1.5.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm5.434 5.748c.478-.836.934-1.333 1.308-1.598.377-.266.624-.268.74-.234.102.031.215.125.263.352.05.233.02.586-.192 1.008a.5.5 0 1 0 .894.448c.226-.451.464-.729.663-.883.203-.156.336-.165.382-.159.024.004.053.011.08.081.033.087.055.276-.046.579a.5.5 0 0 0 .948.316c.15-.447.172-.883.033-1.25a1.09 1.09 0 0 0-.874-.715c-.322-.046-.648.045-.945.227-.135-.447-.446-.82-.92-.961-.509-.153-1.074 0-1.603.375-.532.376-1.077 1.004-1.599 1.918a.5.5 0 0 0 .868.496z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CheckIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.37 11.5h-4.23c-.33 0-.6.27-.6.6v.3c0 .33.27.6.6.6h4.23c.33 0 .6-.27.6-.6v-.3c0-.33-.27-.6-.6-.6zm-2.54 3h-1.7c-.33 0-.6.27-.6.6v.3c0 .33.27.6.6.6h1.7c.33 0 .6-.27.6-.6v-.3c0-.33-.27-.6-.6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8.5h-8V4.99C12 3.89 11.11 3 10.01 3H3.5C2.67 3 2 3.67 2 4.5v8c0 .83.67 1.5 1.5 1.5H6v3.51c0 1.1.89 1.99 1.99 1.99H20c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2zm-9.5 8.17c0 .73-.6 1.33-1.33 1.33H7.72c-.12 0-.22-.1-.22-.22v-2.22c0-.12.1-.22.22-.22h1.45c.73 0 1.33.59 1.33 1.33zm10 .83c0 .28-.22.5-.5.5h-8.35c.22-.4.35-.85.35-1.34V10h8c.28 0 .5.22.5.5v7z"
  })), props.children);
};
var V2CheckmarkBackgroundSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm3.248-9.81a.75.75 0 0 1 .063 1.058l-4 4.5a.75.75 0 0 1-1.147-.03l-2-2.5a.75.75 0 1 1 1.172-.937l1.444 1.806 3.41-3.835a.75.75 0 0 1 1.058-.063z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CheckmarkBackgroundIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-4.756-2.332a1 1 0 1 0-1.488-1.336l-5.046 5.622-1.93-2.412a1 1 0 1 0-1.56 1.25l2.666 3.333a1 1 0 0 0 1.525.043l5.833-6.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CheckmarkSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.655 5.244a1 1 0 0 1 .1 1.411l-5.202 6a1 1 0 0 1-1.51 0l-2.8-3.227a1 1 0 0 1 1.512-1.31l2.042 2.355 4.447-5.128a1 1 0 0 1 1.41-.1z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CheckmarkIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.609 6.207a1 1 0 0 1 .184 1.402l-7.672 10a1 1 0 0 1-1.51.089l-4.327-4.445a1 1 0 0 1 1.432-1.395l3.522 3.616 6.969-9.083a1 1 0 0 1 1.402-.184z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ChevronDownIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.298 7.82a1 1 0 0 1 1.414 0l5.292 5.292 5.283-5.292a1 1 0 1 1 1.416 1.413l-5.99 6-.708-.707.708.706a1.002 1.002 0 0 1-1.415.002l-6-6a1 1 0 0 1 0-1.415z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ChevronLeftIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.707 18.707a1 1 0 0 0 0-1.414L10.415 12l5.292-5.283a1 1 0 1 0-1.414-1.416l-5.999 5.99L9 12l-.706-.708a1.002 1.002 0 0 0-.001 1.415l6 6a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ChevronRightIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.293 5.293a1 1 0 0 0 0 1.414L13.585 12l-5.292 5.283a1 1 0 0 0 1.414 1.416l5.999-5.99L15 12l.706.708a1.002 1.002 0 0 0 .001-1.415l-6-6a1 1 0 0 0-1.414 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ChevronUpIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.702 15.233a1 1 0 0 1-1.414 0l-5.292-5.292-5.283 5.292a1 1 0 0 1-1.416-1.413l5.99-6 .708.706-.708-.705a1.002 1.002 0 0 1 1.415-.002l6 6a1 1 0 0 1 0 1.414z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ClockIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm-.563-12.094a.844.844 0 0 1 1.688 0V12h1.969a.844.844 0 0 1 0 1.688H12.28a.844.844 0 0 1-.844-.844V8.906z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CloseSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 9A7 7 0 1 1 2 9a7 7 0 0 1 14 0zm-5.061-2.79a.65.65 0 0 1 .92.919l-1.93 1.929 1.889 1.889a.65.65 0 1 1-.92.919L9.01 9.977l-1.89 1.89a.65.65 0 0 1-.919-.92l1.89-1.89-1.93-1.929a.65.65 0 0 1 .92-.919l1.929 1.93 1.929-1.93z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CloseIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.709 6.707a1 1 0 0 1 1.414 0l9.9 9.9a1 1 0 0 1-1.415 1.414l-9.9-9.9a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.021 6.707a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-1.413-1.415l9.9-9.899a1 1 0 0 1 1.413 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CodeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.616 12.884a1.25 1.25 0 0 1 0-1.768L6.152 7.58a1.25 1.25 0 1 1 1.767 1.768L5.268 12l2.651 2.652a1.25 1.25 0 0 1-1.767 1.767l-3.536-3.535zm11.727-9.086a1.25 1.25 0 0 1 .859 1.545l-4 14a1.25 1.25 0 1 1-2.404-.687l4-14a1.25 1.25 0 0 1 1.545-.858zm1.773 3.782a1.25 1.25 0 0 1 1.768 0l3.535 3.536a1.25 1.25 0 0 1 0 1.768l-3.535 3.535a1.25 1.25 0 0 1-1.768-1.768L18.768 12l-2.652-2.652a1.25 1.25 0 0 1 0-1.768z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CommunityIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52 13.664a.152.152 0 0 0-.131-.078H5.338c-1.98 0-3.06 2.301-1.79 3.812.22.27.55.42.9.42h2.695a.15.15 0 0 0 .14-.099c.029-.08.06-.163.095-.24a3.796 3.796 0 0 1 3.044-2.19c.137-.014.204-.195.106-.293a6.16 6.16 0 0 1-1.007-1.332zm-.848-1.66a.15.15 0 0 0 .162-.18 6.027 6.027 0 0 1 3.93-6.808c.095-.034.135-.15.073-.23A4.516 4.516 0 0 0 9.237 3c-2.5 0-4.53 2.031-4.53 4.533 0 2.31 1.733 4.188 3.965 4.47zm9.985 4.764h-7.8c-1.98 0-3.06 2.3-1.79 3.812.22.27.55.42.9.42h9.58c.35 0 .68-.15.9-.42 1.28-1.511.2-3.812-1.79-3.812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.796 15.12a4.531 4.531 0 0 0 3.368-5.452 4.531 4.531 0 1 0-8.818 2.082 4.531 4.531 0 0 0 5.45 3.37z"
  })), props.children);
};
var V2ContactUsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.617 11.617A9.617 9.617 0 0 1 12 21.234a9.588 9.588 0 0 1-3.695-.736l-.001.012a.909.909 0 0 0-.778-.053l-3.691 1.475A.928.928 0 0 1 2.6 20.818l1.09-3.823a.882.882 0 0 0-.048-.618 9.573 9.573 0 0 1-1.259-4.76 9.617 9.617 0 0 1 19.234 0zm-7.587.013c-.54.55-1.04 1.06-1.14 1.75-.01.05-.05.08-.1.08h-1.64c-.03 0-.06-.01-.07-.03l-.004-.009c-.01-.02-.024-.045-.016-.071.11-.948.738-1.618 1.347-2.267l.003-.003c.55-.59 1.07-1.15 1.07-1.83 0-1-.62-1.55-1.75-1.55-1.21 0-2.27.69-2.95 1.26-.05.03-.09.03-.12.02-.04-.02-.06-.05-.06-.09v-1.6c0-.03.01-.06.04-.08C9.09 6.85 10.32 6 11.99 6c2.07 0 3.41 1.21 3.41 3.09 0 1.13-.687 1.837-1.35 2.52l-.02.02zm-2.08 5.57c-.66 0-1.2-.55-1.2-1.23 0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2 0 .69-.53 1.23-1.2 1.23z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CopyIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 2.776a2 2 0 0 0-2 2v1H16a1.5 1.5 0 0 1 1.5 1.5v9.5h2a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2h-8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9A1.5 1.5 0 0 1 5 7.5h9A1.5 1.5 0 0 1 15.5 9v10a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 19V9z"
  })), props.children);
};
var V2CreditcardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.5 9.2c0 .44-.36.8-.8.8H5.3c-.44 0-.8-.36-.8-.8V7.8c0-.44.36-.8.8-.8h1.4c.44 0 .8.36.8.8v1.4zm7.99 6.29c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19a.658.658 0 0 1 0-.92c.67-.67.67-1.76 0-2.42a.658.658 0 0 1 0-.92c.25-.25.67-.25.92 0a3.006 3.006 0 0 1 0 4.26zm2.71 1.3c-.13.13-.29.19-.46.19-.17 0-.33-.06-.46-.19a.658.658 0 0 1 0-.92 3.549 3.549 0 0 0 0-5.01.658.658 0 0 1 0-.92c.25-.25.67-.25.92 0 1.89 1.88 1.89 4.96 0 6.85z"
  })), props.children);
};
var V2CriticalSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.684 12.716l-5.252-9.091c-.636-1.1-2.228-1.1-2.864 0l-5.252 9.091c-.636 1.1.16 2.484 1.433 2.484H14.25c1.274 0 2.07-1.383 1.433-2.484zM8.502 6.192h1.003c.18 0 .325.173.311.367l-.346 3.826c-.006.104-.09.187-.186.187h-.54c-.097 0-.18-.083-.187-.187l-.367-3.82c-.013-.2.125-.373.312-.373zm.505 7.05a.81.81 0 0 1-.81-.81c0-.442.367-.809.81-.809a.81.81 0 0 1 0 1.62z"
  })), props.children);
};
var V2CriticalIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.64 17.34L14.05 4.2c-.92-1.59-3.22-1.59-4.14 0L2.32 17.34c-.92 1.59.23 3.59 2.07 3.59h15.18c1.84 0 2.99-2 2.07-3.59zM11.26 7.91h1.45c.26 0 .47.25.45.53l-.5 5.53c-.01.15-.13.27-.27.27h-.78c-.14 0-.26-.12-.27-.27l-.53-5.52c-.02-.29.18-.54.45-.54zm.73 10.19c-.64 0-1.17-.52-1.17-1.17 0-.64.53-1.17 1.17-1.17.65 0 1.17.53 1.17 1.17 0 .65-.52 1.17-1.17 1.17z"
  })), props.children);
};
var V2CryptoIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 2a1 1 0 0 1 1 1v3h2V3a1 1 0 1 1 2 0v3h2.333C18.253 6 19 6.746 19 7.667v2.207a1 1 0 1 1-2 0V8H7v8h10v-1.78a1 1 0 1 1 2 0v2.113c0 .92-.746 1.667-1.667 1.667H15v3a1 1 0 1 1-2 0v-3h-2v3a1 1 0 1 1-2 0v-3H6.667C5.747 18 5 17.254 5 16.333V7.667C5 6.747 5.746 6 6.667 6H9V3a1 1 0 0 1 1-1z",
    clipRule: "evenodd"
  })), props.children);
};
var V2CurrencyChfIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.184 12.106c0-1.308.99-2.184 2.48-2.184.694 0 1.33.148 2.002.478V8.444C6.88 8.114 6.244 8 5.539 8 2.99 8 1 9.638 1 12.106c0 2.469 1.99 4.107 4.539 4.107.705 0 1.342-.114 2.127-.444v-1.956a4.387 4.387 0 0 1-2.014.466c-1.478 0-2.468-.864-2.468-2.173zm10.766 3.982h2.14V8.125h-2.14v3.094h-3.06V8.125H8.753v7.963h2.139V12.96h3.06v3.128zm5.637 0v-2.9h3.06v-1.741h-3.06V9.866H23v-1.74h-5.551v7.962h2.138z"
  })), props.children);
};
var V2CurrencyDollarIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.697 10.179c-2.28-.93-2.666-1.419-2.67-2.163-.003-.889.714-1.422 1.92-1.427 1.474-.006 2.37.5 2.798.741l.75.423 1.138-3.037-.536-.31a7.061 7.061 0 0 0-2.658-.887l-.244-.032-.01-2.471-3.025.013.011 2.662-.203.06c-2.21.66-3.576 2.415-3.567 4.579.012 2.826 2.34 4.105 4.617 4.984 2.2.88 2.387 1.643 2.39 2.289.004 1.043-.876 1.721-2.246 1.727-1.11.005-2.31-.346-3.21-.94l-.784-.516-1.093 3.085.454.32c.795.56 2.025.99 3.29 1.15l.247.03.01 2.57 3.051-.013-.011-2.738.2-.06c2.318-.701 3.754-2.54 3.744-4.803-.013-3.094-2.339-4.424-4.363-5.236z"
  })), props.children);
};
var V2CurrencyEuroIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.28 11.223l.726-2.143H9.874c.68-1.695 2.273-2.66 4.265-2.66 1.125 0 2.203.235 3.258.847V4.253C16.131 3.688 15.1 3.5 13.928 3.5c-3.797 0-6.82 2.12-7.71 5.58H4.6v2.143h9.68zm3.117 8.5v-2.99c-1.055.612-2.133.824-3.258.824-2.062 0-3.656-1.013-4.312-2.731h3.258l.773-2.143H4.6v2.143h1.617c.82 3.508 3.844 5.674 7.711 5.674 1.172 0 2.203-.165 3.469-.777z"
  })), props.children);
};
var V2CurrencyPoundIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.445 12.164l.68-2.11h-3.328c.937-2.015 1.992-2.788 3.539-2.788.773 0 1.43.117 2.367.421V4.829c-.867-.398-1.594-.492-2.531-.492-3.399 0-5.367 2.156-6.82 5.719h-2.79l-.773 2.11h9.656zm2.602 6.305H9.234l1.149-2.719h4.125l.703-2.133H5.437l-.796 2.133h2.296l-1.382 3.164V21h12.492v-2.531z"
  })), props.children);
};
var V2CurrencyRupeeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.93 22l-4.68-8.164v-1.924h1.56c.92 0 1.69-.2 2.314-.598a2.763 2.763 0 0 0 1.196-1.716H6.25V7.674h5.044a3.096 3.096 0 0 0-.962-1.638c-.485-.45-1.16-.676-2.028-.676H6.25V3.436h11.727V5.36h-4.082a4.51 4.51 0 0 1 1.144 2.314h2.938v1.924H15.09c-.174 1.283-.668 2.288-1.482 3.016-.815.71-1.864 1.196-3.146 1.456L15.559 22H10.93z"
  })), props.children);
};
var V2CurrencyYenIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.602 12.53v-2.286H15.91l4.748-6.017h-4.367l-4.215 5.789-4.29-5.79h-4.42l4.748 6.018H5.398v2.285h13.204zm0 3.884V14.13H5.398v2.285h4.698V22h3.808v-5.586h4.698z"
  })), props.children);
};
var V2DashboardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76 3A2.76 2.76 0 0 0 3 5.76v2.32c0 .508.413.92.92.92h6.44a.92.92 0 0 0 .92-.92V3.92a.92.92 0 0 0-.92-.92h-4.6zM21.4 5.76A2.76 2.76 0 0 0 18.64 3h-4.6a.92.92 0 0 0-.92.92v8.16c0 .508.412.92.92.92h6.44a.92.92 0 0 0 .92-.92V5.76zm0 12.88a2.76 2.76 0 0 1-2.76 2.76h-4.6a.92.92 0 0 1-.92-.92l-.04-4.56A.92.92 0 0 1 14 15h6.44a.92.92 0 0 1 .92.92l.04 2.72zm-18.4 0a2.76 2.76 0 0 0 2.76 2.76h4.6a.92.92 0 0 0 .92-.92v-8.56a.92.92 0 0 0-.92-.92H3.92a.92.92 0 0 0-.92.92v6.72z"
  })), props.children);
};
var V2DataprivacyIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.23c-1.04 0-1.59.55-1.59 1.58v.17c0 .04.04.08.08.08h3c.05 0 .09-.04.09-.09v-.16c0-1.03-.54-1.58-1.58-1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6h-9.67l-.74-1.1c-.37-.56-1-.9-1.67-.9H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-4.46 10.41c0 .74-.59 1.33-1.33 1.33H9.79c-.74 0-1.33-.59-1.33-1.33v-3.02c0-.6.4-1.09.94-1.26.04-.02.05-.07.05-.11v-.21c0-1.4 1.14-2.55 2.55-2.55 1.4 0 2.55 1.14 2.55 2.55v.21c0 .04.01.09.05.11.54.17.94.66.94 1.26v3.02z"
  })), props.children);
};
var V2DealsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.854 5.262L8.23 9.145a2.68 2.68 0 0 0 .305 1.736l4.4 7.841a2.55 2.55 0 0 0 3.546.946l4.203-2.497a2.706 2.706 0 0 0 .976-3.631l-4.4-7.841a2.563 2.563 0 0 0-1.309-1.14l-3.58-1.387c-1.541-.596-3.25.418-3.517 2.09zm4.684.832c.41.73.157 1.67-.564 2.098-.721.428-1.638.227-2.047-.503a1.563 1.563 0 0 1 .564-2.097c.72-.429 1.637-.227 2.047.502z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08 9.058l.539-3.364c.048-.301.124-.59.223-.866a2.532 2.532 0 0 0-2.808.901l-1.504 2A2.658 2.658 0 0 0 3 9.343l.058 8.96c.01 1.464 1.18 2.66 2.616 2.67L9.46 21a2.554 2.554 0 0 0 2.36-1.546 4.539 4.539 0 0 1-.4-.598l-3.811-6.791a4.644 4.644 0 0 1-.529-3.007z"
  })), props.children);
};
var V2DeleteIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.42 6.308l-.696-.653a4.595 4.595 0 0 0-3.17-1.254h-.327A3.686 3.686 0 0 0 11.773 2c-1.59 0-2.918 1-3.455 2.401h-.326c-1.18 0-2.307.453-3.17 1.254l-.685.653c-.284.263-.095.737.295.737h14.703c.379 0 .568-.463.284-.737zM10.108 4.4c.39-.495.99-.821 1.664-.821.684 0 1.274.326 1.664.821h-3.328zm7.51 3.709H5.948a.42.42 0 0 0-.41.484L6.243 20a2.107 2.107 0 0 0 2.086 1.79h6.909A2.107 2.107 0 0 0 17.323 20l.706-11.417a.421.421 0 0 0-.411-.474z"
  })), props.children);
};
var V2DesktopIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2.5 2.5 0 0 1 2.5-2.5h13A2.5 2.5 0 0 1 21 5v9a2.5 2.5 0 0 1-2.5 2.5H13V18h4a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2h4v-1.5H5.5A2.5 2.5 0 0 1 3 14V5zm3 7.5a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H6z",
    clipRule: "evenodd"
  })), props.children);
};
var V2DirectdepositIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 3.001a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v7.906a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V3zM3.164 18.222a.54.54 0 0 1 0-.775l1.37-1.34a.966.966 0 0 0 .199-.299c.427-.952 1.564-1.633 2.901-1.633v-.002h6.16c.85 0 1.54.675 1.54 1.508 0 .832-.69 1.387-1.54 1.387H10.64l-.009.03c-.054.194-.134.476-.236.64l4.236.708a1.9 1.9 0 0 0 1.42-.33l2.556-1.83a1.423 1.423 0 0 1 1.982 0 1.35 1.35 0 0 1 0 1.938l-3.13 2.397a2.85 2.85 0 0 1-2.046.57l-6.067-.67a.782.782 0 0 0-.65.235l-1.043 1.083a.57.57 0 0 1-.792 0l-3.698-3.617zM19.5 3.35h-15v6.835h15V3.349z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.261 5.383c0-.41.336-.742.75-.742h9.978c.414 0 .75.332.75.742s-.336.743-.75.743H7.01a.746.746 0 0 1-.75-.743zm.75 1.78a.746.746 0 0 0-.75.742c0 .41.336.743.75.743h5.449c.414 0 .75-.333.75-.743a.746.746 0 0 0-.75-.742H7.01z"
  })), props.children);
};
var V2DownloadIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.34 13.53h-.22c-.35 0-.64.29-.64.64v4.05c0 .69-.49 1.25-1.08 1.25H5.58c-.6 0-1.08-.56-1.08-1.25v-4.05c0-.35-.29-.64-.64-.64h-.22c-.35 0-.64.29-.64.64v4.05c0 1.52 1.16 2.75 2.58 2.75h12.81c1.42 0 2.58-1.23 2.58-2.75v-4.05a.63.63 0 0 0-.63-.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.58 16.53c.23.23.61.23.84 0l4.55-4.51c.38-.37.11-1.02-.42-1.02h-1.8V3.91c0-.5-.41-.91-.91-.91h-3.68c-.5 0-.91.41-.91.91V11h-1.8c-.53 0-.8.65-.42 1.02l4.55 4.51z"
  })), props.children);
};
var V2EditIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.525 5.65l-1.17-1.17a1.68 1.68 0 0 0-2.352 0L14.6 5.883a.44.44 0 0 0 0 .63l2.893 2.892a.44.44 0 0 0 .63 0l1.402-1.402c.31-.31.486-.729.486-1.17a1.68 1.68 0 0 0-.486-1.182zm-5.62 1.546a.44.44 0 0 0-.63 0l-8.248 8.249c-.033.066-.078.132-.11.199l-.906 3.842a.412.412 0 0 0 .408.508c.034 0 .067 0 .1-.01l3.842-.906c.067-.033.133-.078.2-.11l8.248-8.25a.44.44 0 0 0 0-.629l-2.904-2.893z"
  })), props.children);
};
var V2EducationIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.62 8.35c-.935-1.571-3.972-3.432-5.608-2.676 0 0-.41.116-.41.698 0 .581.118 9.306.118 9.306 0 .116.175.29.526.29 2.161-.116 4.264.873 5.316 1.862l.058-9.48z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.902 7.767a5.908 5.908 0 0 0-.876.408s-.526.29-.526.93c0 .582.117 9.248.117 9.248 0 .116.234.233.7.058 2.104-.756 4.09-.989 5.61-.872-1.11-.582-2.513-.93-3.681-.873-.585 0-1.227-.29-1.286-.989 0-2.617-.058-5.292-.058-7.91zm7.536.583c.876-1.571 3.914-3.432 5.55-2.676 0 0 .409.116.409.698 0 .581-.059 9.306-.059 9.306 0 .116-.175.29-.525.29-2.22-.116-4.265.873-5.375 1.862V8.35z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.098 7.767c.35.117.643.233.876.408 0 0 .526.29.526.93 0 .582-.117 9.248-.117 9.248 0 .116-.234.233-.7.058-2.046-.756-4.032-.989-5.55-.872 1.11-.582 2.453-.93 3.621-.873.584 0 1.285-.29 1.285-.989 0-2.617.059-5.292.059-7.91z",
    clipRule: "evenodd"
  })), props.children);
};
var V2EmojiIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM9 8.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zM16.25 10a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm-8.066 4.874a.75.75 0 0 0-1.345.663 5.75 5.75 0 0 0 10.322 0 .75.75 0 0 0-1.345-.663 4.25 4.25 0 0 1-7.632 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2FaceIdIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6zm7-2a.5.5 0 0 0-.5-.5H6A2.5 2.5 0 0 0 3.5 6v2.5A.5.5 0 0 0 4 9h.5a.5.5 0 0 0 .5-.5V6a1 1 0 0 1 1-1h2.5a.5.5 0 0 0 .5-.5V4zm6.5 1a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5H18A2.5 2.5 0 0 1 20.5 6v2.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V6a1 1 0 0 0-1-1h-2.5zM15 19.5a.5.5 0 0 1 .5-.5H18a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5V18a2.5 2.5 0 0 1-2.5 2.5h-2.5a.5.5 0 0 1-.5-.5v-.5zM4.5 15a.5.5 0 0 1 .5.5V18a1 1 0 0 0 1 1h2.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H6A2.5 2.5 0 0 1 3.5 18v-2.5A.5.5 0 0 1 4 15h.5zM10 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm1.5-.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1 0-1 .5.5 0 0 0 .5-.5v-3zm3.5 1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-6.098 5.367a.75.75 0 0 0-.805 1.266h.001l.003.002.006.004.02.012a4.386 4.386 0 0 0 .297.168c.198.105.48.242.826.379.688.271 1.66.552 2.75.552s2.063-.28 2.75-.552a8.258 8.258 0 0 0 1.058-.508l.066-.04.02-.011.006-.004.002-.002h.002a.75.75 0 0 0-.806-1.266l-.008.005a6.776 6.776 0 0 1-.89.43c-.58.229-1.358.448-2.2.448-.842 0-1.62-.22-2.2-.448a6.774 6.774 0 0 1-.85-.406 2.175 2.175 0 0 1-.04-.024l-.008-.005z",
    clipRule: "evenodd"
  })), props.children);
};
var V2FaqIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.994 2.083c-2.556.41-4.59 2.514-4.94 5.084a5.96 5.96 0 0 0 .822 3.954.402.402 0 0 1 .041.342l-.569 1.665a.41.41 0 0 0 .521.521l1.665-.569a.403.403 0 0 1 .343.041 5.952 5.952 0 0 0 3.953.823c2.57-.35 4.667-2.385 5.085-4.94a6.009 6.009 0 0 0-6.921-6.921zm8.221 7.97a6.149 6.149 0 0 1 1.794.03c2.556.41 4.591 2.514 4.94 5.084a5.961 5.961 0 0 1-.822 3.954.402.402 0 0 0-.04.342l.568 1.665a.41.41 0 0 1-.52.521l-1.666-.569a.403.403 0 0 0-.342.041 5.952 5.952 0 0 1-3.954.823c-2.57-.35-4.666-2.385-5.084-4.94a6.178 6.178 0 0 1-.029-1.79 7.538 7.538 0 0 0 5.155-5.161zm-7.871.678a.76.76 0 0 0 .75.77c.418 0 .75-.338.75-.77a.752.752 0 0 0-.75-.75.752.752 0 0 0-.75.75zM8.68 9.114c.063-.432.375-.75.713-1.094l.012-.012c.415-.428.844-.87.844-1.576 0-1.175-.838-1.93-2.131-1.93-1.044 0-1.813.53-2.094.755a.057.057 0 0 0-.025.05v1c0 .025.013.044.037.057.02.006.044.006.075-.013.425-.356 1.088-.787 1.844-.787.706 0 1.094.343 1.094.968 0 .425-.325.775-.669 1.144l-.002.002c-.38.406-.773.824-.841 1.417-.006.016.003.032.01.045l.002.005c.006.012.025.019.044.019h1.025a.06.06 0 0 0 .062-.05zM13.5 16.5a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1h-5zM14 15a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2FavoriteSelectedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.35 5c-3.061 0-4.06 1.87-4.3 2.437-.018.043-.08.043-.099 0C11.711 6.87 10.711 5 7.651 5c-3.76 0-5.79 3.94-3.98 8C5.31 16.68 10 20 12 20c1.999 0 6.7-3.31 8.33-7 1.81-4.06-.22-8-3.98-8z"
  })), props.children);
};
var V2FavoriteIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.679 7.028C3.594 5.208 5.38 4 7.65 4c1.752 0 2.992.542 3.839 1.23.193.157.362.32.51.48.15-.16.319-.323.512-.48C13.358 4.542 14.597 4 16.35 4c2.27 0 4.056 1.208 4.971 3.028.905 1.798.93 4.115-.078 6.378-.902 2.042-2.614 3.913-4.32 5.262-.86.68-1.745 1.25-2.565 1.654-.794.391-1.629.678-2.358.678-.73 0-1.564-.288-2.357-.68-.82-.405-1.705-.975-2.564-1.656-1.704-1.351-3.415-3.22-4.322-5.257m-.078-6.38c-.905 1.799-.93 4.117.078 6.38zm1.786.9c-.597 1.187-.682 2.87.119 4.666.733 1.644 2.187 3.274 3.738 4.503.768.61 1.534 1.099 2.207 1.431.7.346 1.202.473 1.471.473.27 0 .773-.127 1.474-.472.674-.332 1.44-.82 2.209-1.428 1.552-1.228 3.004-2.857 3.732-4.504l.001-.003c.801-1.797.716-3.479.119-4.666C18.948 6.762 17.84 6 16.35 6c-1.31 0-2.1.393-2.578.782a2.784 2.784 0 0 0-.803 1.046c-.363.854-1.575.854-1.938 0a2.785 2.785 0 0 0-.804-1.046C9.75 6.393 8.96 6 7.65 6c-1.49 0-2.598.762-3.185 1.927z",
    clipRule: "evenodd"
  })), props.children);
};
var V2FilterIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4 15.75h-8.48A3.515 3.515 0 0 0 8.5 13c-1.67 0-3.07 1.18-3.42 2.75H3.6c-.33 0-.6.27-.6.6v.3c0 .33.27.6.6.6h1.48A3.515 3.515 0 0 0 8.5 20c1.67 0 3.07-1.18 3.42-2.75h8.48c.33 0 .6-.27.6-.6v-.3c0-.33-.27-.6-.6-.6zm-10.05 1.5c-.07.17-.16.32-.27.46-.02.03-.05.06-.07.08-.11.13-.23.24-.37.34l-.02.02c-.14.1-.3.17-.46.22-.05.02-.09.03-.14.04-.16.04-.32.07-.49.08-.01 0-.02.01-.04.01s-.02-.01-.04-.01c-.17 0-.33-.03-.49-.08-.05-.01-.09-.03-.14-.04-.16-.06-.32-.13-.46-.22l-.02-.02c-.14-.1-.26-.21-.37-.34-.02-.03-.05-.06-.07-.09-.11-.14-.2-.29-.27-.45v-.01c-.07-.22-.13-.47-.13-.74s.05-.52.15-.75v-.01c.07-.16.16-.31.27-.45.02-.03.05-.06.07-.09.11-.13.23-.24.37-.34l.02-.02c.14-.1.29-.17.46-.22.05-.02.09-.03.14-.04.16-.04.32-.07.49-.07.01 0 .03-.01.04-.01.01 0 .03.01.04.01.17 0 .33.03.49.07.05.01.09.03.14.04.16.06.32.13.46.22l.02.02c.14.1.26.21.37.34.02.03.05.06.07.08.11.14.2.29.27.45v.01c.09.23.15.48.15.75s-.08.53-.17.76zM20.4 6.75h-1.48A3.515 3.515 0 0 0 15.5 4c-1.67 0-3.07 1.18-3.42 2.75H3.6c-.33 0-.6.27-.6.6v.3c0 .33.27.6.6.6h8.48A3.515 3.515 0 0 0 15.5 11c1.67 0 3.07-1.18 3.42-2.75h1.48c.33 0 .6-.27.6-.6v-.3c0-.33-.27-.6-.6-.6zm-3.05 1.5c-.07.17-.16.32-.27.46-.02.03-.05.06-.07.09-.11.13-.23.24-.37.34l-.02.02c-.14.1-.29.17-.46.22-.05.02-.09.03-.14.04-.16.04-.32.07-.49.07-.01 0-.03.01-.04.01-.01 0-.03-.01-.04-.01-.17 0-.33-.03-.49-.07-.05-.01-.09-.03-.14-.04-.16-.06-.32-.13-.46-.22l-.02-.02c-.14-.1-.26-.21-.37-.34a.572.572 0 0 0-.07-.08c-.11-.14-.2-.29-.27-.45v-.01c-.07-.24-.13-.49-.13-.76s.05-.52.15-.75v-.01c.07-.17.16-.31.27-.45.02-.03.05-.06.07-.08.11-.13.23-.24.37-.34l.02-.02c.14-.1.3-.17.46-.22.05-.02.09-.03.14-.04.16-.04.32-.07.49-.08.01 0 .02-.01.04-.01s.02.01.04.01c.17 0 .33.03.49.08.05.01.09.03.14.04.16.06.32.13.46.22l.02.02c.14.1.26.21.37.34.02.03.05.06.07.09.11.14.2.29.27.45v.01c.09.23.15.48.15.75s-.08.51-.17.74z"
  })), props.children);
};
var V2FingerprintIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 22c4.142 0 7.5-5.386 7.5-10.91C19 5.569 15.642 2 11.5 2 7.358 2 4 5.568 4 11.09 4 16.615 7.358 22 11.5 22zm.039-17.53c1.531-.048 2.806.726 3.694 2.175.898 1.465 1.389 3.611 1.275 6.21a.5.5 0 0 0 .999.043c.12-2.73-.39-5.091-1.421-6.775-1.041-1.7-2.626-2.714-4.579-2.653-1.65.052-2.898.719-3.832 1.755-.92 1.021-1.52 2.384-1.944 3.822a.5.5 0 1 0 .959.283c.404-1.374.952-2.573 1.728-3.435.762-.846 1.757-1.382 3.12-1.425zm.521 4.454a.5.5 0 1 0-.981-.19c-.55 2.834-2.7 4.44-4.829 5.713a.5.5 0 1 0 .514.858c2.153-1.288 4.658-3.09 5.296-6.38zM10.542 7.21c-.372.356-.688.919-1.027 1.721-.35.826-.695 1.529-1.2 2.161-.508.638-1.157 1.179-2.089 1.718a.5.5 0 1 1-.5-.865c.85-.493 1.394-.958 1.808-1.476.417-.524.72-1.125 1.06-1.927.348-.823.728-1.548 1.255-2.054.554-.532 1.242-.795 2.12-.75.938.047 1.643.551 2.038 1.312.385.74.468 1.695.272 2.69-.15.763-.417 1.945-1.347 3.3-.928 1.352-2.492 2.842-5.19 4.278a.5.5 0 0 1-.47-.882c2.584-1.376 4.015-2.767 4.835-3.962.818-1.19 1.051-2.22 1.19-2.928.166-.84.076-1.55-.177-2.035-.242-.465-.64-.747-1.2-.775-.62-.031-1.034.143-1.378.474zm4.94 4.825a.5.5 0 0 0-.95-.316c-.296.89-.177 1.886.132 2.709.303.808.835 1.567 1.495 1.896a.5.5 0 1 0 .447-.894c-.341-.17-.746-.662-1.006-1.353-.254-.678-.322-1.43-.118-2.042zm-1.671 4.912c-.118-.197-.355-.371-.82-.336-1.05.08-1.875.878-2.053 1.578-.086.339-.032.685.128.932.15.23.412.412.85.412.891 0 1.583-.75 1.923-1.645.14-.37.105-.718-.028-.941zm.857-.514c.321.535.333 1.212.106 1.81-.398 1.047-1.346 2.29-2.858 2.29-.765 0-1.35-.343-1.689-.868-.328-.508-.404-1.145-.258-1.722.287-1.13 1.484-2.218 2.947-2.329.793-.06 1.416.258 1.752.819z",
    clipRule: "evenodd"
  })), props.children);
};
var V2FlagIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.84a.96.96 0 0 1 1.92 0v.96h10.125a.72.72 0 0 1 .662 1.004l-1.44 3.356a.48.48 0 0 0 .008.396l1.368 2.853a.72.72 0 0 1-.65 1.03H6.72v6.72h.96a.96.96 0 1 1 0 1.92H3.84a.96.96 0 1 1 0-1.92h.96V3.84z"
  })), props.children);
};
var V2FoodIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.572 18.895c.745-1.16.426-2.625-.257-3.821a27.337 27.337 0 0 0-1.948-2.947.395.395 0 0 0-.556-.073l-1.637 1.259a.564.564 0 0 1-.74-.046.55.55 0 0 1 0-.783l1.522-1.505a.396.396 0 0 0 .02-.544 27.39 27.39 0 0 0-.648-.702.396.396 0 0 0-.532-.035l-2.231 1.765a.56.56 0 0 1-.741-.04.546.546 0 0 1 0-.778l1.907-1.887a.395.395 0 0 0-.013-.577 27.53 27.53 0 0 0-.751-.644.396.396 0 0 0-.494-.007l-1.77 1.361a.564.564 0 0 1-.74-.045.55.55 0 0 1 0-.783l1.282-1.268a.395.395 0 0 0-.048-.605 27.72 27.72 0 0 0-2.361-1.48l-.167-.093c-1.102-.616-2.438-.888-3.533-.259-.882.507-1.277 1.422-1.091 2.707.372 2.58 10.433 12.529 13.041 12.897 1.22.173 1.967-.259 2.486-1.067z"
  })), props.children);
};
var V2GoalsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.954 5.6a.317.317 0 0 0-.304-.14 2.85 2.85 0 0 1-2.338-.785 2.837 2.837 0 0 1-.773-2.325.316.316 0 0 0-.468-.31c-.533.304-1.768 1.153-1.768 2.49v1.444c-1.47 1.33-3.8 3.547-3.8 4.257v.69a.316.316 0 0 1-.096.222l-1.716 1.717a.317.317 0 0 1-.543-.225.318.318 0 0 1 .093-.225l1.628-1.622v-.38a2.82 2.82 0 0 0-.95-.177 2.863 2.863 0 1 0 2.362 1.267h.488c.33 0 .995-.513 1.742-1.204a5.391 5.391 0 1 1-2.375-2.116c.443-.487 1.058-1.102 1.9-1.9a7.81 7.81 0 0 0-4.117-1.115 7.918 7.918 0 1 0 7.918 7.918 7.824 7.824 0 0 0-1.508-4.624l.697-.76h1.445c1.336 0 2.191-1.235 2.49-1.768a.317.317 0 0 0-.007-.329z"
  })), props.children);
};
var V2GoldIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.81 19.348c-1.909-.41-3.35-1.223-4.323-2.44-.96-1.23-1.454-2.817-1.48-4.764-.012-1.268.219-2.414.692-3.439A6.825 6.825 0 0 1 7.736 6.17c.883-.666 1.908-1.095 3.073-1.287V3h2.42v1.883c1.307.243 2.421.736 3.343 1.479.935.73 1.64 1.825 2.114 3.285h-2.344a4.097 4.097 0 0 0-1.71-1.921c-.755-.461-1.64-.692-2.65-.692-.73 0-1.39.135-1.98.404-.576.256-1.018.544-1.325.864a4.975 4.975 0 0 0-1.057 1.69c-.204.59-.307 1.288-.307 2.094a7 7 0 0 0 .269 1.845c.192.64.455 1.159.788 1.556.525.602 1.075 1.03 1.652 1.287.576.256 1.23.384 1.96.384 1.357 0 2.394-.243 3.111-.73.448-.307.788-.66 1.018-1.057.23-.41.385-.89.461-1.44h-3.65v-2.056h6.07c0 1.358-.12 2.459-.364 3.304a5.077 5.077 0 0 1-1.191 2.152 6.211 6.211 0 0 1-1.902 1.383 6.887 6.887 0 0 1-2.324.634V21h-2.402v-1.652z"
  })), props.children);
};
var V2HelpIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.336 2l-.016.002c-.1.013-.2.026-.3.037-.218.027-.444.054-.667.092-1.93.329-3.626 1.144-5.041 2.423-1.688 1.525-2.749 3.431-3.153 5.666-.045.252-.078.508-.11.755l-.046.342-.003.018v1.338l.005.026.014.062c.009.038.016.073.02.104.015.112.029.226.042.337.026.226.053.46.097.692a9.777 9.777 0 0 0 2.376 4.795c1.526 1.688 3.433 2.748 5.666 3.151.253.046.509.08.756.112.114.014.227.03.341.045l.018.003h1.338l.026-.005.062-.014a1.04 1.04 0 0 1 .104-.02c.112-.015.226-.029.337-.042a9.58 9.58 0 0 0 .692-.097 9.788 9.788 0 0 0 4.765-2.35 9.84 9.84 0 0 0 3.181-5.692c.047-.252.08-.508.112-.756.014-.114.029-.227.045-.341l.003-.018v-1.328l-.017-.137-.03-.25c-.175-1.538-.64-2.925-1.385-4.122-1.634-2.627-4.007-4.213-7.055-4.713-.191-.032-.385-.056-.572-.08-.086-.01-.173-.02-.26-.033L12.664 2h-1.328zM9.294 4.386a.387.387 0 0 1 .245-.517 8.679 8.679 0 0 1 2.463-.368c.812 0 1.637.124 2.46.368a.387.387 0 0 1 .244.517L14.184 5.7a.42.42 0 0 1-.51.24 5.832 5.832 0 0 0-1.67-.25c-.545 0-1.1.083-1.682.252a.416.416 0 0 1-.506-.24l-.522-1.316zm2.703 12.423c-.036 0-.071 0-.107-.002a4.772 4.772 0 0 1-3.366-1.492 4.778 4.778 0 0 1-1.33-3.439 4.77 4.77 0 0 1 1.444-3.304 4.791 4.791 0 0 1 6.781.054 4.754 4.754 0 0 1 1.386 3.38 4.728 4.728 0 0 1-1.395 3.38 4.784 4.784 0 0 1-3.413 1.423zm-7.631-2.095a.386.386 0 0 1-.514-.234c-.528-1.632-.525-3.263.01-4.951a.388.388 0 0 1 .516-.238l1.325.526c.199.08.299.3.24.506a5.962 5.962 0 0 0-.253 1.672c0 .546.082 1.1.252 1.683a.416.416 0 0 1-.24.505l-1.336.531zm15.273-5.43a.38.38 0 0 1 .505.222 7.53 7.53 0 0 1 .392 2.458 8.063 8.063 0 0 1-.4 2.519.383.383 0 0 1-.509.228l-1.327-.526a.418.418 0 0 1-.24-.51c.168-.566.25-1.118.25-1.674 0-.542-.083-1.095-.253-1.68a.416.416 0 0 1 .24-.504l1.342-.533zm-9.861 9.009a.418.418 0 0 1 .503-.241 6.304 6.304 0 0 0 1.698.238c.563 0 1.132-.08 1.7-.238a.418.418 0 0 1 .502.24l.53 1.332a.387.387 0 0 1-.24.516c-.827.26-1.659.39-2.48.39a8.392 8.392 0 0 1-2.501-.393.387.387 0 0 1-.24-.516l.528-1.328z"
  })), props.children);
};
var V2HideIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.15 14.85l10.6-10.6a.61.61 0 0 0 0-.85l-.22-.22a.61.61 0 0 0-.85 0L17.1 5.76a.203.203 0 0 1-.244.031C15.54 5.034 13.933 4.52 11.99 4.52c-6.07 0-8.85 4.96-9.75 7.06-.01 0-.01.01-.01.02-.045.098-.08.185-.11.265l-.03.075c-.01.01-.02.02-.01.04-.06.16-.08.35-.08.53 0 .18.03.36.07.53.005.009.007.02.01.03a4.128 4.128 0 0 0 .08.19 5.63 5.63 0 0 1 .08.18l.01.02c.32.77.9 1.91 1.8 3.05.281.36.601.713.946 1.057a.202.202 0 0 1 0 .286L3.17 19.68a.61.61 0 0 0 0 .85l.22.22c.23.23.61.23.85 0l4.84-4.84 1.07-1.06zM7.5 12.51c0-2.49 2.01-4.5 4.5-4.5a4.32 4.32 0 0 1 2.062.525.145.145 0 0 1 .031.232l-.91.91a.155.155 0 0 1-.168.033A2.706 2.706 0 0 0 12 9.51c-1.66 0-3 1.34-3 3 0 .363.074.701.2 1.015a.155.155 0 0 1-.033.168l-.91.91a.145.145 0 0 1-.232-.032A4.32 4.32 0 0 1 7.5 12.51z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.91 11.92a13.353 13.353 0 0 0-1.95-3.41 9.225 9.225 0 0 0-.514-.589.15.15 0 0 0-.215-.003l-2.952 2.953a.153.153 0 0 0-.035.16c.168.465.256.963.256 1.479 0 2.49-2.01 4.5-4.5 4.5a4.454 4.454 0 0 1-1.48-.257.153.153 0 0 0-.158.035l-2.574 2.565a.148.148 0 0 0 .04.238 9.573 9.573 0 0 0 4.162.919c6.2 0 8.99-5.21 9.84-7.22v-.01c.1-.24.16-.5.16-.77.01-.2-.02-.41-.08-.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002 12.51c0 1.66-1.34 3-3 3a1.15 1.15 0 0 1-.118-.007c-.084-.008-.121-.115-.061-.175l2.998-2.998c.06-.06.167-.023.175.062.003.039.006.078.006.117z"
  })), props.children);
};
var V2HomeGoalsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.507 9.473v-3.14h.094a.174.174 0 0 0 .174-.173v-.726a.174.174 0 0 0-.174-.174h-2.876a.174.174 0 0 0-.174.174v.726c0 .096.078.174.174.174h.094v.538l-3.266-3.159a.758.758 0 0 0-1.053 0L3.108 11.78a.35.35 0 0 0-.01.496l.566.589a.35.35 0 0 0 .496.01l1.329-1.278c-.008 1.179.005 6.215.005 8.083a.7.7 0 0 0 .7.7h11.618a.7.7 0 0 0 .702-.7v-8.088l1.323 1.28a.35.35 0 0 0 .496-.008l.569-.588a.35.35 0 0 0-.01-.495l-2.385-2.308zm-6.511 7.558c-5.808-3.42-2.436-7.576.013-4.854 2.46-2.712 5.812 1.463-.013 4.854z"
  })), props.children);
};
var V2HomeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.88 11.72L12.4 2.24l-.12-.12a.398.398 0 0 0-.57 0l-9.6 9.6c-.16.16-.16.41 0 .57l.49.49c.16.16.41.16.57 0l.67-.67c.04-.04.11-.04.15 0v6.54c0 1.66 1.34 3 3 3h2.1c.22 0 .4-.18.4-.4v-4.69c0-1.14.73-2.19 1.83-2.48 1.67-.43 3.17.81 3.17 2.41v4.76c0 .22.18.4.4.4H17c1.66 0 3-1.34 3-3v-6.54c.04-.04.11-.04.15 0l.67.67c.16.16.41.16.57 0l.49-.49c.16-.16.16-.42 0-.57z"
  })), props.children);
};
var V2HoneyIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.43 18.791c.713.03 1.454-.494 2.036-1.17.311-.353 1.213.132 1.002.606C19.787 19.709 18.423 21 16.87 21c-1.754-.01-2.716-1.16-2.716-2.874V14c0-.444-.221-.746-.682-.746-1.975 0-3.429 5.062-3.57 6.777-.04.575-.861.706-1.302.695-.391-.01-1.063-.14-1.113-.635 0-3.489 0-5.648.01-9.147-1.183-.06-2.526-.403-3.368-1.3-1.023-1.09-.803-2.693.711-3.087.13-.04.27.03.32.161.402.949 1.274 2.542 2.357 2.703 0-.464 0-1.35-.01-1.815-.03-6.04 8.04-5.87 7.89-1.069-.09 2.824-3.148 4.064-5.354 4.407v4.417c.742-2.016 1.745-4.467 4.27-4.367 1.455.102 2.226 1.16 2.357 2.482.05.443.05.897.04 1.35v2.37l-.001.144c-.006.575-.015 1.423.723 1.45zM10.745 4.874c-.491.585-.652 1.573-.682 2.32-.012.396-.013.869-.014 1.329-.001.31-.002.616-.006.889 1.153-.303 2.176-1.19 2.727-2.27.26-.493.41-1.2.3-1.774-.23-1.18-1.634-1.311-2.325-.494z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ImageBrokenIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.316 2.051a1 1 0 0 1 .633 1.265l-6 18a1 1 0 0 1-1.898-.632l6-18a1 1 0 0 1 1.265-.633z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.294 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6.628l.666-2H5.762c-.935 0-1.359-1.17-.64-1.768l3.376-2.813a1 1 0 0 1 1.087-.127l2.692 1.346c.04.02.08.037.12.051L15.295 5zM7 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.402 17h5.98a1 1 0 0 0 .894-1.447L17.7 10.398a1 1 0 0 0-1.675-.178l-.62.774L17.402 5H20c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-7.264l.666-2z"
  })), props.children);
};
var V2ImageIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm4.498 7.419l-3.376 2.813c-.719.599-.295 1.768.64 1.768h13.62a1 1 0 0 0 .894-1.447L17.7 10.398a1 1 0 0 0-1.675-.178l-2.519 3.149a1 1 0 0 1-1.228.27l-2.692-1.346a1 1 0 0 0-1.087.126zM5.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    clipRule: "evenodd"
  })), props.children);
};
var V2InformationSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.24 2.18c2.895.475 5.226 2.813 5.7 5.701a6.985 6.985 0 0 1-8.059 8.059c-2.895-.474-5.226-2.812-5.7-5.7a6.985 6.985 0 0 1 8.059-8.06zM8.993 6.66c-.54 0-.908-.39-.908-.885s.368-.9.908-.9c.547 0 .915.397.915.9.007.495-.368.885-.915.885zm.795 6.143a.32.32 0 0 1-.323.322h-.922a.32.32 0 0 1-.323-.322v-4.71c0-.165.12-.3.278-.323l.922-.127a.323.323 0 0 1 .368.322v4.838z",
    clipRule: "evenodd"
  })), props.children);
};
var V2InformationIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.86 10.31c-.68-4.14-4.02-7.49-8.17-8.17A10.011 10.011 0 0 0 2.14 13.69c.68 4.14 4.02 7.49 8.17 8.17a10.011 10.011 0 0 0 11.55-11.55zm-8.81 6.76c0 .24-.19.43-.43.43h-1.23c-.24 0-.43-.19-.43-.43v-6.28c0-.22.16-.4.37-.43l1.23-.17c.26-.04.49.17.49.43v6.45zm-1.06-8.19c-.72 0-1.21-.52-1.21-1.18 0-.66.49-1.2 1.21-1.2.73 0 1.22.53 1.22 1.2.01.66-.49 1.18-1.22 1.18z"
  })), props.children);
};
var V2InsightsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 3a5 5 0 0 0-5 5v7.94l5.116-5.117a1.25 1.25 0 0 1 1.768 0L11 11.94l4.69-4.689H14.5a.75.75 0 0 1 0-1.5H17c.69 0 1.25.56 1.25 1.25v2.5a.75.75 0 0 1-1.5 0V8.31l-4.866 4.867a1.25 1.25 0 0 1-1.768 0L9 12.06l-5.686 5.686A5.002 5.002 0 0 0 8 21h8a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5H8z",
    clipRule: "evenodd"
  })), props.children);
};
var V2InvestIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.22 4a1 1 0 0 1 1-1h2.6a1 1 0 0 1 1 1v17.16a1 1 0 0 1-1 1h-2.6a1 1 0 0 1-1-1V4zm-6.44 7.3a1 1 0 0 1 1-1h2.6a1 1 0 0 1 1 1v9.86a1 1 0 0 1-1 1h-2.6a1 1 0 0 1-1-1V11.3zM3.34 6.737a1 1 0 0 1 1-1h2.6a1 1 0 0 1 1 1V21.16a1 1 0 0 1-1 1h-2.6a1 1 0 0 1-1-1V6.737z"
  })), props.children);
};
var V2InvoiceIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8zm4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-3zm-4 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zM8 14.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm3.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zM8 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2LaptopIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 7.206a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8zm-2 10.5a.5.5 0 0 1 .5-.5h6.501L9 17.25c0 .415.336.75.75.75h4.5a.75.75 0 0 0 .749-.794H21.5a.5.5 0 0 1 .5.5v.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-.5zm3-10.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2LightBulbIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 16.459l-5.938.494a.77.77 0 0 1-.062.003v.997l5.938-.494a.765.765 0 0 1 .062-.003v-.997zm-.013 2.5l-5.875.49a2.501 2.501 0 0 0 2.388 1.757h1a2.5 2.5 0 0 0 2.487-2.246zm-5.99-3.505c-.036-.673-.422-1.274-.934-1.72a6 6 0 1 1 7.874 0c-.383.334-.696.755-.844 1.228a.754.754 0 0 0-.155-.003l-2.188.182v-1.624l1.28-1.28a.75.75 0 0 0-1.06-1.061l-.97.97-.97-.97a.75.75 0 1 0-1.06 1.06l1.28 1.28v1.751l-2.253.188z",
    clipRule: "evenodd"
  })), props.children);
};
var V2LinkIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65 19.34l1.83-1.83a3.9 3.9 0 0 0 .48-4.93l.64-.64a3.9 3.9 0 0 0 4.93-.48l1.83-1.83a3.899 3.899 0 0 0 0-5.51 3.899 3.899 0 0 0-5.51 0l-1.84 1.85c-.76.76-1.14 1.75-1.14 2.75 0 .76.22 1.52.66 2.17l-.64.64a3.886 3.886 0 0 0-4.92.48l-1.83 1.83C3.38 14.59 3 15.59 3 16.59s.38 2 1.14 2.75a3.899 3.899 0 0 0 5.51 0zm3.42-12.31L14.9 5.2c.93-.93 2.45-.93 3.39 0 .47.47.7 1.08.7 1.69 0 .61-.23 1.23-.7 1.69l-1.83 1.83c-.75.75-1.87.89-2.77.44l1.09-1.09c.09-.09.13-.2.13-.32s-.04-.23-.13-.32l-.42-.42a.453.453 0 0 0-.63 0l-1.1 1.09c-.45-.9-.31-2.01.44-2.76zM5.2 18.28c-.93-.93-.93-2.45 0-3.39l1.83-1.83c.75-.75 1.87-.89 2.77-.44l-1.1 1.1c-.09.09-.13.2-.13.32s.04.23.13.32l.43.43c.17.17.46.17.63 0l1.09-1.09a2.36 2.36 0 0 1-.44 2.76l-1.83 1.83c-.93.93-2.45.93-3.38-.01z"
  })), props.children);
};
var V2ListDetailedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.5a1.5 1.5 0 1 0 0 3h1a1.5 1.5 0 1 0 0-3h-1zM3 9.667a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 1 1 0 3h-1a1.5 1.5 0 0 1-1.5-1.5zm1.5 3.166a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 1 0 0-3h-1zm0 4.667a1.5 1.5 0 1 0 0 3h1a1.5 1.5 0 0 0 0-3h-1zM9 19a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 1 1 0 3h-9A1.5 1.5 0 0 1 9 19zm1.5-6.167a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 1 0 0-3h-9zM9 9.667a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1-1.5-1.5zM10.5 3.5a1.5 1.5 0 1 0 0 3h9a1.5 1.5 0 0 0 0-3h-9z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ListSimpleIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3.5a1.5 1.5 0 1 0 0 3h15a1.5 1.5 0 0 0 0-3h-15zM3 9.667a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 0 3h-15a1.5 1.5 0 0 1-1.5-1.5zm1.5 3.166a1.5 1.5 0 0 0 0 3h15a1.5 1.5 0 0 0 0-3h-15zm0 4.667a1.5 1.5 0 1 0 0 3h15a1.5 1.5 0 0 0 0-3h-15z",
    clipRule: "evenodd"
  })), props.children);
};
var V2LocationIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.898 8.217c-.99-3.256-4.182-5.495-7.564-5.18-3.66.324-6.53 3.409-6.53 7.159 0 4.965 5.253 9.363 6.782 10.54a.675.675 0 0 0 .828 0c1.717-1.321 8.23-6.79 6.484-12.519zM12 12.967a2.695 2.695 0 0 1-2.698-2.7A2.695 2.695 0 0 1 12 7.57a2.694 2.694 0 0 1 2.698 2.698A2.695 2.695 0 0 1 12 12.966z"
  })), props.children);
};
var V2LockIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.87 8.47c-.1-.04-.12-.15-.12-.24v-.48C17.75 4.58 15.17 2 12 2S6.25 4.58 6.25 7.75v.47c0 .09-.02.21-.12.25v.01C4.9 8.85 4 9.97 4 11.32v6.81c0 1.66 1.34 3 3 3h10c1.66 0 3-1.34 3-3v-6.81c0-1.35-.9-2.47-2.13-2.85zm-4.96 5.9c-.09.07-.16.17-.16.29v2.73c0 .21-.17.39-.39.39h-.72a.39.39 0 0 1-.39-.39v-2.73c0-.12-.06-.22-.16-.29-.36-.27-.59-.7-.59-1.19 0-.83.67-1.5 1.5-1.5a1.498 1.498 0 0 1 .91 2.69zm3.34-6.24c0 .11-.09.19-.2.2H7.94a.19.19 0 0 1-.19-.19v-.39A4.26 4.26 0 0 1 12 3.5a4.26 4.26 0 0 1 4.25 4.25v.38z"
  })), props.children);
};
var V2LogoutIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.11 11.9l-2.42-2.42a.61.61 0 0 0-.85 0l-.21.21a.61.61 0 0 0 0 .85l1.04 1.04h-2.58c-.33 0-.6.27-.6.6v.3c0 .33.27.6.6.6h2.58l-1.04 1.04a.61.61 0 0 0 0 .85l.21.21c.23.23.61.23.85 0l2.42-2.42c.12-.12.18-.27.18-.42a.647.647 0 0 0-.18-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.31 16.85H17c-.33 0-.6.27-.6.6V19c0 .28-.22.5-.5.5h-2.34V7.42c0-.73-.53-1.36-1.25-1.48L6.09 4.5h9.81c.28 0 .5.22.5.5v2.2c0 .33.27.6.6.6h.3c.33 0 .6-.27.6-.6V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v14.98c0 .73.53 1.36 1.25 1.48l6.55 1.52a1.5 1.5 0 0 0 1.75-1.48V21h2.35c1.1 0 2-.9 2-2v-1.54a.59.59 0 0 0-.59-.61z"
  })), props.children);
};
var V2LoyaltycardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm5.03 2.533a.5.5 0 0 0-.897 0L7.118 9.59a.5.5 0 0 1-.376.274l-2.27.33a.5.5 0 0 0-.277.852l1.642 1.601a.5.5 0 0 1 .144.442l-.388 2.26a.5.5 0 0 0 .726.528l2.03-1.067a.5.5 0 0 1 .465 0l2.03 1.067a.5.5 0 0 0 .726-.527l-.388-2.26a.5.5 0 0 1 .144-.443l1.642-1.6a.5.5 0 0 0-.277-.854l-2.27-.33a.5.5 0 0 1-.376-.273L9.03 7.533zm7.013 2.99a.5.5 0 0 1 .5-.5h2.916a.5.5 0 1 1 0 1h-2.916a.5.5 0 0 1-.5-.5zm.5 2.482a.5.5 0 1 0 0 1h2.916a.5.5 0 1 0 0-1h-2.916z",
    clipRule: "evenodd"
  })), props.children);
};
var V2MailIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.09 5H4.9A1.9 1.9 0 0 0 3 6.9v.58c0 .17.1.32.26.38l8.59 3.29c.09.03.19.03.28 0l8.59-3.29a.4.4 0 0 0 .26-.38V6.9c.01-1.05-.84-1.9-1.89-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.45 9.86l-7.97 3.05c-.16.06-.32.09-.49.09-.16 0-.33-.03-.48-.09L3.543 9.856A.4.4 0 0 0 3 10.23v6.879C3 18.15 3.85 19 4.9 19h14.2a1.9 1.9 0 0 0 1.9-1.9v-6.87c-.01-.28-.29-.48-.55-.37z"
  })), props.children);
};
var V2MenuIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 7a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 0 3h-15A1.5 1.5 0 0 1 3 7zm0 5a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 0 3h-15A1.5 1.5 0 0 1 3 12zm1.5 3.5a1.5 1.5 0 0 0 0 3h15a1.5 1.5 0 0 0 0-3h-15z",
    clipRule: "evenodd"
  })), props.children);
};
var V2MerchantIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7 8.17L17 3.492h.3c.4 0 .7-.299.7-.697 0-.497-.4-.796-.8-.796H6.7c-.4 0-.7.299-.7.697 0 .398.3.696.7.696H7L2.3 8.169c-.2.2-.3.398-.3.697v.597a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 2 1.99c1.1 0 2-.896 2-1.89 0 1.094.9 1.89 2 1.89a2 2 0 0 0 2-1.99 2 2 0 0 0 4 0v-.597c0-.299-.1-.498-.3-.697z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 12.448v7.96C4 22 5.2 22 6.8 22h1.6c.3 0 .6-.299.6-.597v-3.781c0-1.692 1.3-2.985 3-2.985s3 1.293 3 2.985v3.781c0 .299.3.597.6.597h1.6c1.5 0 2.8 0 2.8-1.592v-7.96c-.8 0-1.5-.299-2-.796-.5.497-1.2.796-2 .796s-1.5-.299-2-.796c-.5.497-1.2.796-2 .796s-1.5-.299-2-.796c-.5.497-1.2.796-2 .796s-1.5-.299-2-.796c-.5.497-1.2.796-2 .796z",
    clipRule: "evenodd"
  })), props.children);
};
var V2MessageCenterIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.207 3.902l8.354 3.132c.283.107.595.107.878 0l8.354-3.132A3.001 3.001 0 0 0 18 2H6c-1.27 0-2.354.788-2.793 1.902zM21 5.426l-8.034 3.013a2.75 2.75 0 0 1-1.932 0L3 5.426V12a3 3 0 0 0 3 3h3.661A7.003 7.003 0 0 1 21 11.138V5.426zm.275 14.178a.527.527 0 0 1 .038-.44 5.5 5.5 0 1 0-2.149 2.149.527.527 0 0 1 .44-.038l1.85.694a.4.4 0 0 0 .515-.515l-.694-1.85zM14.25 14.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5zm0 3a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2MgmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53 4c-.806 0-1.297 1.074-.87 1.758l2.1 3.468a1.027 1.027 0 0 1-1.742 1.088l-2.1-3.468C1.636 4 3.11 2 5.53 2h12.225c.093 0 .184-.023.27 0 .68.116 1.687.705 2.676 1.819 1.21 1.363 1.367 4.147 1.277 5.708a.967.967 0 0 1-.512.787l-1.125.617a1.027 1.027 0 0 1-1.45-.528L16.512 4H5.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.428 12H16v10H4.18c-1.026 0-1.051-1.111-1.19-2.129l-.973-6.178C1.85 12.46 2.183 12 3.428 12zm5.06 4.94a1.541 1.541 0 1 0-1.027 0v1.33a.513.513 0 1 0 1.027 0v-1.33z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12h3c1.134 0 1 .296 1 1.43v7.02c0 1.134-.366 1.55-1.5 1.55H17V12z"
  })), props.children);
};
var V2MicrophoneIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.858c0 1.005.205 1.896.615 2.675a4.95 4.95 0 0 0 1.73 1.876c.737.466 1.596.74 2.575.822v1.791H8.568a.564.564 0 0 0-.415.17.564.564 0 0 0-.17.415c0 .159.057.294.17.407.112.113.25.17.415.17h6.864a.564.564 0 0 0 .415-.17.555.555 0 0 0 .17-.407.564.564 0 0 0-.17-.415.564.564 0 0 0-.415-.17H12.58v-1.79c.98-.083 1.838-.357 2.575-.823a4.891 4.891 0 0 0 1.722-1.876c.416-.779.623-1.67.623-2.675v-1.56a.556.556 0 0 0-.17-.408.555.555 0 0 0-.406-.169.564.564 0 0 0-.416.17.555.555 0 0 0-.169.407v1.514c0 .871-.18 1.635-.538 2.29a3.817 3.817 0 0 1-1.514 1.53c-.646.36-1.407.539-2.283.539-.877 0-1.64-.18-2.29-.538a3.817 3.817 0 0 1-1.515-1.53c-.359-.656-.538-1.42-.538-2.29v-1.515a.555.555 0 0 0-.17-.408.564.564 0 0 0-.414-.169.555.555 0 0 0-.408.17.555.555 0 0 0-.169.407v1.56zm5.504 2.66c.507 0 .953-.118 1.337-.354.39-.235.69-.56.9-.976.215-.42.323-.904.323-1.453V6.593c0-.549-.108-1.03-.323-1.445-.21-.42-.51-.749-.9-.984-.384-.236-.83-.354-1.337-.354-.513 0-.961.118-1.345.354a2.423 2.423 0 0 0-.9.984c-.215.415-.323.896-.323 1.445v5.142c0 .549.108 1.033.323 1.453.215.415.515.74.9.976.384.236.832.354 1.345.354z"
  })), props.children);
};
var V2NoiconIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    strokeWidth: 3,
    x: 3.5,
    y: 3.5,
    width: 17,
    height: 17,
    rx: 4,
    fill: "none",
    fillRule: "evenodd"
  })), props.children);
};
var V2NotificationIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.37h-.05a.2.2 0 0 1-.2-.2v-5.55c0-3.17-2.11-5.85-5.01-6.71A2 2 0 0 0 12 2a2 2 0 0 0-1.99 1.91C7.11 4.77 5 7.45 5 10.62v5.55a.2.2 0 0 1-.2.2h-.05a.749.749 0 1 0 0 1.5h14.5a.749.749 0 1 0 0-1.5zm-4.9 3.15h-4.7c-.23 0-.37.25-.26.45A2.98 2.98 0 0 0 12 21.52c1.13 0 2.11-.63 2.61-1.55.11-.21-.03-.45-.26-.45z"
  })), props.children);
};
var V2NotificationpreferencesIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 19.76H7.79a.31.31 0 0 0-.27.46 3.06 3.06 0 0 0 2.67 1.59c1.16 0 2.16-.65 2.67-1.59a.301.301 0 0 0-.26-.46zm2.32-5.74c-1.57-1.78-1.58-4.68-.04-6.48.32-.37.69-.68 1.1-.94a7.18 7.18 0 0 0-3.75-2.65A2.043 2.043 0 0 0 10.2 2c-1.09 0-1.99.87-2.04 1.96-2.97.88-5.14 3.62-5.14 6.87v5.69a.2.2 0 0 1-.2.2h-.05a.77.77 0 0 0-.77.77c0 .42.35.77.77.77h12.81l.25-3.43c-.34-.23-.64-.5-.91-.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.24 8.55a3.58 3.58 0 0 0-.81-.7c-.22-.13-.5.02-.5.28v2.02c0 .45-.37.82-.82.82h-.94c-.45 0-.82-.37-.82-.82V8.1c0-.25-.28-.41-.49-.28-.31.18-.59.42-.84.71-1.05 1.21-1.04 3.3.02 4.5.38.43.85.74 1.35.93l-.49 6.69a1.081 1.081 0 0 0 1.09 1.16l1.22-.01c.3 0 .59-.13.79-.35.2-.22.31-.52.28-.82l-.5-6.65c.52-.19 1.01-.51 1.41-.96 1.06-1.18 1.08-3.26.05-4.47z"
  })), props.children);
};
var V2NumberPadIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 2.5A1.5 1.5 0 0 0 5 4v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 9 5V4a1.5 1.5 0 0 0-1.5-1.5h-1zm5 0A1.5 1.5 0 0 0 10 4v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 14 5V4a1.5 1.5 0 0 0-1.5-1.5h-1zm5 0A1.5 1.5 0 0 0 15 4v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 19 5V4a1.5 1.5 0 0 0-1.5-1.5h-1zm0 5A1.5 1.5 0 0 0 15 9v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 19 10V9a1.5 1.5 0 0 0-1.5-1.5h-1zM15 14a1.5 1.5 0 0 1 1.5-1.5h1A1.5 1.5 0 0 1 19 14v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 15 15v-1zm-5-5a1.5 1.5 0 0 1 1.5-1.5h1A1.5 1.5 0 0 1 14 9v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 10 10V9zm1.5 3.5A1.5 1.5 0 0 0 10 14v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 14 15v-1a1.5 1.5 0 0 0-1.5-1.5h-1zM10 19a1.5 1.5 0 0 1 1.5-1.5h1A1.5 1.5 0 0 1 14 19v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 10 20v-1zM5 9a1.5 1.5 0 0 1 1.5-1.5h1A1.5 1.5 0 0 1 9 9v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 5 10V9zm1.5 3.5A1.5 1.5 0 0 0 5 14v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 9 15v-1a1.5 1.5 0 0 0-1.5-1.5h-1z",
    clipRule: "evenodd"
  })), props.children);
};
var V2OccasionIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6.501c0 1.38 1.156 2.5 2.583 2.5H6a1 1 0 0 0-1 1v1h14v-1a1 1 0 0 0-1-1h-2.584c1.427 0 2.584-1.12 2.584-2.5s-1.157-2.5-2.584-2.5c-.737 0-1.558.58-2.624 1.784l-.311.36a29.01 29.01 0 0 0-.482.59 26.332 26.332 0 0 0-.48-.59l-.312-.36C10.14 4.582 9.32 4.001 8.583 4.001 7.156 4.001 6 5.121 6 6.501zm9.407-.83a.032.032 0 0 1 .01-.003c.475 0 .86.373.86.833l-.006.097a.852.852 0 0 1-.855.736h-1.71l.074-.087c.337-.4.64-.73.908-.99l.103-.097.187-.167.159-.131.177-.132.093-.059zm-7.685.83c0-.46.385-.833.86-.833.002 0 .005 0 .01.003l.093.059.177.132.16.13.186.168.103.097c.268.26.571.59.908.99l.073.087h-1.71a.852.852 0 0 1-.854-.736l-.006-.097zM5 12.001h14v5a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2OrderAheadIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.945 4.22a.779.779 0 0 1 1.555.059v3.346a.375.375 0 0 0 .75 0V4.25a.75.75 0 0 1 1.5 0v3.375a.375.375 0 1 0 .75 0V4.279a.779.779 0 0 1 1.555-.06l.375 4.864a2 2 0 0 1-.58 1.567l-1.302 1.302.386 7.736A1.25 1.25 0 0 1 9.686 21H8.314a1.25 1.25 0 0 1-1.248-1.312l.386-7.736L6.15 10.65a2 2 0 0 1-.58-1.567l.375-4.864zm9.542-.58c-.53-.156-.987.308-.987.86v15.25c0 .69.56 1.25 1.25 1.25h.5c.745 0 1.332-.648 1.25-1.388L17 12s1.5-1 1.5-3.5c0-2.151-1.11-4.302-3.013-4.86z",
    clipRule: "evenodd"
  })), props.children);
};
var V2OverflowIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0-5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0-5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
  })), props.children);
};
var V2PackageSizeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 7.313l7.5-3.75 7.5 3.75v9.375l-7.5 3.75-7.5-3.75V7.313zm1.238.97a.625.625 0 0 1 .838-.28L12 10.715l5.423-2.712a.625.625 0 0 1 .56 1.118l-5.359 2.68v6.261a.625.625 0 1 1-1.25 0V11.8L6.017 9.12a.625.625 0 0 1-.28-.838z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.88 2.067c.621 0 1.125.504 1.125 1.125v2.5a.625.625 0 1 1-1.25 0V3.317H18.38a.625.625 0 1 1 0-1.25h2.5zm-17.75 20a1.125 1.125 0 0 1-1.125-1.125v-2.5a.625.625 0 1 1 1.25 0v2.375H5.63a.625.625 0 1 1 0 1.25h-2.5z"
  })), props.children);
};
var V2PaymentshubIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm-.823-14.145c.002.35.184.581 1.257 1.019.953.382 2.048 1.008 2.054 2.465.004 1.065-.671 1.93-1.763 2.26l-.094.029.005 1.289-1.436.006-.005-1.21-.116-.014c-.596-.076-1.175-.278-1.549-.542l-.214-.15.515-1.452.369.242c.424.28.99.445 1.511.443.645-.003 1.06-.322 1.057-.813 0-.304-.089-.664-1.125-1.077-1.071-.414-2.167-1.016-2.173-2.347-.004-1.018.638-1.844 1.679-2.155l.096-.029-.005-1.253 1.424-.006.005 1.163.114.016a3.31 3.31 0 0 1 1.252.417l.252.146-.536 1.43-.353-.2h-.002a2.49 2.49 0 0 0-1.316-.348c-.567.002-.904.253-.903.671z",
    clipRule: "evenodd"
  })), props.children);
};
var V2PaypalIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.365 6.737c.145-.07.299-.105.46-.105h4.356c.542 0 1.045.037 1.495.11a6.486 6.486 0 0 1 .757.17c.06.017.119.036.177.056.059.02.113.042.169.063.088-1.198-.245-2.034-.82-2.674C16.12 3.42 14.636 3 12.721 3H7.546a.796.796 0 0 0-.785.676L4.446 18.448a.48.48 0 0 0 .472.555h3.048l1.81-11.469c.054-.347.274-.645.59-.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.38 7.667a4.557 4.557 0 0 0-.475-.13 6 6 0 0 0-.345-.067 8.708 8.708 0 0 0-1.38-.101h-4.045a.7.7 0 0 0-.687.591l-.73 4.676a1.42 1.42 0 0 1 .25-.024h1.63c.865 0 1.637-.098 2.32-.295 1.727-.5 2.888-1.63 3.47-3.428.128-.399.222-.766.289-1.11a4.55 4.55 0 0 0-.296-.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.878 8.518a2.482 2.482 0 0 0-.494-.42c-.45 2.195-1.796 5.286-6.838 5.286l-1.25-.004a.793.793 0 0 0-.782.675s-.972 6.158-1.02 6.481c-.037.256.183.464.415.464h2.509a.697.697 0 0 0 .687-.591l.608-3.818A.697.697 0 0 1 13.4 16h.432c2.802 0 4.995-1.146 5.636-4.46a5.88 5.88 0 0 0 .051-.297c.132-1.11-.047-2.043-.64-2.725z"
  })), props.children);
};
var V2PendingPausedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 11a9 9 0 0 1-9.156 8.999 5.766 5.766 0 0 0-8.672-7.242A9 9 0 1 1 21 11zm-9.469 6.266a4.761 4.761 0 0 1-4.766 4.766 4.766 4.766 0 1 1 4.766-4.766zm-5.795-2.647h.06a.5.5 0 0 1 .5.5v4.294a.5.5 0 0 1-.5.5h-.06a.5.5 0 0 1-.5-.5v-4.294a.5.5 0 0 1 .5-.5zm2 0h.06a.5.5 0 0 1 .5.5v4.294a.5.5 0 0 1-.5.5h-.06a.5.5 0 0 1-.5-.5v-4.294a.5.5 0 0 1 .5-.5zM12.75 5a.75.75 0 0 0-1.5 0v6c0 .25.125.485.334.624l3 2a.75.75 0 1 0 .832-1.248l-2.666-1.777V5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2PersonalinfoIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55 14.86H4.84c-2.41 0-3.72 2.79-2.17 4.63.27.33.67.51 1.09.51h5.9c-.54-.83-.93-1.77-1.1-2.77-.13-.8-.13-1.59-.01-2.37zm.67-2.15c.27-.57.61-1.11 1.03-1.6a7.472 7.472 0 0 1 4.59-2.55c.09-.38.14-.78.14-1.19C14.98 4.4 12.56 2 9.58 2c-2.98 0-5.4 2.41-5.4 5.37-.01 2.85 2.22 5.16 5.04 5.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.79 14.97c-.4-2.44-2.37-4.42-4.82-4.82a5.911 5.911 0 0 0-6.82 6.82c.4 2.44 2.37 4.42 4.82 4.82 4.04.66 7.48-2.78 6.82-6.82zm-5.1 4.08c0 .21-.17.38-.38.38h-.67a.38.38 0 0 1-.38-.38v-3.58c0-.19.14-.35.33-.38l.66-.09c.11-.02.22.02.31.09.08.07.13.17.13.28v3.68zm-.72-4.78c-.46 0-.81-.34-.81-.78 0-.45.35-.79.81-.79.47 0 .82.34.82.79s-.35.78-.82.78z"
  })), props.children);
};
var V2Phone2Icon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.528 21.616C7.976 19.146 4.057 12.36 5.196 5.453a3.683 3.683 0 0 1 6.08-2.562l-.435 4.023-.21 2.007a3.676 3.676 0 0 1-1.84.447 11.09 11.09 0 0 0 4.144 7.177 3.676 3.676 0 0 1 1.307-1.37l1.843.821 3.7 1.635a3.683 3.683 0 0 1-4.573 4.242c-.31-.082-.474-.178-.684-.257z",
    clipRule: "evenodd"
  })), props.children);
};
var V2PhoneIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.103 3h7.796C17.06 3 18 3.984 18 5.197V18.8c0 1.214-.942 2.2-2.1 2.2H8.102C6.943 21 6 20.015 6 18.8V5.197C6 3.984 6.942 3 8.103 3zm4.166 16.326a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd"
  })), props.children);
};
var V2PlayIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.11 17.49V6.51c0-1.963 2.16-3.16 3.825-2.12l8.783 5.49c1.567.98 1.567 3.261 0 4.24l-8.783 5.49c-1.665 1.04-3.825-.157-3.825-2.12z"
  })), props.children);
};
var V2PpCashCardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4zm7.395 4.022a.594.594 0 0 0-.583.505l-.97 6.368-1.702.01a.266.266 0 0 1-.266-.306l1.241-8.202a.445.445 0 0 1 .437-.378L12.442 7c1.069-.006 1.898.221 2.373.738.323.352.512.816.467 1.48a.175.175 0 0 1-.032-.012 2.84 2.84 0 0 0-.369-.104 3.54 3.54 0 0 0-.217-.04 5.286 5.286 0 0 0-.836-.056l-2.433.016zm3.58.525a2.077 2.077 0 0 1 .25.087c-.035.19-.087.395-.157.616-.319 1-.963 1.632-1.926 1.915a4.72 4.72 0 0 1-1.294.172l-.91.006a.739.739 0 0 0-.14.013l.391-2.596a.387.387 0 0 1 .381-.33l2.26-.015c.28-.002.54.016.77.052a3.41 3.41 0 0 1 .375.08zm.924.493a1.423 1.423 0 0 0-.278-.231c-.244 1.22-.985 2.939-3.8 2.957l-.698.002a.442.442 0 0 0-.435.377s-.52 3.42-.546 3.599c-.02.142.104.257.233.256l1.4-.01a.387.387 0 0 0 .382-.33l.326-2.12a.388.388 0 0 1 .382-.33h.242c1.564-.01 2.786-.653 3.132-2.494.01-.055.02-.11.028-.165.07-.617-.033-1.135-.368-1.51z",
    clipRule: "evenodd"
  })), props.children);
};
var V2PreferredFilledIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.552 2.908a.5.5 0 0 1 .896 0l2.375 4.811a.5.5 0 0 0 .376.274l5.309.771a.5.5 0 0 1 .277.853l-3.841 3.745a.5.5 0 0 0-.144.442l.907 5.288a.5.5 0 0 1-.726.527l-4.748-2.497a.5.5 0 0 0-.466 0L7.02 19.62a.5.5 0 0 1-.726-.527l.907-5.288a.5.5 0 0 0-.144-.442L3.215 9.617a.5.5 0 0 1 .277-.853l5.309-.771a.5.5 0 0 0 .376-.274l2.375-4.81z"
  })), props.children);
};
var V2PreferredIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.177 7.72a.5.5 0 0 1-.376.273l-5.309.771a.5.5 0 0 0-.277.853l3.841 3.745a.5.5 0 0 1 .144.442l-.907 5.288a.5.5 0 0 0 .726.527l4.748-2.497a.5.5 0 0 1 .466 0l4.748 2.497a.5.5 0 0 0 .726-.527l-.907-5.288a.5.5 0 0 1 .143-.442l3.842-3.745a.5.5 0 0 0-.277-.853l-5.309-.771a.5.5 0 0 1-.376-.274l-2.375-4.81a.5.5 0 0 0-.896 0l-2.375 4.81zM12 6.52l-1.03 2.084a2.5 2.5 0 0 1-1.88 1.368l-2.302.334 1.665 1.624a2.5 2.5 0 0 1 .72 2.212l-.394 2.292 2.059-1.082a2.5 2.5 0 0 1 2.326 0l2.059 1.082-.393-2.292a2.5 2.5 0 0 1 .718-2.212l1.666-1.624-2.302-.334a2.5 2.5 0 0 1-1.882-1.368L12 6.52z",
    clipRule: "evenodd"
  })), props.children);
};
var V2PrintIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 2.5A1.5 1.5 0 0 0 6 4v1.5h12V4a1.5 1.5 0 0 0-1.5-1.5h-9zM6 17.5V20a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 18 20v-5.5H6v3zM5 7a3 3 0 0 0-3 3v4.5a3 3 0 0 0 2.5 2.959V13h15v4.459A3 3 0 0 0 22 14.5V10a3 3 0 0 0-3-3H5zm13.5 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ProfileIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.996 7.97c0 3.297-2.688 5.97-6.003 5.97s-6.002-2.673-6.002-5.97C5.991 4.673 8.678 2 11.993 2s6.003 2.673 6.003 5.97zm-11.26 8.323h10.516c2.677 0 4.141 3.104 2.413 5.146-.3.358-.745.56-1.213.56H5.536c-.469 0-.913-.202-1.213-.56-1.717-2.042-.264-5.146 2.413-5.146z",
    clipRule: "evenodd"
  })), props.children);
};
var V2PurchaseProtectionIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 6.027c-.27 10.1-5.94 14.26-8.14 15.5-.53.3-1.19.3-1.71 0-2.2-1.25-7.87-5.43-8.15-15.5-.01-.45.33-.85.83-.98l7.85-2.01c.21-.05.43-.05.64 0l7.86 2.01c.49.12.83.53.82.98zm-5.716 2.888l-4.167 4.114-1.4-1.391a1.026 1.026 0 0 0-1.414-.02.94.94 0 0 0-.021 1.363l2.116 2.102c.392.389 1.039.39 1.433.002l4.884-4.822a.941.941 0 0 0-.017-1.364 1.027 1.027 0 0 0-1.414.016z",
    clipRule: "evenodd"
  })), props.children);
};
var V2QrcIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.01 2.01h-2.82c-.01 0-.02-.01-.03-.01h-.31c-.33 0-.6.27-.6.6v.31c0 .33.27.6.6.6H19c.83 0 1.5.67 1.5 1.5v2.82c0 .01-.01.02-.01.03v.31c0 .33.27.6.6.6h.31c.33 0 .6-.27.6-.6V5.01c.01-1.66-1.34-3-2.99-3zM8.16 20.5h-.31c-.02 0-.03.01-.05.01H5c-.83 0-1.5-.67-1.5-1.5v-3.15c0-.33-.27-.6-.6-.6h-.3c-.33 0-.6.27-.6.6v.31c0 .01.01.02.01.04v2.8c0 1.66 1.34 3 3 3h3.15c.33 0 .6-.27.6-.6v-.31c0-.34-.27-.6-.6-.6zm13.25-5.25h-.31c-.33 0-.6.27-.6.6v.31c0 .01.01.02.01.03v2.82c0 .83-.67 1.5-1.5 1.5h-2.8c-.02 0-.03-.01-.05-.01h-.31c-.33 0-.6.27-.6.6v.31c0 .33.27.6.6.6H19c1.66 0 3-1.34 3-3v-3.15a.59.59 0 0 0-.59-.61zM2.6 8.77h.31c.33 0 .6-.27.6-.6V5.01c0-.83.67-1.5 1.5-1.5h2.8c.01 0 .02.01.04.01h.31c.33 0 .6-.27.6-.6v-.31c0-.33-.27-.6-.6-.6H5.01c-1.66 0-3 1.34-3 3v2.82c0 .01-.01.02-.01.03v.31c0 .33.27.6.6.6zM16.711 6H14.29C13.579 6 13 6.58 13 7.289V9.71c0 .71.58 1.289 1.289 1.289h2.422c.71 0 1.289-.58 1.289-1.289V7.29C18 6.579 17.42 6 16.711 6zm-7 0H7.29C6.579 6 6 6.58 6 7.289V9.71c0 .711.58 1.29 1.289 1.29H9.71c.71 0 1.289-.58 1.289-1.289V7.29A1.29 1.29 0 0 0 9.711 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.708 14h-2.416a.296.296 0 0 0-.292.292v2.416c0 .158.134.292.292.292h2.416a.296.296 0 0 0 .292-.292v-2.429a.285.285 0 0 0-.292-.279zm-2.416-1h2.416c.71 0 1.292.569 1.292 1.28v2.428c0 .71-.581 1.292-1.292 1.292h-2.416c-.71 0-1.292-.581-1.292-1.292v-2.416c0-.71.581-1.292 1.292-1.292z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.711 13H7.29C6.579 13 6 13.581 6 14.292v2.416C6 17.418 6.58 18 7.289 18H9.71c.71 0 1.289-.581 1.289-1.292v-2.429A1.283 1.283 0 0 0 9.711 13z"
  })), props.children);
};
var V2QuestionSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.901 7.816c-.476-2.898-2.814-5.243-5.719-5.719a7.008 7.008 0 0 0-8.085 8.085c.476 2.898 2.814 5.243 5.719 5.72a7.008 7.008 0 0 0 8.085-8.086zm-6.937 5.103a.852.852 0 0 1 0-1.7c.462 0 .84.377.84.84a.843.843 0 0 1-.84.86zM10.42 9.02c-.378.385-.728.742-.798 1.225a.068.068 0 0 1-.07.056H8.404c-.02 0-.042-.007-.049-.02-.007-.015-.021-.036-.014-.057.077-.665.518-1.134.945-1.589.385-.413.75-.805.75-1.28 0-.701-.435-1.086-1.226-1.086-.847 0-1.589.483-2.065.882-.035.021-.063.021-.084.014-.028-.014-.042-.035-.042-.063v-1.12c0-.021.007-.042.028-.056.315-.252 1.176-.847 2.345-.847 1.45 0 2.387.847 2.387 2.163 0 .798-.49 1.295-.959 1.778z"
  })), props.children);
};
var V2QuestionIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.86 10.31c-.68-4.14-4.02-7.49-8.17-8.17A10.011 10.011 0 0 0 2.14 13.69c.68 4.14 4.02 7.49 8.17 8.17a10.011 10.011 0 0 0 11.55-11.55zm-9.91 7.29c-.66 0-1.2-.55-1.2-1.23 0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2 0 .69-.53 1.23-1.2 1.23zm2.08-5.57c-.54.55-1.04 1.06-1.14 1.75-.01.05-.05.08-.1.08h-1.64c-.03 0-.06-.01-.07-.03-.01-.02-.03-.05-.02-.08.11-.95.74-1.62 1.35-2.27.55-.59 1.07-1.15 1.07-1.83 0-1-.62-1.55-1.75-1.55-1.21 0-2.27.69-2.95 1.26-.05.03-.09.03-.12.02-.04-.02-.06-.05-.06-.09v-1.6c0-.03.01-.06.04-.08.45-.36 1.68-1.21 3.35-1.21 2.07 0 3.41 1.21 3.41 3.09 0 1.14-.7 1.85-1.37 2.54z"
  })), props.children);
};
var V2RainyDayIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3a1 1 0 0 1 1 1v.063c3.64.46 7 3.438 7 8.937H4c0-5.499 3.36-8.478 7-8.937V4a1 1 0 0 1 1-1zm1 15v-4h-2v4a1 1 0 1 1-2 0 1 1 0 1 0-2 0 3 3 0 1 0 6 0z"
  })), props.children);
};
var V2RecurrentIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.889 2.085A1 1 0 0 1 19 2.958l.49 4.076a1 1 0 0 1-.873 1.112l-4.076.49a1 1 0 1 1-.238-1.986l1.566-.188a6.757 6.757 0 0 0-10.622 5.763 1 1 0 0 1-1.991.157l-.004.002a8.742 8.742 0 0 1-.003-.085v-.008a8.728 8.728 0 0 1 2.585-6.509 8.744 8.744 0 0 1 7.448-2.444 8.72 8.72 0 0 1 3.946 1.638l-.214-1.779a1 1 0 0 1 .874-1.112zm-9.76 15.453l1.567-.189a1 1 0 1 0-.239-1.986l-4.075.49a1 1 0 0 0-.874 1.113l.49 4.075a1 1 0 1 0 1.986-.239l-.214-1.779a8.7 8.7 0 0 0 3.947 1.638 8.744 8.744 0 0 0 7.448-2.444 8.727 8.727 0 0 0 2.585-6.509 1 1 0 1 0-1.999.066c.003.072.004.144.004.215v.05a6.773 6.773 0 0 1-.472 2.447A6.757 6.757 0 0 1 8.13 17.538z",
    clipRule: "evenodd"
  })), props.children);
};
var V2RecurringPausedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.77 2.363a1 1 0 0 1 1.113.874l.49 4.075a1 1 0 0 1-.873 1.112l-4.076.49a1 1 0 0 1-.239-1.985l1.568-.189a6.714 6.714 0 0 0-2.88-1.145 6.743 6.743 0 0 0-5.748 1.886 6.729 6.729 0 0 0-1.976 4.249 5.75 5.75 0 0 0-2.009 1.05 8.734 8.734 0 0 1 2.576-6.72 8.744 8.744 0 0 1 7.448-2.444 8.721 8.721 0 0 1 3.946 1.638l-.214-1.78a1 1 0 0 1 .874-1.112zm-6.614 18.64a5.757 5.757 0 0 0 1.103-1.98 6.73 6.73 0 0 0 4.38-1.949 6.734 6.734 0 0 0 1.994-5.021 1 1 0 0 1 1.999-.066 8.734 8.734 0 0 1-2.585 6.507 8.735 8.735 0 0 1-6.891 2.509zm.375-3.738a4.766 4.766 0 1 1-9.531 0 4.766 4.766 0 0 1 9.531 0zm-5.795-2.647h.06a.5.5 0 0 1 .5.5v4.295a.5.5 0 0 1-.5.5h-.06a.5.5 0 0 1-.5-.5v-4.295a.5.5 0 0 1 .5-.5zm2 0h.06a.5.5 0 0 1 .5.5v4.295a.5.5 0 0 1-.5.5h-.06a.5.5 0 0 1-.5-.5v-4.295a.5.5 0 0 1 .5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2RefreshIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.125 7.481a6.743 6.743 0 0 1 5.748-1.886 6.721 6.721 0 0 1 3.216 1.397 1 1 0 0 0 1.248-1.563 8.721 8.721 0 0 0-4.172-1.812 8.755 8.755 0 1 0 7.467 8.37 1 1 0 1 0-1.999.066A6.755 6.755 0 1 1 7.125 7.482z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.77 2.363a1 1 0 0 1 1.113.874l.49 4.075a1 1 0 0 1-.873 1.112l-4.076.49a1 1 0 0 1-.239-1.985l3.083-.371-.37-3.083a1 1 0 0 1 .873-1.112z",
    clipRule: "evenodd"
  })), props.children);
};
var V2RefundIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.777 5v1h14.685c.56 0 1.015.448 1.015 1v6h.508c.56 0 1.015-.448 1.015-1V5c0-.552-.454-1-1.015-1H5.792c-.56 0-1.015.448-1.015 1zM2 15c0 .248.091.474.242.649l2.261-2.261c.78-.78 2.045-.78 2.825 0l2.419 2.418c.061.062.118.127.17.194h8.29c.561 0 1.016-.448 1.016-1V8c0-.552-.455-1-1.015-1H3.015C2.455 7 2 7.448 2 8v7zm8.611-.803a2.947 2.947 0 1 1 0-5.894 2.947 2.947 0 0 1 0 5.893zm-5.4-.102a.997.997 0 0 1 1.41 0l2.418 2.418a.998.998 0 0 1-1.41 1.41l-.716-.715v.632a1.662 1.662 0 1 0 3.325 0 .34.34 0 0 1 .34-.34h1.315a.34.34 0 0 1 .34.34 3.657 3.657 0 1 1-7.315 0v-.632l-.715.716a.998.998 0 0 1-1.41-1.411l2.417-2.418z",
    clipRule: "evenodd"
  })), props.children);
};
var V2RentIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.201a.79.79 0 0 1 1.053.001l3.266 2.994v-.51h-.094a.17.17 0 0 1-.174-.166v-.687a.17.17 0 0 1 .174-.166h2.876a.17.17 0 0 1 .174.166v.687a.17.17 0 0 1-.174.166h-.094v2.976l2.386 2.186a.32.32 0 0 1 .009.47l-.57.558a.365.365 0 0 1-.495.008l-1.323-1.215v7.668c0 .366-.314.663-.702.663H6.194c-.387 0-.7-.297-.7-.663v-.665l-.001-.259v-.563l-.006-3.569v-1.923c0-.29 0-.523.002-.683l-1.33 1.211a.364.364 0 0 1-.495-.01l-.566-.557a.32.32 0 0 1 .01-.47L11.5 4.2zM13.5 16h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2-2h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-2-2h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm2 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
  })), props.children);
};
var V2RequestIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.223 4.594v1H4.538c-.56 0-1.015.447-1.015 1v6h-.508c-.56 0-1.015-.448-1.015-1v-7c0-.553.454-1 1.015-1h15.193c.56 0 1.015.447 1.015 1zm2.777 10c0 .552-.454 1-1.015 1h-5.857v-2.06a2.946 2.946 0 1 0-3.688-.1v2.16H5.793c-.56 0-1.015-.448-1.015-1v-7c0-.553.455-1 1.015-1h15.193c.56 0 1.015.447 1.015 1v7zm-7.872-.566v-1.872a.844.844 0 1 0-1.687 0v6.463l-1.626-1.625a.844.844 0 1 0-1.193 1.193l3.066 3.066c.33.33.864.33 1.193 0l3.066-3.066a.844.844 0 0 0-1.193-1.193l-1.626 1.625v-4.591z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ResolutionIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.252 9.015a1.56 1.56 0 0 1 .196-1.943l2.59-2.62a1.517 1.517 0 0 1 1.533-.382l9.345 2.932c.146.046.299.07.453.07h.102c.845 0 1.529.692 1.529 1.545v8.353c0 .569-.456 1.03-1.019 1.03-.54 0-1.059-.217-1.441-.603l-.663-.671-7.746-7.833a1.516 1.516 0 0 0-2.162 0l-.36.364a1.516 1.516 0 0 1-2.161 0 1.549 1.549 0 0 1-.196-.242zm-.515-2.647L6.1 6H3.544C2.69 6 2 6.684 2 7.53v7.444c0 .815.677 1.527 1.5 1.527.348 0 .676.07.944.29l3.461 2.856c.315.26.72.385 1.128.348l1.033-.093-3.305-3.207a.5.5 0 0 1 .696-.718l3.923 3.807 1.867-.168-3.728-3.636a.5.5 0 1 1 .698-.716l4.341 4.234 1.288-.116c.178-.016.352-.063.512-.137l-4.08-3.98a.5.5 0 0 1 .698-.716l4.16 4.057 1.108-1.097-7.824-7.912a.516.516 0 0 0-.74 0l-.36.364c-.988 1-2.595 1-3.583 0a2.558 2.558 0 0 1 0-3.592z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))), props.children);
};
var V2RetirementIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.194 5.682c.596-.057 2.009-.193 3.787.643 2.06.968 2.987 2.64 3.007 2.676.04.111-.024.23-.146.272a.246.246 0 0 1-.191-.02s-1.145-.93-2.805-1.472c-1.66-.543-2.77-.483-3.527-.351 2.507 1.572 3.806 4.89 3.806 5.133 0 .242-.164.215-.28.16-.068-.034-.211-.205-.423-.457-.8-.951-2.572-3.062-4.99-3.324.62.75 1.308 3.477 1.163 6.07.136-.008.271-.012.405-.012 3.866 0 5 3.672 5 4.5 0 .828-3.134 1.5-7 1.5s-7-.672-7-1.5c0-.596 2.657-2.663 5.587-3.776.585-3.153.467-5.036.03-6.722-3.128 1.171-4.303 3.803-4.692 4.672l-.046.103c-.05.109-.206.132-.314.072-.109-.06-.565-3.849 2.46-5.41-2.569-.658-4.71 1.178-4.71 1.178a.24.24 0 0 1-.314-.072C2.967 9.493 4.06 5.7 9.098 5.947 8.974 5.271 6.525 4.44 5.565 4.44c-.23 0-.36-.248-.108-.364.253-.117 3.398-1.28 6.124 1.492 3.689-4.14 7.369-2.04 7.421-2 .053.04.23.216.115.362-.027.035-.263.067-.623.116-1.16.157-3.607.489-4.524 1.65a.02.02 0 0 0-.004.002l-.004.002c.052 0 .13-.008.232-.018z"
  })), props.children);
};
var V2ReturnsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.208 8.792a1 1 0 0 1 0-1.414l5.085-5.085a1 1 0 1 1 1.414 1.414L7.329 7.085h5.298a7.458 7.458 0 1 1 0 14.915H9.81a1 1 0 1 1 0-2h2.818a5.458 5.458 0 1 0 0-10.915H7.33l3.378 3.377a1 1 0 0 1-1.414 1.415L4.208 8.792z"
  })), props.children);
};
var V2RocketIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.476 16.076c1.607-.842 3.761-2.437 5.376-4.053 3.286-3.285 4.25-6.269 4.517-7.995.14-.906-.565-1.61-1.47-1.47-1.727.267-4.711 1.23-7.996 4.516-1.616 1.615-3.211 3.769-4.052 5.376 0 0-.105 1.609.955 2.67 1.061 1.06 2.67.956 2.67.956zm4.755-8.381a1.5 1.5 0 1 0 2.121-2.121 1.5 1.5 0 0 0-2.121 2.121zm-3.51 8.826c.224.656.362 1.4.436 2.076.046.42.328.738.675.86a.946.946 0 0 0 1.074-.316c.938-1.202 2.453-3.542 2.324-6.088-1.377 1.32-3.057 2.599-4.508 3.468zM11.145 6.418a1.032 1.032 0 0 0-.154-.032c-2.725-.361-5.283 1.285-6.559 2.28a.946.946 0 0 0-.316 1.074c.123.347.44.629.86.675.84.093 1.788.283 2.536.614a26.98 26.98 0 0 1 3.633-4.611zM6.696 14.72a.75.75 0 0 1-.417.975l-2.5 1a.75.75 0 0 1-.558-1.392l2.5-1a.75.75 0 0 1 .975.418zm.834 2.81a.75.75 0 0 0-1.06-1.061l-3 3a.75.75 0 0 0 1.06 1.06l3-3zm2.166.748a.75.75 0 1 0-1.392-.558l-1 2.5a.75.75 0 1 0 1.392.558l1-2.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2SavingsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.235 11.47a4.765 4.765 0 1 1 0 9.53 4.765 4.765 0 0 1 0-9.53zM3.457 14.648c1.355 1.412 3.31 2.118 5.896 2.118.373 0 .733-.015 1.08-.044.059.729.253 1.42.557 2.047a11.19 11.19 0 0 1-1.635.114c-2.486 0-4.39-.706-5.745-2.117l-.153-2.118zm12.808-1.059h-.06a.5.5 0 0 0-.5.5v1.617h-1.617a.5.5 0 0 0-.5.5v.06a.5.5 0 0 0 .5.5h1.617v1.617a.5.5 0 0 0 .5.5h.06a.5.5 0 0 0 .5-.5v-1.618h1.617a.5.5 0 0 0 .5-.5v-.058a.5.5 0 0 0-.5-.5h-1.618v-1.618a.5.5 0 0 0-.5-.5zM3.229 11.471c1.404 1.411 3.434 2.117 6.124 2.117.62 0 1.204-.037 1.754-.112-.358.66-.59 1.4-.667 2.184-.348.031-.71.046-1.085.046-2.587 0-4.567-.706-5.974-2.118l-.152-2.117zm12.477-3.177l-.153 2.118-.05.045a5.81 5.81 0 0 0-3.525 1.805c-.795.178-1.67.267-2.623.267-2.689 0-4.745-.706-6.203-2.117L3 8.294c1.454 1.412 3.56 2.118 6.353 2.118 2.793 0 4.9-.706 6.353-2.118zM9.353 3c3.509 0 6.353 1.422 6.353 3.176 0 1.755-2.844 3.177-6.353 3.177S3 7.93 3 6.176 5.844 3 9.353 3z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ScanBarcodeIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.65 13.27h.7c.22 0 .4-.18.4-.4V3.4c0-.22-.18-.4-.4-.4h-.7c-.22 0-.4.18-.4.4v9.47c0 .22.18.4.4.4zm-14 0h.7c.22 0 .4-.18.4-.4V3.4c0-.22-.18-.4-.4-.4h-.7c-.22 0-.4.18-.4.4v9.47c0 .22.18.4.4.4zm3.45 0h7.8c.33 0 .6-.27.6-.6V3.6c0-.33-.27-.6-.6-.6H8.1c-.33 0-.6.27-.6.6v9.06c0 .34.27.61.6.61zm13.5 1.5H2.4c-.22 0-.4.18-.4.4v.7c0 .22.18.4.4.4h1.65c.11 0 .2.09.2.2v4.15c0 .22.18.4.4.4h.7c.22 0 .4-.18.4-.4v-4.15c0-.11.09-.2.2-.2H7.3c.11 0 .2.09.2.2v3.95c0 .33.27.6.6.6h7.8c.33 0 .6-.27.6-.6v-3.95c0-.11.09-.2.2-.2h1.35c.11 0 .2.09.2.2v4.15c0 .22.18.4.4.4h.7c.22 0 .4-.18.4-.4v-4.15c0-.11.09-.2.2-.2h1.65c.22 0 .4-.18.4-.4v-.7c0-.22-.18-.4-.4-.4z"
  })), props.children);
};
var V2SearchIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.21 17.544l-2.785-2.785a7.752 7.752 0 0 0 1.114-3.986C18.54 6.49 15.05 3 10.77 3S3 6.49 3 10.773c0 4.282 3.489 7.772 7.77 7.772a7.686 7.686 0 0 0 3.985-1.114l2.784 2.785a1.66 1.66 0 0 0 2.34 0l.33-.33a1.645 1.645 0 0 0 0-2.342zM4.723 10.773c0-3.334 2.714-6.05 6.047-6.05 3.332 0 6.047 2.716 6.047 6.05 0 3.333-2.715 6.049-6.047 6.049-3.333 0-6.047-2.716-6.047-6.05z"
  })), props.children);
};
var V2SecurityFilledIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.86 21.53c2.2-1.24 7.87-5.4 8.14-15.5.01-.45-.33-.86-.82-.98l-7.86-2.01c-.21-.05-.43-.05-.64 0L3.83 5.05c-.5.13-.84.53-.83.98.28 10.07 5.95 14.25 8.15 15.5.52.3 1.18.3 1.71 0z"
  })), props.children);
};
var V2SecurityPatternIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.18 5.05l-7.86-2.01c-.1-.03-.21-.04-.32-.04-.11 0-.21.01-.32.04L3.83 5.05c-.5.13-.84.53-.83.98.28 10.07 5.95 14.49 8.15 15.74.26.15.56.23.85.23.3 0 .59-.08.86-.22 2.2-1.24 7.87-5.65 8.14-15.74.01-.46-.33-.87-.82-.99zm-1.58 6.66c-.05.17-.21.29-.39.29H12v8.05c-.01.14-.08.41-.49.19-1.24-.8-4.17-3.09-5.83-7.69-.09-.27.11-.55.39-.55H12V5.02c0-.26.24-.46.5-.39 1.43.36 5.5 1.41 6.67 1.71.19.05.31.23.3.42-.11 1.88-.43 3.51-.87 4.95z"
  })), props.children);
};
var V2SendIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.947 6.407A.844.844 0 0 1 15.754 7.6l-1.626-1.626v6.463a.844.844 0 1 1-1.687 0V5.976L10.815 7.6a.844.844 0 1 1-1.193-1.193l3.066-3.066a.844.844 0 0 1 1.193 0l3.066 3.066zm-1.819 4.654V9h5.857c.56 0 1.015.448 1.015 1v7c0 .552-.454 1-1.015 1H5.792c-.56 0-1.015-.448-1.015-1v-7c0-.552.455-1 1.015-1h5.649v2.161a2.947 2.947 0 1 0 3.688-.1zM19.223 19v1c0 .552-.455 1-1.015 1H3.015C2.455 21 2 20.552 2 20v-7c0-.552.454-1 1.015-1h.508v6c0 .552.454 1 1.015 1h14.685z",
    clipRule: "evenodd"
  })), props.children);
};
var V2SettingsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.722 10.2a.378.378 0 0 1-.369-.279 7.39 7.39 0 0 0-.684-1.647.378.378 0 0 1 .054-.45 1.271 1.271 0 0 0 0-1.809l-.729-.729a1.271 1.271 0 0 0-1.809 0 .367.367 0 0 1-.45.054 7.642 7.642 0 0 0-1.656-.684.394.394 0 0 1-.279-.369C13.8 3.576 13.224 3 12.513 3h-1.035c-.702 0-1.278.576-1.278 1.287a.375.375 0 0 1-.279.36 7.642 7.642 0 0 0-1.656.684.378.378 0 0 1-.45-.054 1.271 1.271 0 0 0-1.809 0l-.738.729a1.271 1.271 0 0 0 0 1.809.367.367 0 0 1 .054.45 8.305 8.305 0 0 0-.675 1.656.375.375 0 0 1-.36.279h-.009C3.576 10.2 3 10.776 3 11.478v1.044c0 .711.576 1.278 1.278 1.278h.009c.171 0 .315.117.36.279a7.39 7.39 0 0 0 .684 1.647.378.378 0 0 1-.054.45 1.271 1.271 0 0 0 0 1.809l.729.729a1.271 1.271 0 0 0 1.809 0 .367.367 0 0 1 .45-.054 7.57 7.57 0 0 0 1.647.684.392.392 0 0 1 .288.369v.009c0 .702.567 1.278 1.278 1.278h1.044c.702 0 1.278-.576 1.278-1.278 0-.171.117-.315.279-.36a7.39 7.39 0 0 0 1.647-.684.378.378 0 0 1 .45.054 1.271 1.271 0 0 0 1.809 0l.729-.729a1.271 1.271 0 0 0 0-1.809.367.367 0 0 1-.054-.45 7.57 7.57 0 0 0 .684-1.647.375.375 0 0 1 .36-.279h.009c.702 0 1.278-.576 1.278-1.278v-1.062a1.27 1.27 0 0 0-1.269-1.278zM12 15.15A3.153 3.153 0 0 1 8.85 12 3.153 3.153 0 0 1 12 8.85 3.153 3.153 0 0 1 15.15 12 3.153 3.153 0 0 1 12 15.15z"
  })), props.children);
};
var V2ShareFacebookIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12.055C21 7.055 16.97 3 12 3s-9 4.054-9 9.055c0 4.52 3.291 8.266 7.594 8.945v-6.328H8.309v-2.617h2.285V10.06c0-2.27 1.343-3.523 3.4-3.523.984 0 2.014.177 2.014.177v2.228h-1.135c-1.118 0-1.467.698-1.467 1.414v1.699h2.496l-.399 2.617h-2.097V21C17.71 20.32 21 16.575 21 12.055z"
  })), props.children);
};
var V2ShareInstagramIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.997 3.023l.194.007.52.023c.958.043 1.612.196 2.184.418A4.41 4.41 0 0 1 19.49 4.51c.5.5.808 1.003 1.038 1.595.223.572.375 1.226.418 2.184.01.192.016.358.023.52l.007.194c.016.488.022 1.022.024 2.205v1.585a69.443 69.443 0 0 1-.024 2.205l-.007.194-.023.52c-.043.958-.196 1.612-.418 2.184a4.41 4.41 0 0 1-1.038 1.595c-.5.5-1.003.808-1.595 1.038-.572.223-1.226.375-2.184.418a81.13 81.13 0 0 1-.52.023l-.194.007c-.488.016-1.022.022-2.205.024h-1.585a69.441 69.441 0 0 1-2.205-.024l-.194-.007a81.276 81.276 0 0 1-.52-.023c-.958-.043-1.612-.196-2.184-.418a4.412 4.412 0 0 1-1.595-1.038 4.41 4.41 0 0 1-1.038-1.595c-.222-.572-.375-1.226-.418-2.184A42.556 42.556 0 0 1 3 13.49v-2.723c.004-1.36.018-1.71.053-2.479.043-.958.196-1.612.418-2.184A4.412 4.412 0 0 1 4.51 4.509c.5-.5 1.003-.808 1.595-1.038.572-.222 1.226-.375 2.184-.418l.52-.023.194-.007c.385-.012.798-.02 1.534-.022L13.232 3c.885.003 1.342.01 1.765.023zm-1.74 1.599h-2.26c-1.509.002-1.837.014-2.635.05-.877.04-1.354.188-1.671.31-.42.164-.72.36-1.035.674-.315.315-.51.615-.673 1.035-.123.317-.27.794-.31 1.671-.034.75-.047 1.086-.051 2.38v2.26c.001.976.007 1.458.02 1.893l.009.235.022.507c.04.877.186 1.354.31 1.671.163.42.358.72.673 1.035.315.315.615.51 1.035.673.317.124.794.27 1.671.31.798.037 1.126.049 2.635.052h2.005a63.868 63.868 0 0 0 1.893-.022l.235-.008.507-.022c.877-.04 1.354-.186 1.671-.31a2.79 2.79 0 0 0 1.035-.673 2.79 2.79 0 0 0 .673-1.035c.124-.317.27-.794.31-1.671l.022-.507.008-.235c.014-.434.02-.917.022-1.893v-2.005c-.003-1.509-.015-1.837-.052-2.635-.04-.877-.186-1.354-.31-1.671a2.79 2.79 0 0 0-.673-1.035 2.79 2.79 0 0 0-1.035-.673c-.317-.123-.794-.27-1.671-.31a73.53 73.53 0 0 0-.507-.022l-.235-.008c-.395-.013-.83-.019-1.639-.021zm-1.258 2.755a4.622 4.622 0 1 1 0 9.245 4.622 4.622 0 0 1 0-9.245zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm4.805-2.884a1.08 1.08 0 1 1 0 2.16 1.08 1.08 0 0 1 0-2.16z"
  })), props.children);
};
var V2ShareLineIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1 3A3.9 3.9 0 0 1 21 6.9v10.2a3.9 3.9 0 0 1-3.9 3.9H6.9A3.9 3.9 0 0 1 3 17.1V6.9A3.9 3.9 0 0 1 6.9 3h10.2zm-5.13 2.89c-3.613 0-6.553 2.386-6.553 5.319 0 2.629 2.332 4.83 5.481 5.247.214.046.504.14.578.323.066.166.043.425.02.592l-.093.561c-.029.166-.132.648.568.354.7-.295 3.774-2.223 5.15-3.805h-.001c.95-1.042 1.404-2.099 1.404-3.272 0-2.933-2.94-5.319-6.553-5.319zm-1.33 3.901c.07 0 .127.058.127.128v2.855c0 .07-.057.128-.128.128h-.46a.128.128 0 0 1-.127-.128V9.92c0-.07.057-.128.128-.128h.46zm1.172.001h.007l.005.002a.11.11 0 0 1 .008.001l.004.001.004.002h.004l.011.005.004.002.007.004.007.005.004.002.01.008.01.01v.001a.15.15 0 0 1 .01.013l1.31 1.767V9.92c0-.07.056-.128.127-.128h.46c.07 0 .127.058.127.128v2.855c0 .07-.057.128-.128.128h-.46a.12.12 0 0 1-.043-.008l-.003-.001a.102.102 0 0 1-.013-.006l-.011-.007h-.002a.126.126 0 0 1-.032-.032l-1.31-1.77v1.696c0 .07-.057.128-.128.128h-.46a.128.128 0 0 1-.127-.128V9.92c0-.07.057-.128.127-.128l.471.001zm-3.658 0c.07 0 .128.056.128.127v2.268h1.25c.07 0 .127.057.127.128v.46c0 .07-.057.127-.128.127H7.695l-.033-.004a.129.129 0 0 1-.095-.123V9.918c0-.07.057-.128.128-.128h.46zm8.188 0c.07 0 .127.057.127.127v.46c0 .07-.057.127-.127.127h-1.249v.483h1.249c.07 0 .127.057.127.128v.46c0 .07-.057.127-.127.127h-1.249v.483h1.249c.07 0 .127.057.127.128v.46c0 .07-.057.127-.127.127h-1.836l-.034-.004a.128.128 0 0 1-.094-.123V9.918c0-.034.014-.065.035-.088l.002-.002.002-.002a.127.127 0 0 1 .088-.036h1.837z"
  })), props.children);
};
var V2ShareLinkedinIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.667 3a1.318 1.318 0 0 1 1.325 1.163l.008.135V19.7a1.317 1.317 0 0 1-1.198 1.294l-.135.005H4.328a1.315 1.315 0 0 1-1.32-1.165L3 19.701V4.3a1.314 1.314 0 0 1 1.194-1.292L4.328 3h15.339zM8.338 9.748h-2.67v8.59h2.67v-8.59zm6.799-.214a2.806 2.806 0 0 0-2.527 1.388h-.035V9.748h-2.56v8.589h2.666v-4.25c0-1.12.213-2.205 1.602-2.205 1.37 0 1.387 1.282 1.387 2.278v4.177h2.667l.002-4.712c0-2.313-.499-4.09-3.202-4.09zM7.004 5.478a1.548 1.548 0 1 0 .001 3.096 1.548 1.548 0 0 0 0-3.096z"
  })), props.children);
};
var V2ShareMessengerIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c5.07 0 9 3.714 9 8.73s-3.93 8.73-9 8.73c-.91 0-1.786-.12-2.606-.346a.718.718 0 0 0-.48.037l-1.785.787a.721.721 0 0 1-1.01-.637l-.05-1.6a.725.725 0 0 0-.242-.513C4.076 16.62 3 14.354 3 11.73 3 6.714 6.93 3 12 3zm5.404 6.718c.255-.402-.241-.856-.62-.568l-2.84 2.155a.54.54 0 0 1-.65.001L11.193 9.73a1.351 1.351 0 0 0-1.952.36l-2.644 4.194c-.255.402.241.857.62.57l2.84-2.156a.54.54 0 0 1 .65-.002l2.102 1.578c.63.472 1.532.306 1.952-.36l2.644-4.195z"
  })), props.children);
};
var V2ShareSnapchatIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.687 17.477c-.87.487-1.45.435-1.9.728-.383.25-.156.787-.434.981-.342.239-1.351-.017-2.656.419-1.075.36-1.761 1.395-3.696 1.395-1.935 0-2.605-1.033-3.698-1.398-1.302-.436-2.314-.18-2.656-.419-.277-.194-.052-.731-.434-.98-.45-.294-1.03-.242-1.9-.726-.555-.31-.24-.502-.055-.592 3.155-1.547 3.658-3.934 3.68-4.111.028-.215.058-.383-.175-.601-.226-.211-1.226-.838-1.504-1.034-.459-.324-.66-.649-.512-1.047.104-.276.358-.38.625-.38.084 0 .168.01.25.029.504.11.994.366 1.276.435a.446.446 0 0 0 .105.014c.15 0 .204-.076.193-.251-.032-.559-.11-1.646-.023-2.663.12-1.399.564-2.092 1.093-2.704C8.52 4.277 9.714 3 11.997 3s3.48 1.272 3.734 1.565c.53.613.975 1.306 1.094 2.705.087 1.016.012 2.105-.024 2.662-.012.184.043.252.194.252a.44.44 0 0 0 .104-.014c.283-.07.773-.325 1.277-.435.082-.019.166-.029.25-.029.268 0 .52.106.625.38.149.398-.052.722-.512 1.047-.277.196-1.278.822-1.503 1.033-.234.218-.203.387-.176.602.022.18.525 2.567 3.681 4.11.186.095.5.286-.054.599z"
  })), props.children);
};
var V2ShareTwitterIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66 19.629c6.794 0 10.508-5.628 10.508-10.508 0-.16-.003-.319-.01-.477A7.513 7.513 0 0 0 21 6.732a7.373 7.373 0 0 1-2.12.581 3.706 3.706 0 0 0 1.623-2.043 7.4 7.4 0 0 1-2.345.897 3.694 3.694 0 0 0-6.293 3.368 10.484 10.484 0 0 1-7.612-3.859 3.69 3.69 0 0 0 1.143 4.93 3.666 3.666 0 0 1-1.673-.461v.047a3.695 3.695 0 0 0 2.962 3.62 3.703 3.703 0 0 1-1.667.063 3.697 3.697 0 0 0 3.45 2.565 7.41 7.41 0 0 1-4.587 1.581c-.298 0-.592-.017-.881-.051a10.454 10.454 0 0 0 5.66 1.659z"
  })), props.children);
};
var V2ShareWechatIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.595 9.985c2.994 0 5.405 2.011 5.405 4.505 0 1.347-.723 2.573-1.869 3.398-.1.06-.16.16-.14.301 0 .04 0 .08.02.12.08.343.24.886.24.906 0 .06.02.1.02.14a.18.18 0 0 1-.18.181c-.04 0-.06-.02-.1-.04l-1.186-.683a.654.654 0 0 0-.281-.08c-.06 0-.12 0-.161.02a6.368 6.368 0 0 1-1.768.24c-2.994 0-5.405-2.01-5.405-4.503 0-2.494 2.41-4.505 5.405-4.505zM9.505 5c3.155 0 5.795 1.862 6.362 4.347l.043.209h-.363c-3.263 0-5.921 2.208-5.921 4.917 0 .37.052.726.144 1.07l.078.255h-.363c-.725 0-1.45-.12-2.115-.301-.06-.02-.12-.02-.18-.02a.652.652 0 0 0-.264.06l-.08.04-1.43.823c-.04.02-.08.04-.12.04-.12 0-.222-.1-.222-.22 0-.06.02-.1.04-.161.02-.02.202-.683.303-1.084 0-.04.02-.1.02-.14a.456.456 0 0 0-.181-.362C3.866 13.49 3 12.025 3 10.4 3 7.409 5.92 5 9.505 5zm7.874 7.294a.732.732 0 0 0-.735.735c0 .408.327.735.735.735a.745.745 0 0 0 .735-.735.732.732 0 0 0-.735-.735zm-3.621 0a.732.732 0 0 0-.735.735c0 .408.327.735.735.735a.745.745 0 0 0 .735-.735.732.732 0 0 0-.735-.735zm-2.152-4.46a.833.833 0 0 0-.84.84c0 .468.372.84.84.84.47 0 .84-.391.84-.84a.833.833 0 0 0-.84-.84zm-4.303 0a.833.833 0 0 0-.84.84c0 .468.372.84.84.84.469 0 .84-.391.84-.84a.833.833 0 0 0-.84-.84z"
  })), props.children);
};
var V2ShareWhatsappIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.06 13.787c-.222-.112-1.318-.651-1.522-.726-.204-.074-.353-.111-.501.112-.149.223-.576.725-.706.874-.13.149-.26.167-.483.056-.223-.112-.941-.347-1.792-1.107-.663-.59-1.11-1.32-1.24-1.543-.13-.223-.014-.344.098-.455.1-.1.223-.26.334-.39.111-.13.149-.224.223-.373.074-.148.037-.278-.019-.39-.055-.111-.501-1.209-.687-1.655-.18-.434-.365-.375-.501-.382a8.936 8.936 0 0 0-.427-.008.819.819 0 0 0-.595.279c-.204.223-.78.762-.78 1.859s.799 2.157.91 2.305c.112.15 1.572 2.4 3.808 3.366.531.23.946.366 1.27.47.534.169 1.02.145 1.404.087.428-.064 1.318-.539 1.504-1.06.186-.52.186-.966.13-1.06-.056-.092-.204-.148-.427-.26zm-4.066 5.552h-.003a7.403 7.403 0 0 1-3.773-1.033l-.27-.161-2.806.736.748-2.736-.176-.28a7.396 7.396 0 0 1-1.133-3.946c.001-4.087 3.327-7.413 7.416-7.413a7.365 7.365 0 0 1 5.242 2.175 7.37 7.37 0 0 1 2.169 5.244c-.002 4.088-3.327 7.414-7.414 7.414zm6.31-13.723A8.861 8.861 0 0 0 11.994 3c-4.916 0-8.917 4.001-8.92 8.919 0 1.572.41 3.106 1.191 4.459L3 21l4.728-1.24a8.912 8.912 0 0 0 4.263 1.085h.003c4.916 0 8.918-4.001 8.92-8.92a8.866 8.866 0 0 0-2.61-6.31z"
  })), props.children);
};
var V2ShareIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.774 4.97c0-.413.509-.624.814-.338l6.764 6.326a.46.46 0 0 1 0 .676l-6.764 6.327c-.305.286-.814.075-.814-.338v-3.04c-4.623.1-8.077 1.676-10.406 4.726-.307.403-.962.116-.857-.375C3.726 13.25 7.567 9.067 13.774 8.08V4.97z"
  })), props.children);
};
var V2ShippingLabelIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.5 2.206a3.5 3.5 0 0 0-3.5 3.5v13a3.5 3.5 0 0 0 3.5 3.5h13a3.5 3.5 0 0 0 3.5-3.5v-13a3.5 3.5 0 0 0-3.5-3.5h-13zm8.25 2.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5zM13 8.456a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75zm-8.5 5a.75.75 0 0 1 .75-.75h13.5a.75.75 0 1 1 0 1.5H5.25a.75.75 0 0 1-.75-.75zm0-8.25a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-5zm0 11.5a.5.5 0 1 1 1 0v2.5a.5.5 0 0 1-1 0v-2.5zm2.5-.5a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 1 0v-2.5a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 1 1 1 0v2.5a.5.5 0 0 1-1 0v-2.5zm2.5-.5a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 1 0v-2.5a.5.5 0 0 0-.5-.5zm1.5.5a.5.5 0 1 1 1 0v2.5a.5.5 0 0 1-1 0v-2.5zm3.5-.5a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 1 0v-2.5a.5.5 0 0 0-.5-.5zm2 0a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 1 0v-2.5a.5.5 0 0 0-.5-.5zm-13.5-8.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ShippingPackIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.03 8.03a.75.75 0 0 1-1.06 0L9.592 6.653l-1.04-1.041a.75.75 0 0 1 1.06-1.06l1.056 1.056V2.75a.75.75 0 0 1 1.5 0v3.021l1.22-1.22a.75.75 0 1 1 1.06 1.061l-1.04 1.04L12.03 8.03zm-7.048.352l3.324-1.247 1.78 1.78a2 2 0 0 0 2.828 0l1.78-1.78 3.323 1.247-5.844 2.936a1.5 1.5 0 0 1-.625.159.633.633 0 0 0-.096 0 1.5 1.5 0 0 1-.626-.16L4.982 8.383zM4 9.059l-.616-.309-2.5 2L4 12.314l4.384 2.202 2.49-1.993v-.012L4 9.059zm18.12 1.691l-2.5-2-.62.311-6.875 3.452v.007l2.495 1.996 4.38-2.2 3.12-1.566zM19 13.435v4.69l-7.5 3.75-7.5-3.75v-4.692l3.936 1.976a1 1 0 0 0 1.073-.113l1.866-1.492V19.5a.625.625 0 1 0 1.25 0v-5.7l1.87 1.496a1 1 0 0 0 1.074.113l3.93-1.974z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ShippingSendIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.5 4L2 7.75v9.375l7.5 3.75 7.5-3.75V16.5h-2a2 2 0 1 1 0-4h2V7.75L9.5 4zM17 15.25h-2a.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.75h4.521l-1.22-1.22a.75.75 0 1 1 1.061-1.06l2.418 2.418a.75.75 0 0 1 0 1.06l-2.418 2.419a.75.75 0 1 1-1.06-1.06l1.056-1.057H17zM3.238 8.72a.625.625 0 0 1 .838-.279L9.5 11.153l5.424-2.712a.625.625 0 1 1 .559 1.118l-5.358 2.679V18.5a.625.625 0 1 1-1.25 0v-6.262L3.517 9.559a.625.625 0 0 1-.28-.839z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ShippingIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 7.206a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v7.55a2.5 2.5 0 0 0-2 2.45H9.5a2.5 2.5 0 1 0-5 0H4a2 2 0 0 1-2-2v-8zm6.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm9.5 0h3a1 1 0 0 0 1-1v-2.333a2 2 0 0 0-.4-1.2l-2.3-3.067a1 1 0 0 0-.8-.4H17a1 1 0 0 0-1 1v4.55a2.5 2.5 0 0 1 2 2.45zm-1.998-1.414a1.501 1.501 0 1 1-1.006 2.828 1.501 1.501 0 0 1 1.006-2.828zM18 10.5a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h1.46a.5.5 0 0 0 .39-.812l-1.2-1.5a.5.5 0 0 0-.39-.188H18z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ShoppingBasketIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 8.295a6.252 6.252 0 0 1 11.5 0 .75.75 0 1 0 1.379-.59 7.752 7.752 0 0 0-14.258 0 .75.75 0 1 0 1.38.59zM3.5 10a1.5 1.5 0 0 0-.321 2.966l.614 6.76A2.5 2.5 0 0 0 6.283 22h11.434a2.5 2.5 0 0 0 2.49-2.274l.614-6.76A1.5 1.5 0 0 0 20.5 10h-17zM6 13a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0v-6zm5.5 0a.5.5 0 0 1 1 0v6a.5.5 0 0 1-1 0v-6zm-2.25-.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5zm6 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6zm2.25-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ShoppingcartIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.822 7.22H7.712c-.142 0-.39-.038-.438-.248l-.496-2.605a1.056 1.056 0 0 0-1.05-.955H3.466a.721.721 0 0 0-.716.716c0 .391.325.716.716.716h1.603a.35.35 0 0 1 .344.305l1.994 10.289c0 .028.02.047.02.076.01.038.019.086.038.124a.34.34 0 0 0 .038.086c.277.601.964 1.03 1.775 1.03H17c.993 0 1.651-.563 1.9-1.46l1.813-6.365c.21-.84-.773-1.709-1.89-1.709zM9.67 20.667a1.432 1.432 0 1 0 0-2.863 1.432 1.432 0 0 0 0 2.863zm6.862 0a1.432 1.432 0 1 0 0-2.863 1.432 1.432 0 0 0 0 2.863z"
  })), props.children);
};
var V2SkipIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.509 4.388C5.545 3.524 4 4.198 4 5.482v13.036c0 1.284 1.545 1.958 2.509 1.094l7.27-6.517a1.465 1.465 0 0 0 0-2.19L6.51 4.388zM18 4.11c-1.105 0-2 .884-2 1.973v11.834c0 1.09.895 1.972 2 1.972s2-.883 2-1.972V6.083c0-1.09-.895-1.972-2-1.972z"
  })), props.children);
};
var V2SplitBillIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v1.997A2 2 0 0 0 7.45 9.92l8.638 2.468A1.5 1.5 0 0 0 18 10.946V6zM7.912 11.612A1.5 1.5 0 0 0 6 13.054V18a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1.997a2 2 0 0 0-1.45-1.923l-8.638-2.468zM8.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zM8 15.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2SubtractIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12.467v-.934c0-.293.16-.533.356-.533h15.288c.196 0 .356.24.356.533v.934c0 .293-.16.533-.356.533H4.356C4.16 13 4 12.76 4 12.467z"
  })), props.children);
};
var V2SwitchcardIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.75 5.42L7.79 2.05c-.89-.23-1.81.3-2.04 1.2L4.78 7H18.2c1.25 0 2.33.7 2.89 1.72.13.23.49.17.55-.09l.31-1.18c.23-.89-.3-1.8-1.2-2.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.21 8.5H3.8c-.99 0-1.8.81-1.8 1.8v9c0 .99.81 1.8 1.8 1.8h14.4c.99 0 1.8-.81 1.8-1.8v-9c.01-.99-.8-1.8-1.79-1.8zm-1.7 10.6c-.38 0-.73-.15-.99-.38a.2.2 0 0 0-.27 0c-.26.24-.61.38-.99.38-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5c.38 0 .73.15.99.38a.2.2 0 0 0 .27 0c.26-.24.61-.38.99-.38.83 0 1.5.67 1.5 1.5s-.68 1.5-1.5 1.5z"
  })), props.children);
};
var V2TipJarIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 2.206a.5.5 0 0 1 .5.5V3a.5.5 0 0 1 0 1h-9a.5.5 0 1 1 0-1v-.294a.5.5 0 0 1 .5-.5h8zM7.285 5h9.43a2 2 0 0 0 .462.597l.808.713A3 3 0 0 1 19 8.56V19a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V8.56a3 3 0 0 1 1.015-2.25l.808-.713A2 2 0 0 0 7.285 5zM17 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-6 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ToolsIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.046 9.877l-1.741 1.74-1.923-1.922 1.741-1.742a3.4 3.4 0 0 1 4.408-4.407l-1.85 1.85a.5.5 0 0 0 0 .707l1.216 1.216a.5.5 0 0 0 .707 0l1.85-1.85a3.4 3.4 0 0 1-4.408 4.408zm-5.814 1.967l1.923 1.923 2.06 2.06a1.36 1.36 0 0 0 .21 1.652l2.884 2.884a1.36 1.36 0 0 0 1.923 0l.962-.961a1.36 1.36 0 0 0 0-1.923l-2.885-2.885a1.36 1.36 0 0 0-1.652-.21l-6.521-6.52-.334-1.336a1.36 1.36 0 0 0-.683-.872L5.012 4.012a.68.68 0 0 0-.799.12l-.251.251a.68.68 0 0 0-.12.799l1.645 3.107c.18.341.497.59.872.683l1.335.334 2.538 2.538zm-2.278 2.279l1.571-1.572 1.923 1.924-1.571 1.571a3.4 3.4 0 0 1-4.408 4.408l1.85-1.85a.5.5 0 0 0 0-.708L6.103 16.68a.5.5 0 0 0-.707 0l-1.85 1.85a3.4 3.4 0 0 1 4.408-4.407z",
    clipRule: "evenodd"
  })), props.children);
};
var V2TopUpIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 6c.702 0 1.271.55 1.271 1.23v12.54c0 .68-.57 1.23-1.271 1.23-.702 0-1.271-.55-1.271-1.23V7.23c0-.68.57-1.23 1.271-1.23z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.372 13.64a1.201 1.201 0 0 1 0-1.738l5.73-5.542a1.301 1.301 0 0 1 1.797 0l5.729 5.542c.496.48.496 1.259 0 1.739-.497.48-1.301.48-1.798 0L12 8.968l-4.83 4.673c-.497.48-1.301.48-1.798 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2TrackIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.32 21.43c2.019-2.892 6.161-9.193 6.161-12.21 0-3.987-3.242-7.22-7.24-7.22C8.24 2 5 5.233 5 9.22c0 3.017 4.142 9.318 6.16 12.21.531.76 1.63.76 2.16 0zm-1.177-9.59a2.62 2.62 0 1 0 0-5.241 2.62 2.62 0 0 0 0 5.24z",
    clipRule: "evenodd"
  })), props.children);
};
var V2TransferVerticalIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.064 21.246a.844.844 0 0 0 .843-.844v-12a.844.844 0 0 0-1.687 0v12c0 .466.378.844.844.844z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.901 16.24a.844.844 0 0 0 0 1.193l3.566 3.566a.844.844 0 0 0 1.193 0l3.566-3.566a.844.844 0 0 0-1.193-1.194l-2.97 2.97-2.968-2.97a.844.844 0 0 0-1.194 0zm-5.034 1.006a.844.844 0 0 0 .844-.844v-12a.844.844 0 0 0-1.688 0v12c0 .466.378.844.844.844z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.705 8.564a.844.844 0 0 1 0-1.193L7.27 3.805a.844.844 0 0 1 1.194 0l3.565 3.566a.844.844 0 1 1-1.193 1.193L7.867 5.595l-2.97 2.97a.844.844 0 0 1-1.192 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2TransferIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.755 17.064c0 .466.377.843.843.843h12a.844.844 0 0 0 0-1.687h-12a.844.844 0 0 0-.843.844z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76 12.901a.844.844 0 0 0-1.193 0l-3.565 3.566a.844.844 0 0 0 0 1.193l3.565 3.566a.844.844 0 0 0 1.194-1.193l-2.97-2.97 2.97-2.968a.844.844 0 0 0 0-1.194zM6.755 7.867c0 .466.377.844.843.844h12a.844.844 0 1 0 0-1.688h-12a.844.844 0 0 0-.843.844z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.436 3.705a.844.844 0 0 1 1.193 0l3.566 3.565c.33.33.33.864 0 1.194l-3.566 3.565a.844.844 0 0 1-1.193-1.193l2.97-2.969-2.97-2.97a.844.844 0 0 1 0-1.192z",
    clipRule: "evenodd"
  })), props.children);
};
var V2TravelIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.796 16.502c2.483-4.3 1.005-9.816-3.296-12.299C12.2 1.72 6.684 3.198 4.201 7.499c-2.483 4.3-1.005 9.816 3.296 12.299 4.312 2.48 9.816 1.005 12.299-3.296zm-.558-6.74c.1-.025.203.033.232.133a7.605 7.605 0 0 1-.73 5.945 7.686 7.686 0 0 1-6.438 3.847c-.958-.38 1.416-1.587 2.333-2.667.939-1.117-1.228-2.894.715-4.586 1.83-1.594 2.368-2.297 3.888-2.673zM5.378 8.114c1.967-3.407 6.165-4.735 9.706-3.234a.19.19 0 0 1 .099.257c-.271.558-1.156 2.111-2.814 2.382-2.028.33-.079 3.83-2.884 4.342-2.407.43-3.208-2.268-4.27-2.555-.158-.043-.314-.212-.25-.364.117-.28.255-.554.413-.828z"
  })), props.children);
};
var V2TreatYourselfIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 16a1 1 0 0 1-1 1H9V7h11a1 1 0 0 1 1 1v2l-.15.005A2 2 0 0 0 21 14v2zM8 7v10H4a1 1 0 0 1-1-1v-2l.15-.005A2 2 0 0 0 3 10V8a1 1 0 0 1 1-1h4zm5.637 2.275l-.447 1.436a.383.383 0 0 1-.362.276h-1.446c-.37 0-.523.493-.224.72l1.17.888c.133.101.19.281.138.445l-.447 1.437c-.114.367.288.672.587.445l1.17-.887a.367.367 0 0 1 .448 0l1.17.887c.299.227.7-.078.587-.445l-.447-1.437a.408.408 0 0 1 .139-.445l1.17-.888c.298-.227.145-.72-.225-.72h-1.446a.383.383 0 0 1-.363-.276l-.446-1.436a.377.377 0 0 0-.726 0z",
    clipRule: "evenodd"
  })), props.children);
};
var V2TrophyIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1h1.234c1.009 0 1.846.759 1.733 1.76C21.695 9.18 20.45 12.945 16 13l-2 2.666a4.998 4.998 0 0 0-.965 2.41c2.222.349 3.217 1.802 3.65 2.838.231.555-.216 1.085-.818 1.085H8.133c-.602 0-1.049-.53-.817-1.085.433-1.036 1.427-2.489 3.65-2.838a5 5 0 0 0-.966-2.41l-2-2.668c-4.45-.055-5.695-3.82-5.967-6.238C1.92 5.759 2.757 5 3.766 5H5V4zm13.973 2.7a8.999 8.999 0 0 1-1.538 4.372 3.435 3.435 0 0 0 1.722-1.28c.645-.884.973-2.052 1.105-3.09a.294.294 0 0 0-.028-.002h-1.261zm-13.946 0H3.766l-.028.001c.132 1.039.46 2.207 1.105 3.09.395.542.931 1.015 1.722 1.28A9 9 0 0 1 5.027 6.7zM17.5 5a.5.5 0 0 0-1 0v.015c0 .012 0 .032-.002.058a9.28 9.28 0 0 1-.117 1.095 9.331 9.331 0 0 1-.828 2.608c-.485.97-.969 1.695-1.328 2.174a9.142 9.142 0 0 1-.545.661 3.118 3.118 0 0 1-.028.03l-.005.005-.001.001a.5.5 0 0 0 .708.707s-.002.001 0-.001l.002-.002.003-.003.012-.012a6.584 6.584 0 0 0 .177-.194c.117-.134.281-.331.477-.592.39-.521.907-1.297 1.422-2.326.529-1.058.79-2.109.921-2.892a10.334 10.334 0 0 0 .13-1.226l.002-.075V5z",
    clipRule: "evenodd"
  })), props.children);
};
var V2TuitionIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 12v2.686a1 1 0 0 1-.193.59C16.477 17.093 14.54 18 12 18c-2.54 0-4.476-.908-5.807-2.723A1 1 0 0 1 6 14.686V12l6 3 6-3zm-6-6l9 3.5-9 4.5-9-4.5L12 6z",
    clipRule: "evenodd"
  })), props.children);
};
var V2UnlockIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 8.32H7.94a.19.19 0 0 1-.19-.19v-.38c0-2.31 1.85-4.18 4.14-4.24h.26c.33 0 .6-.27.6-.6v-.3c0-.33-.27-.6-.6-.6H12V2C8.83 2 6.25 4.58 6.25 7.75v.68C4.96 8.76 4 9.93 4 11.32v6.81c0 1.66 1.34 3 3 3h10c1.66 0 3-1.34 3-3v-6.81c0-1.65-1.34-3-3-3zm-4.09 6.05c-.09.07-.16.17-.16.29v2.73c0 .21-.17.39-.39.39h-.72a.39.39 0 0 1-.39-.39v-2.73c0-.12-.06-.22-.16-.29-.36-.27-.59-.7-.59-1.19 0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .49-.23.92-.59 1.19z"
  })), props.children);
};
var V2UploadIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.34 13.53h-.22c-.35 0-.64.29-.64.64v4.05c0 .69-.49 1.25-1.08 1.25H5.58c-.6 0-1.08-.56-1.08-1.25v-4.05c0-.35-.29-.64-.64-.64h-.22c-.35 0-.64.29-.64.64v4.05c0 1.52 1.16 2.75 2.58 2.75h12.81c1.42 0 2.58-1.23 2.58-2.75v-4.05a.63.63 0 0 0-.63-.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.58 3.172c.23-.23.61-.23.84 0l4.55 4.51c.38.37.11 1.02-.42 1.02h-1.8v7.09c0 .5-.41.91-.91.91h-3.68c-.5 0-.91-.41-.91-.91v-7.09h-1.8c-.53 0-.8-.65-.42-1.02l4.55-4.51z"
  })), props.children);
};
var V2VacationIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15l-5 4H7l3-4h5zM6 8l2 2h11a2 2 0 1 1 0 4H5.72a1 1 0 0 1-.948-.684L3 8h3zm4-3l5 4h-5L7 5h3z",
    clipRule: "evenodd"
  })), props.children);
};
var V2VerifiedIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.427 19.668c.372-.55.744-1.103 1.184-1.282.416-.17 1.043-.04 1.68.093.801.166 1.617.336 2.044-.087.427-.422.265-1.24.105-2.043-.127-.638-.252-1.266-.079-1.68.184-.438.739-.805 1.293-1.172.672-.445 1.343-.889 1.346-1.457.002-.567-.664-1.017-1.333-1.468-.55-.372-1.102-.744-1.282-1.184-.17-.415-.04-1.043.093-1.679.167-.801.337-1.618-.086-2.044-.423-.427-1.24-.265-2.043-.105-.637.127-1.266.252-1.68.078-.438-.184-.806-.74-1.173-1.294-.445-.672-.888-1.342-1.455-1.344-.568-.003-1.018.664-1.47 1.332-.37.551-.743 1.103-1.183 1.283-.416.17-1.043.039-1.68-.094-.8-.167-1.617-.337-2.044.087-.426.422-.264 1.239-.104 2.041.127.638.252 1.267.078 1.682-.183.438-.739.806-1.293 1.172-.672.445-1.343.889-1.345 1.457-.003.568.664 1.018 1.333 1.468.55.372 1.102.744 1.282 1.184.17.416.04 1.043-.093 1.68-.167.801-.337 1.617.085 2.044.423.427 1.24.264 2.043.104.638-.127 1.267-.252 1.682-.078.438.183.805.738 1.172 1.293.444.672.888 1.343 1.456 1.345.567.003 1.017-.663 1.467-1.332zm-2.81-6.639l4.167-4.114a1.027 1.027 0 0 1 1.414-.016.941.941 0 0 1 .017 1.365l-4.884 4.821a1.027 1.027 0 0 1-1.433-.002l-2.116-2.102a.94.94 0 0 1 .02-1.364 1.026 1.026 0 0 1 1.415.02l1.4 1.392z",
    clipRule: "evenodd"
  })), props.children);
};
var V2ViewIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.91 11.41A13.353 13.353 0 0 0 19.96 8C18.38 6 15.85 4 12 4c-6.07 0-8.86 4.96-9.76 7.06-.01.01-.01.02-.01.03-.06.13-.1.24-.14.34-.01.01-.02.02-.01.04-.06.16-.08.34-.08.52s.03.36.07.53c.01.02.01.05.02.06.04.1.09.2.14.32 0 .01.01.02.02.04.32.77.9 1.91 1.8 3.05 1.57 1.99 4.1 4 7.94 4 6.2 0 8.99-5.21 9.84-7.22v-.01a1.853 1.853 0 0 0 .08-1.35zM12 16.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-.69 3.3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
  })), props.children);
};
var V2VoucherIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 9V6H3v3a3 3 0 1 1 0 6v3h8v-3h2v3h8v-3a3 3 0 1 1 0-6V6h-8v3h-2zm0 1.5h2v3h-2v-3z",
    clipRule: "evenodd"
  })), props.children);
};
var V2WalletIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11.75A2.75 2.75 0 0 1 4.75 9h13.82a2.75 2.75 0 0 1 2.75 2.75v6.66a2.75 2.75 0 0 1-2.75 2.75H4.75A2.75 2.75 0 0 1 2 18.41v-6.66zM5.5 5.5c-2 0-2.5 1.333-2.5 2h17c0-1.6-1.333-2-2-2H5.5zM6.206 2C4.44 2 4 3.333 4 4h15c0-1.6-1.177-2-1.765-2H6.205z"
  })), props.children);
};
var V2WandIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9 10.404l2.121 2.121-9.9 9.9-2.12-2.122 9.899-9.9zm.707-.708l2.121 2.122 2.121-2.122-2.121-2.121-2.121 2.121zM8.924 8l.8-2.2 2.2-.8-2.2-.8-.8-2.2-.8 2.2-2.2.8 2.2.8.8 2.2zm10 11l.8-2.2 2.2-.8-2.2-.8-.8-2.2-.8 2.2-2.2.8 2.2.8.8 2.2zm0-11l.8-2.2 2.2-.8-2.2-.8-.8-2.2-.8 2.2-2.2.8 2.2.8.8 2.2z"
  })), props.children);
};
var V2WarningSmIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 15.655a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM8.036 4.539a.5.5 0 0 1 .5-.534h.922a.5.5 0 0 1 .498.54l-.407 5a.5.5 0 0 1-.499.46h-.175a.5.5 0 0 1-.5-.466l-.339-5zM8.01 11.99a.991.991 0 0 1 1.982 0v.032a.991.991 0 1 1-1.982 0v-.032z"
  })), props.children);
};
var V2WarningIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM10.87 7.454a.5.5 0 0 1 .498-.537h1.256a.5.5 0 0 1 .498.544l-.484 5.454a.5.5 0 0 1-.498.456h-.369a.5.5 0 0 1-.498-.463l-.403-5.454zm-.079 8.45a1.209 1.209 0 1 1 2.418 0v.038a1.209 1.209 0 0 1-2.418 0v-.038z"
  })), props.children);
};
var V2WebsiteIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.778 4H4.222C3 4 2 5 2 6.222v11.556C2 19 3 20 4.222 20h15.556C21 20 22 19 22 17.778V6.222A2.222 2.222 0 0 0 19.778 4zM14.7 13.489L13.433 14l1.223 1.222c.233.234.233.6 0 .834l-.2.2a.584.584 0 0 1-.834 0L12.4 15.033l-.511 1.267a.294.294 0 0 1-.545 0l-2.2-5.167a.298.298 0 0 1 .39-.389l5.166 2.19c.244.11.244.455 0 .555zm5.411-5.056H3.89a.223.223 0 0 1-.222-.222V6.222a.55.55 0 0 1 .555-.555h15.556a.55.55 0 0 1 .555.555v1.99c0 .121-.1.221-.222.221z"
  })), props.children);
};
var V2WithdrawCashIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.985 16c.56 0 1.015-.448 1.015-1V8c0-.552-.454-1-1.015-1H5.792c-.56 0-1.015.448-1.015 1v7c0 .552.455 1 1.015 1H16.5v-1a2 2 0 1 1 4 0v1h.485zm-3.926 5.83A.999.999 0 0 0 17.5 21v.121c0-.397.158-.779.44-1.06l.681-.682a3 3 0 0 0 .879-2.122V15a1 1 0 1 0-2 0v2H17c-.316 0-.82.119-1.236.478-.398.345-.764.95-.764 2.022a.5.5 0 0 1-1 0c0-1.125.336-1.94.83-2.5H9.5v.5a3 3 0 0 0 .6 1.8l.6.8c.195.26.3.575.3.9a1 1 0 0 0 1 1h4.5c.207 0 .4-.063.56-.17zm-2.905-7.81a2.948 2.948 0 1 0-1.616-5.67 2.948 2.948 0 0 0 1.616 5.67zM19.223 6V5c0-.552-.455-1-1.015-1H3.015C2.455 4 2 4.448 2 5v7c0 .552.454 1 1.015 1h.508V7c0-.552.454-1 1.015-1h14.685z",
    clipRule: "evenodd"
  })), props.children);
};
var VerifiedAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.036 1c.92.004 1.474 1.983 2.337 2.345.83.349 2.634-.657 3.308.024.675.68-.347 2.474-.006 3.31.354.865 2.329 1.436 2.325 2.357-.005.92-1.984 1.475-2.346 2.336-.348.833.658 2.636-.023 3.31-.68.674-2.475-.347-3.31-.006-.865.353-1.437 2.329-2.356 2.324-.921-.004-1.475-1.984-2.337-2.345-.832-.349-2.635.657-3.31-.023-.674-.68.348-2.475.007-3.31C2.97 10.456.995 9.885 1 8.964c.004-.92 1.984-1.474 2.345-2.336.349-.832-.656-2.636.023-3.31.68-.675 2.475.347 3.31.006C7.544 2.971 8.116.995 9.036 1zm2.728 4.825L7.629 10.06 6.238 8.627a.993.993 0 1 0-1.425 1.383l2.1 2.164a.994.994 0 0 0 1.423.002l4.848-4.963a.994.994 0 0 0-1.42-1.388z"
  })), props.children);
};
var WalletIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 7h14.5A1.5 1.5 0 0 1 20 8.5v1.486a1.5 1.5 0 0 1-1.5 1.5h-2.6a.5.5 0 0 0-.353.147l-1.25 1.25a.5.5 0 0 0 0 .707l1.264 1.264a.5.5 0 0 0 .353.146H20v-2.5a.5.5 0 1 1 1 0v3a.5.5 0 0 1-.5.5H20v2.5a1.5 1.5 0 0 1-1.5 1.5h-14A1.5 1.5 0 0 1 3 18.5v-13A1.5 1.5 0 0 1 4.5 4h11A1.5 1.5 0 0 1 17 5.5a.5.5 0 1 1-1 0 .5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V7zm0 1v10.5a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V16h-3.086a1.5 1.5 0 0 1-1.06-.44l-1.264-1.263a1.5 1.5 0 0 1 0-2.122l1.25-1.25a1.5 1.5 0 0 1 1.06-.439h2.6a.5.5 0 0 0 .5-.5V8.5a.5.5 0 0 0-.5-.5H4z"
  })), props.children);
};
var WarningAltIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1c4.411 0 8 3.59 8 8 0 4.412-3.589 8-8 8s-8-3.588-8-8c0-4.41 3.589-8 8-8zm0 3a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  })), props.children);
};
var WarningIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-1a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.5-3.468c0-.293.24-.532.532-.532.292 0 .531.24.531.532 0 .292-.24.531-.531.531a.533.533 0 0 1-.532-.531zM11.5 7a.5.5 0 1 1 1 0v7.082a.5.5 0 1 1-1 0V7z"
  })), props.children);
};
var WithdrawCashIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.079 14.357l.545 2.538a.5.5 0 0 1-.978.21l-.904-4.208a1.384 1.384 0 0 0-.24-.309 1.2 1.2 0 0 0-.876-.357c-.353 0-.588.113-.754.303a.903.903 0 0 0-.148.228v4.923a.5.5 0 0 1-.214.41c-.56.392-.942.968-1.171 1.693-.235.742-.286 1.54-.23 2.24.007.085.013.144.017.171a.5.5 0 1 1-.99.14 4.144 4.144 0 0 1-.024-.232c-.065-.816-.007-1.736.273-2.62.124-.392.286-.754.49-1.082-.069-.396-.27-.915-.587-1.53-.15-.291-.322-.598-.519-.928-.025-.042-.741-1.167-1.084-1.78a19.874 19.874 0 0 0-1.152-.11 12.834 12.834 0 0 0-1.248-.013 26.85 26.85 0 0 0-1.65.11 32.855 32.855 0 0 0-1.067.12A.5.5 0 0 1 5 13.78V5.79a.5.5 0 0 1 .372-.483c.154-.04.43-.099.81-.155a14.577 14.577 0 0 1 3.428-.09c1.02.09 1.533.145 2.757.287l.184.022c.846.098 1.456.16 2.315.235 1.743.15 3.341-.012 4.52-.288a.5.5 0 0 1 .614.486v3.684c.227.317.507.851.778 1.64.54 1.573.854 3.661.83 6.331l-.035.182a60.314 60.314 0 0 1-1.1 2.564c-.104.226-.205.442-.303.646-.28.583-.53 1.056-.746 1.4a.5.5 0 0 1-.848-.53c.192-.307.427-.751.693-1.304.095-.197.193-.408.294-.628a59.343 59.343 0 0 0 1.046-2.433c.013-2.216-.215-3.99-.609-5.368v1.584a.5.5 0 0 1-.33.47c-.18.065-.523.153-1.047.239-.17.027-.352.053-.544.077zm-.211-.982c.212-.025.41-.052.594-.082A9.28 9.28 0 0 0 19 13.19V6.417c-1.184.217-2.645.32-4.22.184-.87-.075-1.49-.14-2.343-.238l-.185-.021a83.855 83.855 0 0 0-2.73-.286A13.586 13.586 0 0 0 6 6.194v7.021a27.822 27.822 0 0 1 2.252-.17 13.79 13.79 0 0 1 2.257.095l.524.06.534.065c.808.096 1.443.156 2.157.193v-.778l.017-.13c.05-.186.165-.43.377-.673.352-.403.858-.646 1.508-.646.642 0 1.17.244 1.576.644.242.237.394.476.473.654l.032.098.16.748zm-4.144 1.085c-.61-.03-1.162-.077-1.795-.147l.262.411c.161.256.303.485.437.711.207.347.39.671.549.982.2.387.36.745.48 1.075l.067-.056V14.46zM3.002 3.67a64796.053 64796.053 0 0 0 .022 5.738.5.5 0 0 1-.282.954 5.556 5.556 0 0 1-.336-.071.5.5 0 0 1-.38-.484l-.013-3.285V6.52l-.012-3.287a.5.5 0 0 1 .485-.502c2.015-.298 3.62-.228 7.143.153 3.472.375 5.011.44 6.94.15a.5.5 0 0 1 .15.989c-2.043.308-3.64.24-7.203-.146-3.21-.346-4.77-.428-6.514-.207zM12.5 7.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  })), props.children);
};
var WorkingCapitalIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.861 2.118c3.59 1.257 5.07 3.181 4.21 5.642l-.081.213.134.12a8.453 8.453 0 0 1 1.489 1.765c-.009-3.167 2.082-4.425 5.942-3.662a.5.5 0 0 1 .39.601c-.858 3.77-2.87 5.184-5.82 3.99l-.035-.015.101.249c.767 2.009.501 4.305-.787 6.855l-.031.057 2.245-1.015c1.368-.567 2.418-.64 3.172-.376l.147.057c.196.084.334.178.363.213.635.46.688 1.068.23 1.448a.985.985 0 0 1-.179.12l-.021.008-5.968 3.249a2.955 2.955 0 0 1-.76.294c-.55.133-1.121.133-1.658.055a3.721 3.721 0 0 1-.233-.04l-.094-.022-5.16-1.554c-.397-.144-.712-.217-.953-.235a.934.934 0 0 0-.252.008l-.025.007-.516.333a.5.5 0 0 1-.613-.785l.071-.056.429-.264a.782.782 0 0 1 .27-.162c.379-.142.935-.115 1.693.132l.211.073 5.106 1.538.079.016a3.444 3.444 0 0 0 1.41-.016c.123-.03.24-.068.35-.117l.16-.08L20.69 17.6l-.03-.023-.028-.016a.887.887 0 0 0-.037-.02l-.053-.023c-.465-.2-1.21-.186-2.29.223l-.236.094-3.633 1.645a.5.5 0 0 1-.63-.721c.933-1.483 1.515-2.854 1.749-4.12a.483.483 0 0 1-.262-.166c-.697-.858-1.616-1.52-2.763-1.987-2.62 1.348-4.65.619-5.833-2.118a.5.5 0 0 1 .245-.65c3.252-1.535 5.407-.902 6.106 1.901l-.202-.083c1.123.448 2.067 1.068 2.827 1.859 0-1.722-.722-3.232-2.159-4.553l-.263-.233h-.034c-3.057-.092-4.415-2.122-3.996-5.818l.033-.267a.5.5 0 0 1 .66-.406zm.11 13.079c2.43.793 3.583 1.43 3.578 2.339-.024.159-.102.353-.271.54-.224.247-.549.401-.965.436l-.184.007H9.984a.5.5 0 0 1-.09-.992l.09-.008h2.145c.192 0 .306-.033.373-.083l.011-.011-.015-.013a2.972 2.972 0 0 0-.373-.257l-.122-.07c-.507-.28-1.29-.594-2.332-.934-1.162-.35-2.214-.473-2.89-.392-.389.063-.76.177-1.084.335l-2.46 1.32a.5.5 0 0 1-.549-.832l.076-.05 2.257-1.21a4.75 4.75 0 0 1 1.621-.553c.844-.101 2.032.036 3.329.428zM7.985 10.33l-.213.087.072.134c.92 1.663 2.211 2.018 4.05 1.111l.067-.034-.05-.155c-.55-1.611-1.786-1.993-3.926-1.143zm8.63-.706l-.004.202.001.077.077.03c1.967.721 3.261-.026 4.023-2.403l.072-.235.059-.21-.205-.03c-2.68-.373-3.945.457-4.023 2.569zm-6.491-6.341l-.012.146c-.19 2.706.748 4.029 2.873 4.17l.076.004.017-.042c.676-1.765-.188-3.132-2.774-4.205l-.18-.073z"
  })), props.children);
};
var WorldIcon = function (props) {
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: props.svgElementRef
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.416 9.447a8 8 0 0 0 13.513 7.923 1.6 1.6 0 0 1-.716-.756 1.193 1.193 0 0 1-.051-1.042c.002-.004.029-.295.037-.64.005-.194.006-.358.006-.647 0-.51.203-.825.672-1.22-.31-.187-.487-.495-.426-.896a.233.233 0 0 0-.086-.007c-.866 0-1.39-.583-1.507-1.554a1.412 1.412 0 0 1-.766-.966c-.226-.845.191-1.37.98-1.723.084-.037.149-.063.286-.118.108-.043.157-.063.21-.086.427-.186 1.149-.2 2.114-.116a8.044 8.044 0 0 0-2.106-2.162 1.8 1.8 0 0 0-.018.011 1.8 1.8 0 0 1-1.191 1.039 3.34 3.34 0 0 0-.528.185c-.2.09-.407.164-.633.224-.08.019-.16.032-.262.041a1.964 1.964 0 0 1-1.632-.734c-.339-.488-.227-1.049.216-2.05.023-.044.046-.088.07-.13a8.114 8.114 0 0 0-2.274.153 1.942 1.942 0 0 1-.028.197c-.039.285-.016.74.04.811.549.718.848 1.55.468 2.139-.287.52-.802.856-1.45.888.105.01.1.013.114.005-.058.03-.142.077-.244.14a17.977 17.977 0 0 0-.968.634 4.62 4.62 0 0 0 .307-.018l.047-.004c.681-.06 1.041.033 1.421.603.128.232.21.489.243.754.232-.096.394-.15.58-.182.29-.05.565-.024.822.102.832.408 1.45 1.222 1.302 2.021a3.343 3.343 0 0 0-.027.176l-.004.029c-.03.226-.05.34-.09.489-.144.537-.464.936-1.03 1.14-.328.117-.351.15-.38.518-.076.767-.532 1.436-1.179 1.739-.095.051-.089.037-.118.307l-.01.087-.008.074a.93.93 0 0 0 .01.247c.104.329.065.689-.13 1.021a.933.933 0 0 1-.808.406c-.606-.008-1.126-.434-1.304-1.12a6.61 6.61 0 0 1-.021-.886c.008-.568-.006-.982-.037-1.048a4.174 4.174 0 0 1-.242-.918 3.628 3.628 0 0 0-.23-.85 1.428 1.428 0 0 0-.357-.307c-.672-.491-.944-.8-.944-1.402 0-.267-.003-.389-.016-.532-.035-.395-.14-.637-.353-.79-.598-.43-1.012-.789-1.284-1.199zm.58-1.315a.51.51 0 0 1 0 .007c.085.692.406 1.062 1.287 1.694.49.351.708.857.766 1.513.017.183.02.326.02.622 0 .155.121.293.502.573.245.15.46.348.635.581l.06.104c.157.368.266.758.323 1.158.036.24.097.474.167.657.126.253.136.554.122 1.481-.01.256-.005.512.003.681.044.162.161.27.311.293a.321.321 0 0 0-.014-.158 1.9 1.9 0 0 1-.04-.612l.008-.08.01-.091c.062-.564.195-.84.663-1.09.346-.163.59-.523.631-.936.06-.734.322-1.114 1.04-1.371.23-.083.337-.216.402-.458.025-.094.04-.178.064-.363l.004-.03a4.11 4.11 0 0 1 .035-.225c.05-.266-.285-.706-.76-.939-.05-.025-.115-.031-.21-.015-.107.019-.225.06-.428.146-.03.012-.03.012-.015.004a1.7 1.7 0 0 1-.704.203.5.5 0 0 1-.503-.332 1.519 1.519 0 0 1-.086-.541 1.108 1.108 0 0 0-.11-.518c-.103-.152-.124-.157-.482-.125l-.05.004c-.18.015-.307.022-.46.022-.403 0-.738-.08-1.007-.22a1.197 1.197 0 0 1-.383-.296c-.094-.57-.094-.57 0-.626.041-.048.041-.048.066-.072l.09-.078c.06-.047.143-.11.245-.184.201-.147.466-.333.73-.511.902-.612 1.236-.813 1.44-.79.226-.013.437-.15.577-.403.08-.125-.095-.616-.404-1.02-.236-.308-.295-.818-.259-1.317a8.026 8.026 0 0 0-4.287 3.658zm8.711-3.95a1.848 1.848 0 0 0-.274.398c-.286.646-.352.976-.326 1.017a.942.942 0 0 0 .762.343.822.822 0 0 0 .095-.014c.158-.042.313-.097.463-.165.223-.1.453-.181.684-.241a.797.797 0 0 0 .554-.538.5.5 0 0 1 .031-.079 7.944 7.944 0 0 0-1.989-.72zm5.553 4.452a4.196 4.196 0 0 1-.454-.019c-.883-.088-1.603-.086-1.837.016-.068.03-.124.052-.242.1a6.1 6.1 0 0 0-.247.102c-.396.176-.49.295-.416.578.03.14.127.256.293.325.059.03.094.048.132.07.222.135.331.328.353.596.048.573.205.76.484.761.328-.025.65.097.912.37.178.225.25.515.203.779v.003c.017-.071.06-.053.304 0 .144.03.225.05.308.078a.5.5 0 0 1 .194.832 4.587 4.587 0 0 1-.492.419l-.036.027c-.396.307-.514.45-.514.614 0 .297 0 .467-.006.671-.014.553-.042.862-.124 1.02-.019.049-.015.103.032.192.08.18.232.316.382.363a.875.875 0 0 0 .094.016A7.963 7.963 0 0 0 20 12a7.97 7.97 0 0 0-.74-3.366zM12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18z"
  })), props.children);
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Icon(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'acorns' : _ref$name,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rest = _objectWithoutProperties(_ref, ["as", "size", "name", "className"]);

  return React.createElement(as, _objectSpread({
    className: clsx(styles.ppvx_icon, styles["ppvx_icon--size_".concat(size)], styles["ppvx_icon-".concat(name)], className)
  }, rest));
}

export { AchievementIcon, AcornsIcon, ActivityIcon, AddCashIcon, AddIcon, AddImageIcon, AddPaymentMethodIcon, ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon, AttachIcon, AutoTopUpIcon, BankIcon, BarcodeScanIcon, BlockIcon, BrowserIcon, CalculatorIcon, CalendarIcon, CalendarPausedIcon, CameraAddIcon, CameraIcon, CardIcon, CartIcon, CashCheckIcon, CashIcon, ChatIcon, CheckAltIcon, CheckCircleAltIcon, CheckCircleIcon, CheckIcon, ChevronCircleDownIcon, ChevronCircleUpIcon, ChevronDownAltIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightAltIcon, ChevronRightIcon, ChevronUpAltIcon, ChevronUpIcon, ClearAltIcon, ClearIcon, CloseAltIcon, CloseIcon, CodeIcon, ContactInfoIcon, CopyToClipboardIcon, CreditDebitCardsIcon, CriticalAltIcon, CryptoIcon, DeclineIcon, DesktopIcon, DirectDepositIcon, DisasterReliefIcon, DonateIcon, DownloadIcon, DuplicateIcon, EditIcon, EmailIcon, EmojiIcon, ErrorIcon, ExternalAltIcon, ExternalIcon, FaceIdIcon, FaqIcon, FavoriteIcon, FavoriteSelectedIcon, FilterIcon, FingerprintIcon, GiftIcon, GoalsIcon, HeartIcon, HelpCenterIcon, HideAltIcon, HomeIcon, HoneyIcon, Icon, IconContainer, InfoAltIcon, InfoIcon, InsightsIcon, InvoiceIcon, IzettlePosIcon, LaptopIcon, LightBulbIcon, LinkIcon, ListDetailedIcon, ListSimpleIcon, LocationIcon, LockAltIcon, LockIcon, LogoPaypalIcon, LogoutIcon, LoyaltyCardIcon, MenuIcon, MessageCenterIcon, MicrophoneIcon, MobileIcon, MoneyDeliveryIcon, MoneyPoolsIcon, NotificationIcon, NumberPadIcon, OffersRewardsIcon, OrderAheadIcon, OverflowIcon, PayOnlineIcon, PendingIcon, PendingPausedIcon, PhoneIcon, PhotoIcon, PixIcon, PlayIcon, PlaySmIcon, PpCashCardIcon, PreferredIcon, PreferredSelectedIcon, PrintIcon, PurchaseProtectionAltIcon, QuestionAltIcon, RecurringIcon, RecurringPausedIcon, RefreshIcon, RefundIcon, RequestIcon, ResolutionIcon, RocketIcon, ScanToSendIcon, SearchIcon, SecurityCodeIcon, SendIcon, SettingsIcon, ShareEmailIcon, ShareFacebookIcon, ShareIcon, ShareInstagramIcon, ShareLineIcon, ShareLinkIcon, ShareLinkedinIcon, ShareMessengerIcon, ShareMobileIcon, ShareSnapchatIcon, ShareTwitterIcon, ShareWechatIcon, ShareWhatsappIcon, ShieldIcon, ShippingIcon, ShippingLabelIcon, ShippingPackIcon, ShippingSendIcon, ShowAltIcon, SortAscendingAltIcon, SortDescendingAltIcon, SpecialFinancingIcon, SplitBillIcon, StarAltIcon, StoreIcon, SubtractIcon, SupportIcon, ThemeIcon, TipJarIcon, ToolsIcon, TransferIcon, TransferMoneyIcon, TrashAltIcon, TrashIcon, UnlockAltIcon, UploadIcon, UserAddIcon, UserIcon, V2AccountbenefitsIcon, V2AcornsIcon, V2ActivityIcon, V2AddCashIcon, V2AddIcon, V2AddImageIcon, V2AddUserIcon, V2ArrowDownSmIcon, V2ArrowLeftIcon, V2ArrowRightIcon, V2ArrowUpSmIcon, V2AttachIcon, V2AutoIcon, V2BankIcon, V2BigPurchaseIcon, V2BillPaymentIcon, V2CalculatorIcon, V2CalendarIcon, V2CalendarPausedIcon, V2CameraAddIcon, V2CameraIcon, V2CashIcon, V2CausesIcon, V2ChatIcon, V2CheckCaptureIcon, V2CheckIcon, V2CheckmarkBackgroundIcon, V2CheckmarkBackgroundSmIcon, V2CheckmarkIcon, V2CheckmarkSmIcon, V2ChevronDownIcon, V2ChevronLeftIcon, V2ChevronRightIcon, V2ChevronUpIcon, V2ClockIcon, V2CloseIcon, V2CloseSmIcon, V2CodeIcon, V2CommunityIcon, V2ContactUsIcon, V2CopyIcon, V2CreditcardIcon, V2CriticalIcon, V2CriticalSmIcon, V2CryptoIcon, V2CurrencyChfIcon, V2CurrencyDollarIcon, V2CurrencyEuroIcon, V2CurrencyPoundIcon, V2CurrencyRupeeIcon, V2CurrencyYenIcon, V2DashboardIcon, V2DataprivacyIcon, V2DealsIcon, V2DeleteIcon, V2DesktopIcon, V2DirectdepositIcon, V2DownloadIcon, V2EditIcon, V2EducationIcon, V2EmojiIcon, V2FaceIdIcon, V2FaqIcon, V2FavoriteIcon, V2FavoriteSelectedIcon, V2FilterIcon, V2FingerprintIcon, V2FlagIcon, V2FoodIcon, V2GoalsIcon, V2GoldIcon, V2HelpIcon, V2HideIcon, V2HomeGoalsIcon, V2HomeIcon, V2HoneyIcon, V2ImageBrokenIcon, V2ImageIcon, V2InformationIcon, V2InformationSmIcon, V2InsightsIcon, V2InvestIcon, V2InvoiceIcon, V2LaptopIcon, V2LightBulbIcon, V2LinkIcon, V2ListDetailedIcon, V2ListSimpleIcon, V2LocationIcon, V2LockIcon, V2LogoutIcon, V2LoyaltycardIcon, V2MailIcon, V2MenuIcon, V2MerchantIcon, V2MessageCenterIcon, V2MgmIcon, V2MicrophoneIcon, V2NoiconIcon, V2NotificationIcon, V2NotificationpreferencesIcon, V2NumberPadIcon, V2OccasionIcon, V2OrderAheadIcon, V2OverflowIcon, V2PackageSizeIcon, V2PaymentshubIcon, V2PaypalIcon, V2PendingPausedIcon, V2PersonalinfoIcon, V2Phone2Icon, V2PhoneIcon, V2PlayIcon, V2PpCashCardIcon, V2PreferredFilledIcon, V2PreferredIcon, V2PrintIcon, V2ProfileIcon, V2PurchaseProtectionIcon, V2QrcIcon, V2QuestionIcon, V2QuestionSmIcon, V2RainyDayIcon, V2RecurrentIcon, V2RecurringPausedIcon, V2RefreshIcon, V2RefundIcon, V2RentIcon, V2RequestIcon, V2ResolutionIcon, V2RetirementIcon, V2ReturnsIcon, V2RocketIcon, V2SavingsIcon, V2ScanBarcodeIcon, V2SearchIcon, V2SecurityFilledIcon, V2SecurityPatternIcon, V2SendIcon, V2SettingsIcon, V2ShareFacebookIcon, V2ShareIcon, V2ShareInstagramIcon, V2ShareLineIcon, V2ShareLinkedinIcon, V2ShareMessengerIcon, V2ShareSnapchatIcon, V2ShareTwitterIcon, V2ShareWechatIcon, V2ShareWhatsappIcon, V2ShippingIcon, V2ShippingLabelIcon, V2ShippingPackIcon, V2ShippingSendIcon, V2ShoppingBasketIcon, V2ShoppingcartIcon, V2SkipIcon, V2SplitBillIcon, V2SubtractIcon, V2SwitchcardIcon, V2TipJarIcon, V2ToolsIcon, V2TopUpIcon, V2TrackIcon, V2TransferIcon, V2TransferVerticalIcon, V2TravelIcon, V2TreatYourselfIcon, V2TrophyIcon, V2TuitionIcon, V2UnlockIcon, V2UploadIcon, V2VacationIcon, V2VerifiedIcon, V2ViewIcon, V2VoucherIcon, V2WalletIcon, V2WandIcon, V2WarningIcon, V2WarningSmIcon, V2WebsiteIcon, V2WithdrawCashIcon, VerifiedAltIcon, WalletIcon, WarningAltIcon, WarningIcon, WithdrawCashIcon, WorkingCapitalIcon, WorldIcon };
